webpackJsonp([1],{

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return service; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commTools_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_uploadifive_jquery_uploadifive_js__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_uploadifive_jquery_uploadifive_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__libs_uploadifive_jquery_uploadifive_js__);





var API = __WEBPACK_IMPORTED_MODULE_1__util_js__["a" /* util */].api(["IMPROPERCREATEORDER", "SINGLECREATEORDER", "UPLOAD"]);

var temp = {
  creatOrder: "<div class=\"create_order\" id=\"creatOrder\">\n\t\t\t\t\t<i class=\"close\" onclick=\"$.modal('close')\"></i>\n\t\t\t\t    <form id=\"order-form\">\n\t\t\t\t        <p class=\"title\">\u65B0\u5EFA\u8BA2\u5355</p>\n\t\t\t\t        <div class=\"section1\">\n\t\t\t\t            <span class=\"state upload-tip\">\u672A\u4E0A\u4F20</span>\n\t\t\t\t            <span style=\"display:none\">\n\t\t\t\t            \t<span id=\"order-upload-obj\"></span>\n\t\t\t\t            </span>\n\t\t\t\t            <input name=\"auditionIds\" check=\"require\" style=\"display:none\"/>\n\t\t\t\t            <button type=\"button\" class=\"upload\" id=\"order-upload-btn\">\u4E0A\u4F20\u7A3F\u4EF6</button>\n\t\t\t\t            <span style=\"font-size: 12px; color: #9b9b9b;\">\u5982\u9700\u5E2E\u52A9\uFF0C</span>\n\t\t\t\t            <div class=\"contact kf_btn right\">\n\t\t\t\t                <span>\u8054\u7CFB\u5BA2\u670D</span>\n\t\t\t\t                <div class=\"kf_list_wrap\">\n\t\t\t\t                    <div class=\"kf_list\">\n\t\t\t\t                        <div class=\"arrow_top\">\n\t\t\t\t                            <div class=\"arrow_inner\"></div>\n\t\t\t\t                        </div>\n\t\t\t\t                        <ul>\n\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t                        </ul>\n\t\t\t\t                    </div>\n\t\t\t\t                </div>\n\t\t\t\t            </div>\n\t\t\t\t\t\t\t\t\t\t<span class=\"title__qq\">QQ:1123662664</span>\n\t\t\t\t             <p class=\"remind\">\u4FDD\u5BC6\u8BA2\u5355\u65E0\u9700\u4E0A\u4F20\u7A3F\u4EF6,\u8BF7\u9009\u62E9<span>\u4FDD\u5BC6\u8BA2\u5355</span></p>\n\t\t\t\t        </div>\n\t\t\t\t        <div class=\"section2\">\n\t\t\t\t            <p class=\"label\">\u8BF7\u8F93\u5165\u60A8\u7684\u7A3F\u4EF6\u540D\u79F0</p> \n                            <span class=\"error\" data-error=\"\u8BF7\u586B\u5199\u7A3F\u4EF6\u540D\u79F0\"></span>\n\t\t\t\t            <input type=\"text\" name=\"contributionName\">\n\t\t\t\t        </div>\n\t\t\t\t        <div class=\"section3\">\n\t\t\t\t            <p class=\"label\">\u8BA2\u5355\u9700\u6C42</p> <span class=\"error\" data-error=\"\u8BF7\u586B\u5199\u8BA2\u5355\u9700\u6C42\"></span>\n\t\t\t\t            <textarea name=\"requirementInfo\" placeholder=\"\u8BF7\u7B80\u8981\u63CF\u8FF0\u60A8\u7684\u9700\u6C42\u4FE1\u606F\"></textarea>\n\t\t\t\t        </div>\n\t\t\t\t        <div class=\"section4\">\n\t\t\t\t            <span>\u7D27\u6025\u72B6\u6001\uFF1A</span>\n\t\t\t\t            <select name=\"pressingStatus\">\n\t\t\t\t                <option value=\"1\">\u4F4E</option>\n\t\t\t\t                <option value=\"2\">\u4E2D</option>\n\t\t\t\t                <option value=\"3\">\u9AD8</option>\n\t\t\t\t            </select>\n\t\t\t\t        </div>\n\t\t\t\t        <div class=\"section5\">\n\t\t\t\t            <ul>\n\t\t\t\t                <li><button type=\"button\"  class=\"order-normal-btn\">\u521B\u5EFA\u8BA2\u5355</button></li>\n\t\t\t\t                <li><button type=\"button\"  class=\"order-special-btn\">\u521B\u5EFA\u4FDD\u5BC6\u8BA2\u5355</button></li>\n\t\t\t\t                <li><button type=\"button\"  class=\"order-back\" onclick=\"$.modal('close')\">\u8FD4\u56DE\u8BA2\u5355</button></li>\n\t\t\t\t            </ul>\n\t\t\t\t        </div>\n\t\t\t\t    </form>\n\t\t\t\t</div>"
};

var check = {
  auditionIds: function auditionIds(dom) {
    dom = dom || __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#order-form").find("[name=auditionIds]");

    if (!dom.val()) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".upload-tip").css("color", "red");
      return false;
    } else {
      return true;
    }
  },
  contributionName: function contributionName(dom) {
    dom = dom || __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#order-form").find("[name=contributionName]");
    var err = dom.siblings("[data-error]");
    if (!dom.val()) {
      err.show().text(err.data("error"));
      err.siblings("input").addClass("error");
      return false;
    } else {
      dom.siblings("[data-error]").hide();
      err.siblings("input").removeClass("error");
      return true;
    }
  },
  requirementInfo: function requirementInfo(dom) {
    dom = dom || __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#order-form").find("[name=requirementInfo]");
    var err = dom.siblings("[data-error]");

    if (!dom.val()) {
      err.show().text(err.data("error"));
      err.siblings("textarea").addClass("error");
      return false;
    } else {
      err.siblings("textarea").removeClass("error");
      return true;
    }
  },
  pressingStatus: function pressingStatus(dom) {
    dom = dom || __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#order-form").find("[name=pressingStatus]");
    var err = dom.siblings("[data-error]");
    if (!dom.val()) {
      return false;
    } else {
      return true;
    }
  }
};

var fn = {
  _creatNormal: function _creatNormal(callback) {
    if (check.auditionIds() && check.contributionName() && check.requirementInfo() && check.pressingStatus()) {
      var param = {};
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#order-form").serializeArray().forEach(function (d, i) {
        param[d.name] = d.value;
      });
      __WEBPACK_IMPORTED_MODULE_1__util_js__["a" /* util */].kAjax(API.SINGLECREATEORDER, param, function (json) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal("close");
        __WEBPACK_IMPORTED_MODULE_1__util_js__["a" /* util */].confirm.success("创建订单成功！");
        callback();
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal("close");
        __WEBPACK_IMPORTED_MODULE_1__util_js__["a" /* util */].confirm.error(res.message);
      });
    }
  },
  _creatSpecial: function _creatSpecial(callback) {
    if (check.contributionName() && check.requirementInfo() && check.pressingStatus()) {
      var param = {};
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#order-form").serializeArray().forEach(function (d, i) {
        param[d.name] = d.value;
      });
      __WEBPACK_IMPORTED_MODULE_1__util_js__["a" /* util */].kAjax(API.IMPROPERCREATEORDER, param, function (json) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal("close");
        __WEBPACK_IMPORTED_MODULE_1__util_js__["a" /* util */].confirm.success("创建订单成功！");
        callback();
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal("close");
        __WEBPACK_IMPORTED_MODULE_1__util_js__["a" /* util */].confirm.error(res.message);
      });
    }
  }
};

var action = {
  creatOrder: function creatOrder(callback) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal("pop", temp.creatOrder);
    var wrap = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#creatOrder"),
        upload = wrap.find("#order-upload-btn"),
        upload_obj = wrap.find("#order-upload-obj"),
        uploadTip = wrap.find(".upload-tip"),
        auditionIds = wrap.find("[name=auditionIds]"),
        contributionName = wrap.find("[name=contributionName]"),
        requirementInfo = wrap.find("[name=requirementInfo]"),
        pressingStatus = wrap.find("[name=pressingStatus]"),
        normal = wrap.find(".order-normal-btn"),
        special = wrap.find(".order-special-btn");
    wrap.css("top", "15%");

    __WEBPACK_IMPORTED_MODULE_2__commTools_js__["a" /* commTools */].initUpload(upload_obj, {
      buttonText: "上传稿件",
      fileType: ".txt,.doc,.docx,.ppt,.pptx",
      uploadScript: API.UPLOAD + ";jsessionid=" + window.USERINFO.sessionId,
      onUploadComplete: function onUploadComplete(file, data) {
        var data = eval("(" + data + ")");
        if (data.status == 4) {
          var auth = __webpack_require__(89).auth;
          auth.pop_login();
        }

        auditionIds.val(data.data);
        uploadTip.text("已上传").css("color", "#2dbfee");

        contributionName.val(file.name);
        check.contributionName();
      }
    });

    upload.click(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#uploadifive-order-upload-obj").find("input:last").click();
    });
    var lock = false;

    normal.click(function () {
      if (!lock) {
        fn._creatNormal(callback);
        lock = true;
        setTimeout(function () {
          lock = false;
        }, 1000);
      }
    });
    special.click(function () {
      if (!lock) {
        fn._creatSpecial(callback);
        lock = true;
        setTimeout(function () {
          lock = false;
        }, 1000);
      }
    });
  }
};

__WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").on("focus", "form input, form textarea", function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).siblings("[data-error]").hide();
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()("body").on("blur", "form input, form textarea", function () {
  var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
  var name = $this.attr("name");
  check[name] && check[name]($this);
});

var service = action;
window.service = action;


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(755)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(841),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(759)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(851),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_soundmanager2__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_soundmanager2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_soundmanager2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_util__ = __webpack_require__(5);





var temp = '<div class="g-player" style="bottom:170px">\n                <div class="glp-normal show" style="transition: all 0.3s ease 0.5s; left: -670px">\n                \t<div class="glp-normal-left left">\n                \t\t<div class="g-play-btn-wrap left">\n                \t\t\t<a class="g-play-btn" href="javascript:;"></a>\n                \t\t</div>\n\t                \t<div class="g-radio-voice left">\n\t\t\t\t\t\t\t<a class="g-radio-horn">\n\t\t\t\t\t\t\t\t<div class="g-volume">\n\t\t\t\t\t\t\t\t<div class="volume-progressbar">\n\t\t\t\t\t\t\t\t\t<div class="volume-seekbar" style="height: 100.00%"></div>\n\t\t\t\t\t\t\t\t\t<div class="volume-playbar" style="height: 80.00%"></div>\n\t\t\t\t\t\t\t\t\t<div class="volume-space"></div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</a>\n\t                \t</div>\n\t                    <div class="left progress-bar">\n\t                        <marquee class="title g-player-info" scrollamount="2" onMouseOut="this.start()" onMouseOver="this.stop()">\u672A\u52A0\u8F7D</marquee>\n\t                        \n\t                        <span class="time sound_position">00:00</span>\n\t                        <div class="player_progressbar" title="\u70B9\u51FB\u64AD\u653E">\n\t                            <div class="player_seekbar" style="width: 100%;"></div>\n\t                            <div class="player_playbar" style="width: 00.00%;"></div>\n\t                        </div>\n\t                        <span class="time sound_duration j-sound_durationStr">00:00</span>\n\t                    </div>\n\t                    <div class="g-player-down left">\n\t                    \t<a href="javascript:;" target="_blank"></a>\n\t                    </div>\n\t                    <div class="g-player-share left">\n\t                    \t<a href="javascript:;"></a>\n\t                    </div>\n\t                    <div class="g-player-shareBox" style="display:none">\n          \t\t\t\t\t<a class="item lf" onclick="javascript:bShare.share(event,\'weixin\');return false;" title="\u5206\u4EAB\u81F3\u5FAE\u4FE1">\n                \t\t\t\t<i class="share-ic ic-weixin"></i>\n                \t\t\t\t\u5206\u4EAB\u81F3\u5FAE\u4FE1\n          \t\t\t\t\t</a>\n          \t\t\t\t\t<a class="item lf" onclick="javascript:bShare.share(event,\'sinaminiblog\');return false;" title="\u5206\u4EAB\u81F3\u65B0\u6D6A\u5FAE\u535A">\n\t\t\t\t                <i class="share-ic ic-weibo bshare-sinaminiblog"></i>\n\t\t\t\t                \u5206\u4EAB\u81F3\u65B0\u6D6A\u5FAE\u535A\n\t\t\t                </a>\n\t\t\t\t            <a class="item lf" onclick="javascript:bShare.share(event,\'qqim\');return false;" title="\u5206\u4EAB\u81F3QQ\u597D\u53CB">\n\t\t\t\t              <i class="share-ic ic-qq"></i>\n\t\t\t\t              \u5206\u4EAB\u81F3QQ\u597D\u53CB\n\t\t\t\t            </a>\n        \t\t\t\t</div>\n        \t\t\t\t<div class="g-player-list"></div>\n        \t\t\t\t<div class="g-player-listBox" style="display:none">\n        \t\t\t\t\t<div class="title">\u64AD\u653E\u5217\u8868<span class="icon_close">\xD7</span></div>\n        \t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n                \t</div>\n                    <div class=" left gnormal-btn-more">\n                    </div>\n                </div>\n                <!-- mini -->\n                <div class="glp-mini show" style="transition: all 0.3s ease 0.5s; left: 0px"">\n                    <div class="glp-panel">\n                        <img class="sound_face" src="/static/player_bga.jpg">\n                        <div class="g-masker"></div>\n                        <i class="btn-player ic playBtn" title="\u64AD\u653E"></i>\n                    </div>\n                    <div class="btn-more">\n                        <i class="ic ic-arrow"></i>\n                    </div>\n                    <i class="icon-playing"></i>\n                </div>\n            </div>';
var SERVER_PATH = __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].getOSS(),
    IMG_PATH = __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].imgPath('');

var API = __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].api(['ADDPLAYCOUNT', 'ADDDOWNLOADCOUNT']);
var audio = null;
var prog_len = null,
    prog_hei = null;
var player = {
	init: function init() {
		var t = {
			wrap: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".g-player"),

			playBtn: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".g-play-btn"),

			info: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".g-player-info"),

			curTime: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".time.sound_position"),

			totalTime: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".j-sound_durationStr"),

			progressBar: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".player_playbar"),

			mini: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".glp-mini"),
			miniBtn: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".btn-player"),

			normal: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".glp-normal"),

			shareBtn: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".g-player-share"),

			shareBox: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".g-player-shareBox"),

			listBtn: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".g-player-list"),

			listWrap: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".g-player-listBox")
		};
		prog_len = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.player_progressbar').width();
		prog_hei = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.volume-progressbar').height();
		__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(this, t);
	}
};

var gPlayer = {
	soundData: {},

	played: {},

	whileplaying: null,

	playList: [],
	playListIds: [],
	initPlayer: function initPlayer(soundData, withList) {
		var jq = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.sd-player');
		if (!jq.length) {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').append('<div class="sd-player"></div>');
			jq = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.sd-player');
		}

		jq.css({ 'position': 'absolute', 'z-index': 999 }).first().html(temp);
		player.init();

		this.soundData = soundData;

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".player_progressbar").click(function (e) {
			if (!audio.url) return;

			var percent = e.offsetX / (prog_len + 2);
			var position = audio.duration * percent;
			audio.setPosition(position);
			if (audio.playState != 1 || audio.paused) {
				gPlayer.gPlay();
			}

			updatePage();
		});

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".volume-progressbar").click(function (e) {
			if (!audio.url) return;
			var percent = 1.0 - e.offsetY / prog_hei;
			var volume = 100 * percent;
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.volume-playbar').css('height', volume + '%');
			audio.setVolume(volume);
		});

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.btn-player,.g-play-btn').click(function () {
			if (!audio.url) {
				return;
			}
			if (audio.playState === 0 || audio.paused === true) {
				gPlayer.gPlay();
			} else {
				gPlayer.gPause();
			}

			updatePage();
		});

		player.shareBtn.find('a').click(function () {
			if (player.shareBtn.hasClass('onclick')) {
				player.shareBtn.removeClass('onclick');
				player.shareBox.hide();
			} else {
				player.shareBtn.addClass('onclick');
				player.shareBox.show();
			}
		});
		var play_n = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".glp-normal"),
		    play_m = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".glp-mini");

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".gnormal-btn-more").click(function (e) {
			play_n.attr('style', 'transition: all 0.5s ease 0.0s; left: -670px;');
			play_m.attr('style', 'transition: all 0.5s ease 0.5s; left: 0px;');

			player.shareBtn.removeClass('onclick');
			player.shareBox.hide();
			player.listWrap.hide();
		});

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".btn-more").click(function (e) {
			play_n.attr('style', 'transition: all 0.5s ease 0.5s; left: 0px;');
			play_m.attr('style', 'transition: all 0.5s ease 0.0s; left: -170px;');
		});

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".glp-normal").mouseleave(function () {
			player.shareBtn.removeClass('onclick');
			player.shareBox.hide();
		});

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".g-player-down").click(function () {
			if (audio.id.substr(0, 1) != 'c' && audio.url) __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.ADDDOWNLOADCOUNT, { id: audio.id });
		});

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.icon_close').click(function () {
			player.listWrap.hide();
		});
		player.listBtn.click(function () {
			player.listWrap.toggle();

			gPlayer.updateListPosition();
		});
		soundManager.setup({
			useHighPerformance: true,
			useConsole: false,
			debugMode: false,
			onready: function onready() {
				audio = soundManager.createSound({
					id: 'audio',
					volume: 80,

					whileloading: function whileloading() {
						player.totalTime.text(formatMusicTime(audio.durationEstimate));
					},
					whileplaying: function whileplaying() {
						updateProg();
					},
					onload: function onload() {
						updateTotal();
					},
					onfinish: function onfinish() {
						var event;
						try {
							event = new Event('click');
						} catch (ex) {
							event = document.createEvent('MouseEvent');
							event.initEvent('click', true, false);
						}
						audio.stop();
						updateProg();
						updatePage();

						if (gPlayer.playList.length) {
							gPlayer.playNext();

							gPlayer.updateListPosition();
						}
					}
				});

				window.audio = audio;
			}
		});
		this.initStaticData();
	},

	initStaticData: function initStaticData() {
		var doms = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[sound-id]'),
		    data = {};
		__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each(doms, function (i, d) {
			var $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
			    id = $this.attr('sound-id');
			if (id) {
				data[id] = {
					id: $this.attr('sound-id'),
					audio: $this.attr('sound-url'),
					title: $this.attr('title'),
					img: $this.attr('sound-img'),
					dubbingName: $this.attr('dubber-name'),
					dubbingId: $this.attr('dubber-id')
				};
			}
		});

		doms.removeAttr('data-url');

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').on('click', '[sound-id] .sound-play', function () {
			gPlayer.gChange(this);
		});

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').on('click', '[sound-id] .sound-down', function () {
			gPlayer.gDownload(this);
		});

		__WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').on('click', '[sound-id] .sound-down-count', function () {
			gPlayer.gDownload(this, true);
		});
		__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(this.soundData, data, true);
	},
	isPlaying: function isPlaying() {
		return audio.url && !audio.paused;
	},
	gPlay: function gPlay() {
		if (audio) {
			audio.play();
		}
	},
	gPause: function gPause() {
		if (audio) {
			audio.pause();
		}
	},

	listPlay: function listPlay(el) {
		var $el,
		    $items,
		    listData = [],
		    listIds = [],
		    tId = '';
		if (typeof el == 'string' || typeof el == 'number') {
			$el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[sound-id=' + el + ']');
		} else {
			$el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
		}
		if ($el.attr('sound-id')) {
			$items = $el.parent().children();
			tId = $el.attr('sound-id');
		} else {
			$el = $el.parents('[sound-id]:first');
			tId = $el.attr('[sound-id]');

			$items = $el.parent().children();
		}
		$items.each(function (i, d) {
			var id = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(d).attr('sound-id');
			if (!id) {
				return true;
			}
			gPlayer.soundData[id].id = id;
			listIds.push(id + '');
			listData.push(gPlayer.soundData[id]);
		});
		gPlayer.playList = listData;
		gPlayer.playListIds = listIds;
		gPlayer.playIndex = $el.index();
		gPlayer.updateListView();
	},

	updateListView: function updateListView() {
		var temp = '';
		__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each(this.playList, function (i, d) {
			temp += '<li sound-id="' + d.id + '"><button class="sound-play"></button><a href="' + (d.dubbingId ? '/n/' + d.dubbingId + '/' + d.id + '.html' : 'javascript:;') + '" target="_blank" class="title_voice left">' + d.title + '</a> <a href="' + (d.dubbingId ? '/n/' + d.dubbingId + '.html' : 'javascript:;') + '" target="_blank" class="name_teacher right">' + (d.dubbingName || '') + '</a></li>';
		});
		player.listWrap.find('ul').replace(temp);
	},

	updateListPosition: function updateListPosition() {
		var item = player.listWrap.find('[sound-id=' + audio.id + ']'),
		    index = item.index(),
		    y = 54 * index - 120;
		player.listWrap.find('ul').animate({ scrollTop: y }, 500);
	},

	playNext: function playNext() {
		var item = this.playList[this.playIndex + 1];
		if (item) {
			this.playIndex++;

			this.gChange(player.listWrap.find('[sound-id=' + item.id + ']:first'));
		} else {
			console.warn('未找到index=' + (this.playIndex + 1) + '的声音数据！');
		}
	},

	playPre: function playPre() {
		var item = this.playList[this.playIndex - 1];
		if (item) {
			this.playIndex--;

			this.gChange(player.listWrap.find('[sound-id=' + item.id + ']:first'));
		} else {
			console.warn('未找到index=' + (this.playIndex - 1) + '的声音数据！');
		}
	},

	gChange: function gChange(_id) {
		gPlayer.listPlay(_id);

		var id = _id;
		if ((typeof _id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_id)) == 'object') {
			var $jq = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(_id);
			id = $jq.attr('sound-id') || $jq.parents('[sound-id]:first').attr('sound-id');
		}
		var data = this.soundData[id];
		if (!data) {
			console.log(this.soundData);
			console.log('error - 未找到声音id:' + id);
			return;
		}
		var _url = data.audio;;

		if (audio.id && audio.id == id) {
			if (!audio.playState) {
				this.gPlay();
			} else if (!audio.paused) {
				this.gPause();
			} else {
				this.gPlay();
			}
			updatePage(id);
			return;
		}

		_url = _url && _url.substr(0, 4) == 'http' ? _url : SERVER_PATH + _url;

		if (!_url) {
			return;
		}

		audio.stop();

		audio.id = id;

		audio.url = _url;

		gPlayer.gPlay();

		updatePage(id);
		if (!this.firstTry) {
			this.firstTry = true;
			openPlayer();
		}
	},

	gDownload: function gDownload(id, count) {
		var _id = '';
		if ((typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(id)) == 'object') {
			_id = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(id).itemId('sound-id');
		} else {
			_id = id;
		}

		var data = gPlayer.soundData[_id];
		if (data) {
			if (!count) {
				var isFox = navigator.userAgent.toUpperCase().indexOf("FIREFOX") != -1;
				if (isFox) {
					window.location = SERVER_PATH + data.audio;
				} else {
					var link = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<a href="' + SERVER_PATH + data.audio + '" download="down"></a>');
					link[0].click();
					if (typeof window.location == 'string') {
						window.location = SERVER_PATH + data.audio;
					}
				}
			}
			__WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].downCount(_id);
		}
	}
};

function updatePage(id) {
	var id = id || audio.id;
	var data = gPlayer.soundData[id],
	    img = data.img,
	    title = data.title,
	    t = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.title.g-player-info');

	__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.is-play').removeClass('is-play');
	var item = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[sound-id=' + audio.id + ']');
	var paused = audio.paused;

	if (!paused && audio.playState) {
		player.wrap.addClass('is-play');

		title && title != t.text() && t.replaceWith('<marquee class="title g-player-info" scrollamount="2"  onMouseOut="this.start()" onMouseOver="this.stop()">' + title + '</marquee>');

		img && player.mini.find('.sound_face').attr('src', img.substr(0, 4) == 'http' ? img : IMG_PATH + img);

		item.addClass('is-play');
	} else {
		player.wrap.removeClass('is-play');

		title && title != t.text() && __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.title.g-player-info').replaceWith('<marquee class="title g-player-info" scrollamount="2"  onMouseOut="this.start()" onMouseOver="this.stop()">' + title + '</marquee>');
	}

	__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.g-player-down a').attr('href', audio.url).attr('download', title);

	if (!gPlayer.played[id] && id.substr(0, 1) != 'c') {
		gPlayer.played[id] = true;
		__WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.ADDPLAYCOUNT, { id: id });
	}
}

function openPlayer() {
	__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".btn-more").click();
}

function closePlayer() {
	__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".gnormal-btn-more").click();
}

function updateProg() {

	var percent = audio.position * 100 / audio.duration;
	player.curTime.text(formatMusicTime(audio.position));
	player.progressBar.css('width', percent + '%');

	typeof gPlayer.whileplaying == 'function' && gPlayer.whileplaying(percent, audio.id);
}

function updateTotal() {
	player.totalTime.text(formatMusicTime(audio.duration));
}

function formatMusicTime(milliseconds) {
	var hours = Math.floor(milliseconds / 3600000);
	milliseconds = milliseconds % 3600000;
	var minutes = Math.floor(milliseconds / 60000);
	milliseconds = milliseconds % 60000;
	var seconds = Math.floor(milliseconds / 1000);
	milliseconds = Math.floor(milliseconds % 1000);

	return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
}
window.gPlayer = gPlayer;


/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commTools; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


var fn = {
	initUpload: function initUpload(dom, opt) {
		var def = {
			'width': 80,
			'height': 30,
			'buttonText': '上传',
			'auto': true,
			'multi': false,
			'fileType': '.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.pdf,.mp3',
			'fileTypeExts': '',
			'fileTypeDesc': '',
			'queueSizeLimit': 1,
			'fileSizeLimit': 50000,
			'removeCompleted': true
		};
		dom.uploadifive(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(def, opt || {}));
	}
};

var commTools = fn;


/***/ }),

/***/ 387:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTMyIDc5LjE1OTI4NCwgMjAxNi8wNC8xOS0xMzoxMzo0MCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjY4OEE5NkM3OUEzMTFFN0FCQjhCQzk1Nzk1MkVBMTAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjY4OEE5NkQ3OUEzMTFFN0FCQjhCQzk1Nzk1MkVBMTAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGNjg4QTk2QTc5QTMxMUU3QUJCOEJDOTU3OTUyRUExMCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGNjg4QTk2Qjc5QTMxMUU3QUJCOEJDOTU3OTUyRUExMCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pg+xf4MAAABCSURBVHjaYmBgYKhlwA18QMRyID6HRbIciG/DONOA+DSa5CMg5mFEEpwCxDJAfByIk4BYH4h/oBvbBsT3kAUAAgwAJ/MKvPT9adwAAAAASUVORK5CYII="

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(767)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(864),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(769)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(868),
  /* scopeId */
  "data-v-8684f436",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(764)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(859),
  /* scopeId */
  "data-v-49182ec4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(761)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(854),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);


function hasClass(obj, cls) {
  return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

var fn = {
  linkQq: {
    bind: function bind(el, binding, vnode) {
      var qqNum = binding.expression || '2851207386',
          link = 'mqqwpa://im/chat?chat_type=wpa&uin=' + qqNum + '&version=1&src_type=web&web_src=oicqzone.com';
      if (el.localName == 'a') {
        el.href = link;
        el.target = '_blank';
      } else {
        el.addEventListener('click', function () {
          window.open(link);
        });
      }
    }
  },
  playerAnimate: {
    bind: function bind(el, binding, vnode) {
      var timer = void 0,
          interval = 2500;
      el.addEventListener('click', function () {
        timer && clearTimeout(timer);
        timer = setTimeout(function () {
          if (hasClass(el, 'on')) {
            var reg = new RegExp('(\\s|^)' + 'on' + '(\\s|$)');
            el.className = el.className.replace(reg, ' ');
          }
        }, interval);
      });
    }
  },
  jqTips: {
    bind: function bind(el, binding, vnode) {
      var $el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
      $el.data('tips', binding.value || '');
      $el.hover(function () {
        var str = $el.data('tips');
        str && $el.tips(str);
      }, function () {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.tips();
      });
    },
    componentUpdated: function componentUpdated(el, binding, vnode) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).data('tips', binding.value);
    }
  },

  interval: {
    bind: function bind(el, binding, vnode) {
      var interval = binding.expression || 1000,
          lock = false,
          $el = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
      el.addEventListener('click', function () {
        $el.css('pointer-events', 'none');
        setTimeout(function () {
          $el.css('pointer-events', '');
        }, interval);
      });
    }
  },

  clickoutside: {
    bind: function bind(el, binding, vnode) {
      el.externalClick = function (event) {
        if (event.target !== el && !el.contains(event.target)) {
          binding.value && binding.value();
        }
      };
      document.body.addEventListener('click', el.externalClick);
    },
    unbind: function unbind(el) {
      document.body.removeEventListener('click', el.externalClick);
    }
  }
};

for (var key in fn) {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive(key, fn[key]);
}

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);





__WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_date_picker___default.a);

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);






var sex = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('sex', function (value) {
    if (value == 1) {
        return '男';
    } else {
        return '女';
    }
});
var price = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('price', function (value) {
    var result = value <= 0 && "暂无报价" || value >= 10000 && '联系客服' || value;
    return result;
});
var imgPath = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('imgPath', function (value) {
    return __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].imgPath(value);
});
var preImgPath = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('preImgPath', function (value) {
    return __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].preImgPath(value);
});

var adPrice = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('adPrice', function (value) {
    var res = '';
    if (!value) {
        res = '暂无报价';
    } else if (value == 10000) {
        res = '联系客服';
    } else {
        res = '广告' + value + '元/30秒';
    }
    return res;
});

var minPrice = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('minPrice', function (value) {
    var res = '';
    if (!value) {
        res = '暂无报价';
    } else if (value == 10000) {
        res = '联系客服';
    } else {
        res = '专题' + value + '元/分';
    }
    return res;
});

var toBigCount = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('toBigCount', function (value) {
    var value = parseInt(value) || 0;
    if (value > 1000) {
        return (value / 10000).toFixed(1) + '万';
    }
    return value;
});

var time = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('time', function (value, fmt) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format(fmt || 'YYYY.MM.DD');
});
var time2 = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('time2', function (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('YYYY-MM-DD HH:mm:ss');
});

var way = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('way', function (value) {
    if (value == 1) {
        return '线下';
    } else if (value == 2) {
        return '线上';
    }
});

var invoiceType = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('invoiceType', function (value) {
    if (value == 1) {
        return '增值税普通发票';
    } else if (value == 2) {
        return '增值税专用发票';
    }
});

var invoiceStatus = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('invoiceStatus', function (value) {
    if (value == 1) {
        return '未开发票';
    } else if (value == 2) {
        return '已开发票';
    }
});
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('toString', function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
    }
    return '';
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter('OSS', function (value) {
    return __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].getOSS() + value;
});

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_BaseView__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_BaseView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_BaseView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_OrderView__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_OrderView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_OrderView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_CollectView__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_CollectView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_CollectView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_AddressView__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_AddressView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_AddressView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_PayView__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_PayView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_PayView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_InvoiceView__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_InvoiceView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_InvoiceView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_PaySuccessView__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_PaySuccessView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_PaySuccessView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_CouponView__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_CouponView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_CouponView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_InfoView__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_InfoView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_InfoView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_MyInvoiceView__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_MyInvoiceView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_MyInvoiceView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_RechargeView__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_RechargeView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_RechargeView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_ChargeRecord__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_ChargeRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_ChargeRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_PayRecord__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_PayRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_PayRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_WithdrawRecord__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_WithdrawRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_WithdrawRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_ResetView__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_ResetView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_ResetView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_MessageView__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_MessageView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_MessageView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_HomeView__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_HomeView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_HomeView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_EnterpriseView__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_EnterpriseView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_EnterpriseView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_IdentityView__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_IdentityView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_IdentityView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_RebateIntro__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_RebateIntro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_RebateIntro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_RecommendStat__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_RecommendStat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_RecommendStat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_RebateStat__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_RebateStat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_RebateStat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_DiscussView__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_DiscussView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_DiscussView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_withinOrders__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_withinOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__views_withinOrders__);






























__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var config = {
  routes: [{
    path: "/",
    redirect: "/pages/"
  }, {
    path: "/pages",
    component: __WEBPACK_IMPORTED_MODULE_2__views_BaseView___default.a,
    children: [{
      path: "",
      redirect: "/pages/home"
    }, {
      path: "home",
      name: "HomeView",
      component: __WEBPACK_IMPORTED_MODULE_18__views_HomeView___default.a
    }, {
      path: "collect",
      name: "CollectView",
      component: __WEBPACK_IMPORTED_MODULE_4__views_CollectView___default.a
    }, {
      path: "address",
      name: "AddressView",
      component: __WEBPACK_IMPORTED_MODULE_5__views_AddressView___default.a
    }, {
      path: "order",
      name: "OrderView",
      component: __WEBPACK_IMPORTED_MODULE_3__views_OrderView___default.a
    }, {
      path: "coupon",
      name: "CouponView",
      component: __WEBPACK_IMPORTED_MODULE_9__views_CouponView___default.a
    }, {
      path: "info",
      name: "InfoView",
      component: __WEBPACK_IMPORTED_MODULE_10__views_InfoView___default.a
    }, {
      path: "myInvoice",
      name: "MyInvoiceView",
      component: __WEBPACK_IMPORTED_MODULE_11__views_MyInvoiceView___default.a
    }, {
      path: "chargeRecord",
      name: "ChargeRecord",
      component: __WEBPACK_IMPORTED_MODULE_13__views_ChargeRecord___default.a
    }, {
      path: "payRecord",
      name: "PayRecord",
      component: __WEBPACK_IMPORTED_MODULE_14__views_PayRecord___default.a
    }, {
      path: "withdrawRecord",
      name: "WithdrawRecord",
      component: __WEBPACK_IMPORTED_MODULE_15__views_WithdrawRecord___default.a
    }, {
      path: "reset",
      name: "ResetView",
      component: __WEBPACK_IMPORTED_MODULE_16__views_ResetView___default.a
    }, {
      path: "recharge",
      name: "RechargeView",
      component: __WEBPACK_IMPORTED_MODULE_12__views_RechargeView___default.a
    }, {
      path: "message",
      name: "MessageView",
      component: __WEBPACK_IMPORTED_MODULE_17__views_MessageView___default.a
    }, {
      path: "enterprise",
      name: "EnterpriseView",
      component: __WEBPACK_IMPORTED_MODULE_19__views_EnterpriseView___default.a
    }, {
      path: "identity",
      name: "IdentityView",
      component: __WEBPACK_IMPORTED_MODULE_20__views_IdentityView___default.a
    }, {
      path: "rebateIntro",
      name: "RebateIntro",
      component: __WEBPACK_IMPORTED_MODULE_21__views_RebateIntro___default.a
    }, {
      path: "recommend",
      name: "RecommendStat",
      component: __WEBPACK_IMPORTED_MODULE_22__views_RecommendStat___default.a
    }, {
      path: "rebate",
      name: "RebateStat",
      component: __WEBPACK_IMPORTED_MODULE_23__views_RebateStat___default.a
    }, {
      path: "discuss",
      name: "Discuss",
      component: __WEBPACK_IMPORTED_MODULE_24__views_DiscussView___default.a
    }]
  }, {
    path: "/pay",
    name: "PayView",
    component: __WEBPACK_IMPORTED_MODULE_6__views_PayView___default.a
  }, {
    path: "/invoice",
    name: "InvoiceView",
    component: __WEBPACK_IMPORTED_MODULE_7__views_InvoiceView___default.a
  }, {
    path: "/success",
    name: "PaySuccessView",
    component: __WEBPACK_IMPORTED_MODULE_8__views_PaySuccessView___default.a
  }, {
    path: "/withinOrders",
    name: "WithinOrders",
    component: __WEBPACK_IMPORTED_MODULE_25__views_withinOrders___default.a
  }, {
    path: "*",
    redirect: "/pages/"
  }]
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */](config);

window.$pageCount = -1;
router.beforeEach(function (to, from, next) {
  window.$pageCount++;
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_zh_CN__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(814);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({
    locale: 'zh_CN'
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */], {
    i18n: i18n,
    i18nRootKey: 'validation',
    dictionary: {
        zh_CN: __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_zh_CN___default.a
    }
});

var dictionary = {
    zh_CN: {
        messages: {
            email: function email() {
                return '请输入正确的邮箱格式';
            },
            required: function required(field) {
                return '此项不能为空';
            }
        },
        attributes: {
            email: '邮箱',
            password: '密码',
            name: '账号',
            phone: '手机'
        }
    }
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* Validator */].localize(dictionary);
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* Validator */].extend('idcard', {
    getMessage: function getMessage(field, args) {
        return '请输入正确的身份证号码';
    },
    validate: function validate(value) {
        return value.length == 18 && /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value);
    }
});
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* Validator */]);

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_common__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_player__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  modules: {
    common: __WEBPACK_IMPORTED_MODULE_2__modules_common__["a" /* default */],
    player: __WEBPACK_IMPORTED_MODULE_3__modules_player__["a" /* default */]
  }
}));

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(765)
__webpack_require__(766)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(862),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 400:
/***/ (function(module, exports) {

/*
UploadiFive 1.2.2
Copyright (c) 2012 Reactive Apps, Ronnie Garcia
Released under the UploadiFive Standard License <http://www.uploadify.com/uploadifive-standard-license>
*/
;(function($,file,input,limit,_file,xhr,existingFile) {

    var methods = {

        init : function(options) {
            
            return this.each(function() {

                // Create a reference to the jQuery DOM object
                var $this = $(this);
                    $this.data('uploadifive', {
                        inputs     : {}, // The object that contains all the file inputs
                        inputCount : 0,  // The total number of file inputs created
                        fileID     : 0,
                        queue      : {
                                         count      : 0, // Total number of files in the queue
                                         selected   : 0, // Number of files selected in the last select operation
                                         replaced   : 0, // Number of files replaced in the last select operation
                                         errors     : 0, // Number of files that returned an error in the last select operation
                                         queued     : 0, // Number of files added to the queue in the last select operation
                                         cancelled  : 0  // Total number of files that have been cancelled or removed from the queue
                                     },
                        uploads    : {
                                         current    : 0, // Number of files currently being uploaded
                                         attempts   : 0, // Number of file uploads attempted in the last upload operation
                                         successful : 0, // Number of files successfully uploaded in the last upload operation
                                         errors     : 0, // Number of files returning errors in the last upload operation
                                         count      : 0  // Total number of files uploaded successfully
                                     }
                    });
                var $data = $this.data('uploadifive');

                // Set the default options
                var settings = $data.settings = $.extend({
                    'auto'            : true,               // Automatically upload a file when it's added to the queue
                    'buttonClass'     : false,              // A class to add to the UploadiFive button
                    'buttonText'      : 'Select Files',     // The text that appears on the UploadiFive button
                    'checkScript'     : false,              // Path to the script that checks for existing file names 
                    'dnd'             : true,               // Allow drag and drop into the queue
                    'dropTarget'      : false,              // Selector for the drop target
                    'fileObjName'     : 'Filedata',         // The name of the file object to use in your server-side script
                    'fileSizeLimit'   : 0,                  // Maximum allowed size of files to upload
                    'fileType'        : false,              // Type of files allowed (image, etc), separate with a pipe character |
                    'formData'        : {},                 // Additional data to send to the upload script
                    'height'          : 30,                 // The height of the button
                    'itemTemplate'    : false,              // The HTML markup for the item in the queue
                    'method'          : 'post',             // The method to use when submitting the upload
                    'multi'           : true,               // Set to true to allow multiple file selections
                    'overrideEvents'  : [],                 // An array of events to override
                    'queueID'         : false,              // The ID of the file queue
                    'queueSizeLimit'  : 0,                  // The maximum number of files that can be in the queue
                    'removeCompleted' : false,              // Set to true to remove files that have completed uploading
                    'simUploadLimit'  : 0,                  // The maximum number of files to upload at once
                    'truncateLength'  : 0,                  // The length to truncate the file names to
                    'uploadLimit'     : 0,                  // The maximum number of files you can upload
                    'uploadScript'    : 'uploadifive.php',  // The path to the upload script
                    'width'           : 100                 // The width of the button

                    /*
                    // Events
                    'onAddQueueItem'   : function(file) {},                        // Triggered for each file that is added to the queue
                    'onCancel'         : function(file) {},                        // Triggered when a file is cancelled or removed from the queue
                    'onCheck'          : function(file, exists) {},                // Triggered when the server is checked for an existing file
                    'onClearQueue'     : function(queue) {},                       // Triggered during the clearQueue function
                    'onDestroy'        : function() {}                             // Triggered during the destroy function
                    'onDrop'           : function(files, numberOfFilesDropped) {}, // Triggered when files are dropped into the file queue
                    'onError'          : function(file, fileType, data) {},        // Triggered when an error occurs
                    'onFallback'       : function() {},                            // Triggered if the HTML5 File API is not supported by the browser
                    'onInit'           : function() {},                            // Triggered when UploadiFive if initialized
                    'onQueueComplete'  : function() {},                            // Triggered once when an upload queue is done
                    'onProgress'       : function(file, event) {},                 // Triggered during each progress update of an upload
                    'onSelect'         : function() {},                            // Triggered once when files are selected from a dialog box
                    'onUpload'         : function(file) {},                        // Triggered when an upload queue is started
                    'onUploadComplete' : function(file, data) {},                  // Triggered when a file is successfully uploaded
                    'onUploadFile'     : function(file) {},                        // Triggered for each file being uploaded
                    */
                }, options);

                // Calculate the file size limit
                if (isNaN(settings.fileSizeLimit)) {
                    var fileSizeLimitBytes = parseInt(settings.fileSizeLimit) * 1.024
                    if (settings.fileSizeLimit.indexOf('KB') > -1) {
                        settings.fileSizeLimit = fileSizeLimitBytes * 1000;
                    } else if (settings.fileSizeLimit.indexOf('MB') > -1) {
                        settings.fileSizeLimit = fileSizeLimitBytes * 1000000;
                    } else if (settings.fileSizeLimit.indexOf('GB') > -1) {
                        settings.fileSizeLimit = fileSizeLimitBytes * 1000000000;
                    }
                } else {
                    settings.fileSizeLimit = settings.fileSizeLimit * 1024;
                }

                // Create a template for a file input
                $data.inputTemplate = $('<input type="file">')
                .css({
                    'font-size' : settings.height + 'px',
                    'opacity'   : 0,
                    'position'  : 'absolute',
                    'right'     : '-3px',
                    'top'       : '-3px',
                    'z-index'   : 999 
                });

                // Create a new input
                $data.createInput = function() {

                    // Create a clone of the file input
                    var input     = $data.inputTemplate.clone();
                    // Create a unique name for the input item
                    var inputName = input.name = 'input' + $data.inputCount++;
                    // Set the multiple attribute
                    if (settings.multi) {
                        input.attr('multiple', true);
                    }
                    // Set the accept attribute on the input
                    if (settings.fileType) {
                        input.attr('accept', settings.fileType);
                    }
                    // Set the onchange event for the input
                    input.bind('change', function() {
                        $data.queue.selected = 0;
                        $data.queue.replaced = 0;
                        $data.queue.errors   = 0;
                        $data.queue.queued   = 0;
                        // Add a queue item to the queue for each file
                        var limit = this.files.length;
                        $data.queue.selected = limit;
                        if (($data.queue.count + limit) > settings.queueSizeLimit && settings.queueSizeLimit !== 0) {
                            if ($.inArray('onError', settings.overrideEvents) < 0) {
                                alert('The maximum number of queue items has been reached (' + settings.queueSizeLimit + ').  Please select fewer files.');
                            }
                            // Trigger the error event
                            if (typeof settings.onError === 'function') {
                                settings.onError.call($this, 'QUEUE_LIMIT_EXCEEDED');
                            }
                        } else {
                            for (var n = 0; n < limit; n++) {
                                file = this.files[n];
                                $data.addQueueItem(file);
                            }
                            $data.inputs[inputName] = this;
                            $data.createInput();
                        }
                        // Upload the file if auto-uploads are enabled
                        if (settings.auto) {
                            methods.upload.call($this);
                        }
                        // Trigger the select event
                        if (typeof settings.onSelect === 'function') {
                            settings.onSelect.call($this, $data.queue);
                        }
                    });
                    // Hide the existing current item and add the new one
                    if ($data.currentInput) {
                        $data.currentInput.hide();
                    }
                    $data.button.append(input);
                    $data.currentInput = input;
                }

                // Remove an input
                $data.destroyInput = function(key) {
                    $($data.inputs[key]).remove();
                    delete $data.inputs[key];
                    $data.inputCount--;
                }

                // Drop a file into the queue
                $data.drop = function(e) {
                    $data.queue.selected = 0;
                    $data.queue.replaced = 0;
                    $data.queue.errors   = 0;
                    $data.queue.queued   = 0;

                    var fileData = e.dataTransfer;

                    var inputName = fileData.name = 'input' + $data.inputCount++;
                    // Add a queue item to the queue for each file
                    var limit = fileData.files.length;
                    $data.queue.selected = limit;
                    if (($data.queue.count + limit) > settings.queueSizeLimit && settings.queueSizeLimit !== 0) {
                        // Check if the queueSizeLimit was reached
                        if ($.inArray('onError', settings.overrideEvents) < 0) {
                            alert('The maximum number of queue items has been reached (' + settings.queueSizeLimit + ').  Please select fewer files.');
                        }
                        // Trigger the onError event
                        if (typeof settings.onError === 'function') {
                            settings.onError.call($this, 'QUEUE_LIMIT_EXCEEDED');
                        }
                    } else {
                        // Add a queue item for each file
                        for (var n = 0; n < limit; n++) {
                            file = fileData.files[n];
                            $data.addQueueItem(file);
                        }
                        // Save the data to the inputs object
                        $data.inputs[inputName] = fileData;
                    }

                    // Upload the file if auto-uploads are enabled
                    if (settings.auto) {
                        methods.upload.call($this);
                    }

                    // Trigger the onDrop event
                    if (typeof settings.onDrop === 'function') {
                        settings.onDrop.call($this, fileData.files, fileData.files.length);
                    }

                    // Stop FireFox from opening the dropped file(s)
                    e.preventDefault();
                    e.stopPropagation();
                }

                // Check if a filename exists in the queue
                $data.fileExistsInQueue = function(file) {
                    for (var key in $data.inputs) {
                        input = $data.inputs[key];
                        limit = input.files.length;
                        for (var n = 0; n < limit; n++) {
                            existingFile = input.files[n];
                            // Check if the filename matches
                            if (existingFile.name == file.name && !existingFile.complete) {
                                return true;
                            }
                        }
                    }
                    return false;
                }

                // Remove an existing file in the queue
                $data.removeExistingFile = function(file) {
                    for (var key in $data.inputs) {
                        input = $data.inputs[key];
                        limit = input.files.length;
                        for (var n = 0; n < limit; n++) {
                            existingFile = input.files[n];
                            // Check if the filename matches
                            if (existingFile.name == file.name && !existingFile.complete) {
                                $data.queue.replaced++;
                                methods.cancel.call($this, existingFile, true);
                            }
                        }
                    }
                }

                // Create the file item template
                if (settings.itemTemplate == false) {
                    $data.queueItem = $('<div class="uploadifive-queue-item">\
                        <a class="close" href="#">X</a>\
                        <div><span class="filename"></span><span class="fileinfo"></span></div>\
                        <div class="progress">\
                            <div class="progress-bar"></div>\
                        </div>\
                    </div>');
                } else {
                    $data.queueItem = $(settings.itemTemplate);
                }

                // Add an item to the queue
                $data.addQueueItem = function(file) {
                    if ($.inArray('onAddQueueItem', settings.overrideEvents) < 0) {
                        // Check if the filename already exists in the queue
                        $data.removeExistingFile(file);
                        // Create a clone of the queue item template
                        file.queueItem = $data.queueItem.clone();
                        // Add an ID to the queue item
                        file.queueItem.attr('id', settings.id + '-file-' + $data.fileID++);
                        // Bind the close event to the close button
                        file.queueItem.find('.close').bind('click', function() {
                           methods.cancel.call($this, file);
                           return false;
                        });
                        var fileName = file.name;
                        if (fileName.length > settings.truncateLength && settings.truncateLength != 0) {
                            fileName = fileName.substring(0, settings.truncateLength) + '...';
                        }
                        file.queueItem.find('.filename').html(fileName);
                        // Add a reference to the file
                        file.queueItem.data('file', file);
                        $data.queueEl.append(file.queueItem);
                    }
                    // Trigger the addQueueItem event
                    if (typeof settings.onAddQueueItem === 'function') {
                        settings.onAddQueueItem.call($this, file);
                    }
                    // Check the filesize
                    if (file.size > settings.fileSizeLimit && settings.fileSizeLimit != 0) {
                        $data.error('FILE_SIZE_LIMIT_EXCEEDED', file);
                    } else {
                        $data.queue.queued++;
                        $data.queue.count++;
                    }
                }

                // Remove an item from the queue
                $data.removeQueueItem = function(file, instant, delay) {
                    // Set the default delay
                    if (!delay) delay = 0;
                    var fadeTime = instant ? 0 : 500;
                    if (file.queueItem) {
                        if (file.queueItem.find('.fileinfo').html() != ' - Completed') {
                            file.queueItem.find('.fileinfo').html(' - Cancelled');
                        }
                        file.queueItem.find('.progress-bar').width(0);
                        file.queueItem.delay(delay).fadeOut(fadeTime, function() {
                           $(this).remove();
                        });
                        delete file.queueItem;
                        $data.queue.count--;
                    }
                }

                // Count the number of files that need to be uploaded
                $data.filesToUpload = function() {
                    var filesToUpload = 0;
                    for (var key in $data.inputs) {
                        input = $data.inputs[key];
                        limit = input.files.length;
                        for (var n = 0; n < limit; n++) {
                            file = input.files[n];
                            if (!file.skip && !file.complete) {
                                filesToUpload++;
                            }
                        }
                    }
                    return filesToUpload;
                }

                // Check if a file exists
                $data.checkExists = function(file) {
                    if ($.inArray('onCheck', settings.overrideEvents) < 0) {
                        // This request needs to be synchronous
                        $.ajaxSetup({
                            'async' : false
                        });
                        // Send the filename to the check script
                        var checkData = $.extend(settings.formData, {filename: file.name});
                        $.post(settings.checkScript, checkData, function(fileExists) {
                            file.exists = parseInt(fileExists);
                        });
                        if (file.exists) {
                            if (!confirm('A file named ' + file.name + ' already exists in the upload folder.\nWould you like to replace it?')) {
                                // If not replacing the file, cancel the upload
                                methods.cancel.call($this, file);
                                return true;
                            }
                        }
                    }
                    // Trigger the check event
                    if (typeof settings.onCheck === 'function') {
                        settings.onCheck.call($this, file, file.exists);
                    }
                    return false;
                }

                // Upload a single file
                $data.uploadFile = function(file, uploadAll) {
                    if (!file.skip && !file.complete && !file.uploading) {
                        file.uploading = true;
                        $data.uploads.current++;
                        $data.uploads.attempted++;

                        // Create a new AJAX request
                        xhr = file.xhr = new XMLHttpRequest();

                        // Start the upload
                        // Use the faster FormData if it exists
                        if (typeof FormData === 'function' || typeof FormData === 'object') {

                            // Create a new FormData object
                            var formData = new FormData();

                            // Add the form data
                            formData.append(settings.fileObjName, file);

                            // Add the rest of the formData
                            for (i in settings.formData) {
                                formData.append(i, settings.formData[i]);
                            }

                            // Open the AJAX call
                            xhr.open(settings.method, settings.uploadScript, true);

                            // On progress function
                            xhr.upload.addEventListener('progress', function(e) {
                                if (e.lengthComputable) {
                                    $data.progress(e, file);
                                }
                            }, false);

                            // On complete function
                            xhr.addEventListener('load', function(e) {
                                if (this.readyState == 4) {
                                    file.uploading = false;
                                    if (this.status == 200) {
                                        if (file.xhr.responseText !== 'Invalid file type.') {
                                            $data.uploadComplete(e, file, uploadAll);
                                        } else {
                                            $data.error(file.xhr.responseText, file, uploadAll);
                                        }
                                    } else if (this.status == 404) {
                                        $data.error('404_FILE_NOT_FOUND', file, uploadAll);
                                    } else if (this.status == 403) {
                                        $data.error('403_FORBIDDEN', file, uploadAll);
                                    } else {
                                        $data.error('Unknown Error', file, uploadAll);
                                    }
                                }
                            });

                            // Send the form data (multipart/form-data)
                            xhr.send(formData);

                        } else {

                            // Send as binary
                            var reader = new FileReader();
                            reader.onload = function(e) {

                                // Set some file builder variables
                                var boundary = '-------------------------' + (new Date).getTime(),
                                    dashes   = '--',
                                    eol      = '\r\n',
                                    binFile  = '';

                                // Build an RFC2388 String 
                                binFile += dashes + boundary + eol;
                                // Generate the headers
                                binFile += 'Content-Disposition: form-data; name="' + settings.fileObjName + '"';
                                if (file.name) {
                                    binFile += '; filename="' + file.name + '"';
                                }
                                binFile += eol;
                                binFile += 'Content-Type: application/octet-stream' + eol + eol;
                                binFile += e.target.result + eol;

                                for (key in settings.formData) {
                                    binFile += dashes + boundary + eol;
                                    binFile += 'Content-Disposition: form-data; name="' + key + '"' + eol + eol;
                                    binFile += settings.formData[key] + eol;
                                }

                                binFile += dashes + boundary + dashes + eol;

                                // On progress function
                                xhr.upload.addEventListener('progress', function(e) {
                                    $data.progress(e, file);
                                }, false);

                                // On complete function
                                xhr.addEventListener('load', function(e) {
                                    file.uploading = false;
                                    var status = this.status;
                                    if (status == 404) {
                                        $data.error('404_FILE_NOT_FOUND', file, uploadAll);
                                    } else {
                                        if (file.xhr.responseText != 'Invalid file type.') {    
                                            $data.uploadComplete(e, file, uploadAll);
                                        } else {
                                            $data.error(file.xhr.responseText, file, uploadAll);
                                        } 
                                    }
                                }, false);

                                // Open the ajax request
                                var url = settings.uploadScript;
                                if (settings.method == 'get') {
                                    var params = $(settings.formData).param();
                                    url += params;
                                }
                                xhr.open(settings.method, settings.uploadScript, true);
                                xhr.setRequestHeader("Content-Type", "multipart/form-data; boundary=" + boundary);

                                // Trigger the uploadFile event
                                if (typeof settings.onUploadFile === 'function') {
                                    settings.onUploadFile.call($this, file);
                                }

                                // Send the file for upload
                                xhr.sendAsBinary(binFile);
                            }
                            reader.readAsBinaryString(file);

                        }
                    }
                }

                // Update a file upload's progress
                $data.progress = function(e, file) {
                    if ($.inArray('onProgress', settings.overrideEvents) < 0) {
                        if (e.lengthComputable) {
                            var percent = Math.round((e.loaded / e.total) * 100);
                        }
                        file.queueItem.find('.fileinfo').html(' - ' + percent + '%');
                        file.queueItem.find('.progress-bar').css('width', percent + '%');
                    }
                    // Trigger the progress event
                    if (typeof settings.onProgress === 'function') {
                        settings.onProgress.call($this, file, e);
                    }
                }

                // Trigger an error
                $data.error = function(errorType, file, uploadAll) {
                    if ($.inArray('onError', settings.overrideEvents) < 0) {
                        // Get the error message
                        switch(errorType) {
                            case '404_FILE_NOT_FOUND':
                                errorMsg = '404 Error';
                                break;
                            case '403_FORBIDDEN':
                                errorMsg = '403 Forbidden';
                                break;
                            case 'FORBIDDEN_FILE_TYPE':
                                errorMsg = 'Forbidden File Type';
                                break;
                            case 'FILE_SIZE_LIMIT_EXCEEDED':
                                errorMsg = 'File Too Large';
                                break;
                            default:
                                errorMsg = 'Unknown Error';
                                break;
                        }

                        // Add the error class to the queue item
                        file.queueItem.addClass('error')
                        // Output the error in the queue item
                        .find('.fileinfo').html(' - ' + errorMsg);
                        // Hide the 
                        file.queueItem.find('.progress').remove();
                    }
                    // Trigger the error event
                    if (typeof settings.onError === 'function') {
                        settings.onError.call($this, errorType, file);
                    }
                    file.skip = true;
                    if (errorType == '404_FILE_NOT_FOUND') {
                        $data.uploads.errors++;
                    } else {
                        $data.queue.errors++;
                    }
                    if (uploadAll) {
                        methods.upload.call($this, null, true);
                    }
                }

                // Trigger when a single file upload is complete
                $data.uploadComplete = function(e, file, uploadAll) {
                    if ($.inArray('onUploadComplete', settings.overrideEvents) < 0) {
                        file.queueItem.find('.progress-bar').css('width', '100%');
                        file.queueItem.find('.fileinfo').html(' - Completed');
                        file.queueItem.find('.progress').slideUp(250);
                        file.queueItem.addClass('complete');
                    }
                    // Trigger the complete event
                    if (typeof settings.onUploadComplete === 'function') {
                        settings.onUploadComplete.call($this, file, file.xhr.responseText);
                    }
                    if (settings.removeCompleted) {
                        setTimeout(function() { methods.cancel.call($this, file); }, 3000);
                    }
                    file.complete = true;
                    $data.uploads.successful++;
                    $data.uploads.count++;
                    $data.uploads.current--;
                    delete file.xhr;
                    if (uploadAll) {
                        methods.upload.call($this, null, true);
                    }
                }

                // Trigger when all the files are done uploading
                $data.queueComplete = function() {
                    // Trigger the queueComplete event
                    if (typeof settings.onQueueComplete === 'function') {
                        settings.onQueueComplete.call($this, $data.uploads);
                    }
                }

                // ----------------------
                // Initialize UploadiFive
                // ----------------------

                // Check if HTML5 is available
                if (window.File && window.FileList && window.Blob && (window.FileReader || window.FormData)) {
                    // Assign an ID to the object
                    settings.id = 'uploadifive-' + $this.attr('id');

                    // Wrap the file input in a div with overflow set to hidden
                    $data.button = $('<div id="' + settings.id + '" class="uploadifive-button">' + settings.buttonText + '</div>');
                    if (settings.buttonClass) $data.button.addClass(settings.buttonClass);

                    // Style the button wrapper
                    $data.button.css({
                        'height'      : settings.height,
                        'line-height' : settings.height + 'px', 
                        'overflow'    : 'hidden',
                        'position'    : 'relative',
                        'text-align'  : 'center', 
                        'width'       : settings.width
                    });

                    // Insert the button above the file input
                    $this.before($data.button)
                    // Add the file input to the button
                    .appendTo($data.button)
                    // Modify the styles of the file input
                    .hide();

                    // Create a new input
                    $data.createInput.call($this);

                    // Create the queue container
                    if (!settings.queueID) {
                        settings.queueID = settings.id + '-queue';
                        $data.queueEl = $('<div id="' + settings.queueID + '" class="uploadifive-queue" />');
                        $data.button.after($data.queueEl);
                    } else {
                        $data.queueEl = $('#' + settings.queueID);
                    }

                    // Add drag and drop functionality
                    if (settings.dnd) {
                        var $dropTarget = settings.dropTarget ? $(settings.dropTarget) : $data.queueEl.get(0);
                        $dropTarget.addEventListener('dragleave', function(e) {
                            // Stop FireFox from opening the dropped file(s)
                            e.preventDefault();
                            e.stopPropagation();
                        }, false);
                        $dropTarget.addEventListener('dragenter', function(e) {
                            // Stop FireFox from opening the dropped file(s)
                            e.preventDefault();
                            e.stopPropagation();
                        }, false);
                        $dropTarget.addEventListener('dragover', function(e) {
                            // Stop FireFox from opening the dropped file(s)
                            e.preventDefault();
                            e.stopPropagation();
                        }, false);
                        $dropTarget.addEventListener('drop', $data.drop, false);
                    }

                    // Send as binary workaround for Chrome
                    if (!XMLHttpRequest.prototype.sendAsBinary) {
                        XMLHttpRequest.prototype.sendAsBinary = function(datastr) {
                            function byteValue(x) {
                                return x.charCodeAt(0) & 0xff;
                            }
                            var ords = Array.prototype.map.call(datastr, byteValue);
                            var ui8a = new Uint8Array(ords);
                            this.send(ui8a.buffer);
                        }
                    }

                    // Trigger the oninit event
                    if (typeof settings.onInit === 'function') {
                        settings.onInit.call($this);
                    }

                } else {

                    // Trigger the fallback event
                    if (typeof settings.onFallback === 'function') {
                        settings.onFallback.call($this);
                    }
                    return false;

                }

            });

        },


        // Write some data to the console
        debug : function() {

            return this.each(function() {

                console.log($(this).data('uploadifive'));

            });

        },

        // Clear all the items from the queue
        clearQueue : function() {

            this.each(function() {

                var $this    = $(this),
                    $data    = $this.data('uploadifive'),
                    settings = $data.settings;

                for (var key in $data.inputs) {
                    input = $data.inputs[key];
                    limit = input.files.length;
                    for (i = 0; i < limit; i++) {
                        file = input.files[i];
                        methods.cancel.call($this, file);
                    }
                }
                // Trigger the onClearQueue event
                if (typeof settings.onClearQueue === 'function') {
                    settings.onClearQueue.call($this, $('#' + $data.settings.queueID));
                }

            });

        },

        // Cancel a file upload in progress or remove a file from the queue
        cancel : function(file, fast) {

            this.each(function() {

                var $this    = $(this),
                    $data    = $this.data('uploadifive');
                // 处理ng兼容问题
                if(!$data)
                    return;
                var settings = $data.settings;

                // If user passed a queue item ID instead of file...
                if (typeof file === 'string') {
                    if (!isNaN(file)) {
                        fileID = 'uploadifive-' + $(this).attr('id') + '-file-' + file;
                    }
                    file = $('#' + fileID).data('file');
                }

                file.skip = true;
                $data.filesCancelled++;
                if (file.uploading) {
                    $data.uploads.current--;
                    file.uploading = false;
                    file.xhr.abort();
                    delete file.xhr;
                    methods.upload.call($this);
                }
                if ($.inArray('onCancel', settings.overrideEvents) < 0) {
                    $data.removeQueueItem(file, fast);
                }

                // Trigger the cancel event
                if (typeof settings.onCancel === 'function') {
                    settings.onCancel.call($this, file);
                }
                
            });
            
        },

        // Upload the files in the queue
        upload : function(file, keepVars) {

            this.each(function() {

                var $this    = $(this),
                    $data    = $this.data('uploadifive'),
                    settings = $data.settings;

                if (file) {

                    $data.uploadFile.call($this, file);

                } else {

                    // Check if the upload limit was reached
                    if (($data.uploads.count + $data.uploads.current) < settings.uploadLimit || settings.uploadLimit == 0) {
                        if (!keepVars) {
                            $data.uploads.attempted   = 0;
                            $data.uploads.successsful = 0;
                            $data.uploads.errors      = 0;
                            var filesToUpload = $data.filesToUpload();
                            // Trigger the onUpload event
                            if (typeof settings.onUpload === 'function') {
                                settings.onUpload.call($this, filesToUpload);
                            }
                        }

                        // Loop through the files
                        $('#' + settings.queueID).find('.uploadifive-queue-item').not('.error, .complete').each(function() {
                            _file = $(this).data('file');
                            // Check if the simUpload limit was reached
                            if (($data.uploads.current >= settings.simUploadLimit && settings.simUploadLimit !== 0) || ($data.uploads.current >= settings.uploadLimit && settings.uploadLimit !== 0) || ($data.uploads.count >= settings.uploadLimit && settings.uploadLimit !== 0)) {
                                return false;
                            }
                            if (settings.checkScript) {
                                // Let the loop know that we're already processing this file
                                _file.checking = true;
                                skipFile = $data.checkExists(_file);
                                _file.checking = false;
                                if (!skipFile) {
                                    $data.uploadFile(_file, true);
                                }
                            } else {
                                $data.uploadFile(_file, true);
                            }
                        });
                        if ($('#' + settings.queueID).find('.uploadifive-queue-item').not('.error, .complete').size() == 0) {
                            $data.queueComplete();
                        }
                    } else {
                        if ($data.uploads.current == 0) {
                            if ($.inArray('onError', settings.overrideEvents) < 0) {
                                if ($data.filesToUpload() > 0 && settings.uploadLimit != 0) {
                                    alert('The maximum upload limit has been reached.');
                                }
                            }
                            // Trigger the onError event
                            if (typeof settings.onError === 'function') {
                                settings.onError.call($this, 'UPLOAD_LIMIT_EXCEEDED', $data.filesToUpload());
                            }
                        }
                    }

                }

            });

        },

        // Destroy an instance of UploadiFive
        destroy : function() {

            this.each(function() {

                var $this    = $(this),
                    $data    = $this.data('uploadifive'),
                    settings = $data.settings;
            
                // Clear the queue
                methods.clearQueue.call($this);
                // Destroy the queue if it was created
                if (!settings.queueID) $('#' + settings.queueID).remove();
                // Remove extra inputs
                $this.siblings('input').remove();
                // Show the original file input
                $this.show()
                // Move the file input out of the button
                .insertBefore($data.button);
                // Delete the button
                $data.button.remove();
                // Trigger the destroy event
                if (typeof settings.onDestroy === 'function') {
                    settings.onDestroy.call($this);
                }

            });

        }

    }

    $.fn.uploadifive = function(method) {

        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('The method ' + method + ' does not exist in $.uploadify');
        }

    }

})(jQuery);

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_jqEx__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_auth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_public_css__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_public_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_public_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_player_css__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_player_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_player_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_font_awesome_min_css__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plug_playerController__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sdConfirm__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sdConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_sdConfirm__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { sdConfirm: __WEBPACK_IMPORTED_MODULE_8__components_sdConfirm___default.a },
  data: function data() {
    return {
      temp: 'asdasd'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    soundData: function soundData(state) {
      return state.common.soundData;
    }
  })),
  methods: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_7__plug_playerController__["a" /* gPlayer */].initPlayer(this.soundData);
    __WEBPACK_IMPORTED_MODULE_3__service_auth__["auth"].register.bind();
    var _this = this;

    util.confirm = this.$refs.confirm;
  },
  created: function created() {}
});

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sdModal__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sdModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_sdModal__);







var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['UPDATEUSERADDRESS', 'ADDUSERADDRESS', 'UPDATEUSERADDRESS']);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-address',
  props: ['address'],
  components: { sdModal: __WEBPACK_IMPORTED_MODULE_3__components_sdModal___default.a },
  data: function data() {
    return {
      show: false,
      type: '',
      param: {
        receiverName: '',
        userAdd: '',
        userPhone: '',
        haveDefault: '' },
      dirty: {
        receiverName: '',
        userAdd: '',
        userPhone: ''
      },

      pParam: {}
    };
  },

  computed: {
    _haveDefault: function _haveDefault() {
      return this.param.haveDefault == 2;
    },
    checkReceiverName: function checkReceiverName() {
      return this.param.receiverName;
    },
    checkUserAdd: function checkUserAdd() {
      return this.param.userAdd;
    },
    checkUserPhone: function checkUserPhone() {
      return this.param.userPhone && this.param.userPhone.length >= 6 && this.param.userPhone.length <= 11;
    },
    checkAll: function checkAll() {
      return this.checkReceiverName && this.checkUserAdd && this.checkUserPhone;
    }
  },
  methods: {
    init: function init() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
    },
    doUpdate: function doUpdate(address) {
      this.show = true;

      this.type = 'update';

      var obj = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].copy(address);
      obj.haveDefault = obj.haveDefault == 2 ? true : false;
      this.param = obj;
    },
    doAdd: function doAdd() {
      this.init();
      this.show = true;
      this.type = 'add';
    },
    updateOriginal: function updateOriginal() {
      for (var key in this.param) {
        this.pParam[key] = this.param[key];
      }
      this.pParam.haveDefault = this.pParam.haveDefault === true ? 2 : 1;
    },
    dirtyAll: function dirtyAll() {
      for (var key in this.dirty) {
        this.dirty[key] = true;
      }
    },
    addAddress: function addAddress() {
      var _this = this;

      this.dirtyAll();
      if (!this.checkAll) {
        return;
      }

      var param = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].copy(this.param);
      if (param.haveDefault === true) {
        param.haveDefault = 2;
      } else {
        param.haveDefault = 1;
      }
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.ADDUSERADDRESS, param, function (res) {
        _this.show = false;

        _this.$emit('on-success');
        _this.init();
      });
    },
    updateAddress: function updateAddress() {
      var _this2 = this;

      this.dirtyAll();
      if (!this.checkAll) {
        return;
      }

      var param = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].copy(this.param);
      if (param.haveDefault === true) {
        param.haveDefault = 2;
      } else {
        param.haveDefault = 1;
      }
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.UPDATEUSERADDRESS, param, function (res) {
        _this2.show = false;
        _this2.$emit('on-success');
        _this2.init();
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.success('更新地址成功！');
      });
    }
  },
  watch: {},
  created: function created() {}
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sdModal__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sdModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_sdModal__);







var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['UPDATEUSERINVOICE', 'ADDINVOICEINFO']);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-invoce',
  props: ['address'],
  components: { sdModal: __WEBPACK_IMPORTED_MODULE_3__components_sdModal___default.a },
  data: function data() {
    return {
      show: false,
      type: '',
      param: {
        "invoiceType": "1",
        "invoiceTitle": "",
        "regAddress": "",
        "regPhone": "",
        "regBank": "",
        "bankNumber": "",
        "identifyNumber": "",
        "haveDefault": "" },
      dirty: {
        "invoiceType": "",
        "invoiceTitle": "",
        "regAddress": "",
        "regPhone": "",
        "regBank": "",
        "bankNumber": "",
        "identifyNumber": "",
        "haveDefault": ""
      },

      pParam: {}
    };
  },

  computed: {
    _haveDefault: function _haveDefault() {
      return this.param.haveDefault == 2;
    },
    isZP: function isZP() {
      return this.param.invoiceType == 2;
    },
    checkInvoiceTitle: function checkInvoiceTitle() {
      if (!this.dirty.invoiceTitle) {
        return true;
      }
      return this.param.invoiceTitle;
    },
    checkIdentifyNumber: function checkIdentifyNumber() {
      if (!this.dirty.identifyNumber) {
        return true;
      }
      return this.param.identifyNumber;
    },
    checkRegAddress: function checkRegAddress() {
      if (this.isZP) {
        if (!this.dirty.regAddress) {
          return true;
        }
        return this.param.regAddress;
      }
      return true;
    },
    checkRegPhone: function checkRegPhone() {
      if (this.isZP) {
        if (!this.dirty.regPhone) {
          return true;
        }
        return this.param.regPhone;
      }
      return true;
    },
    checkRegBank: function checkRegBank() {
      if (this.isZP) {
        if (!this.dirty.regBank) {
          return true;
        }
        return this.param.regBank;
      }
      return true;
    },
    checkBankNumber: function checkBankNumber() {
      if (this.isZP) {
        if (!this.dirty.bankNumber) {
          return true;
        }
        return this.param.bankNumber;
      }
      return true;
    },
    checkAll: function checkAll() {
      this.dirtyAll(true);
      return this.checkInvoiceTitle && this.checkRegAddress && this.checkRegPhone && this.checkRegBank && this.checkBankNumber && this.checkIdentifyNumber;
    }
  },
  methods: {
    init: function init() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
    },
    dirtyAll: function dirtyAll(bool) {
      for (var key in this.dirty) {
        this.dirty[key] = bool;
      }
    },
    doUpdate: function doUpdate(data) {
      this.show = true;

      this.type = 'update';

      var obj = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].copy(data);
      obj.haveDefault = obj.haveDefault == 2 ? true : false;
      this.param = obj;
    },
    doAdd: function doAdd() {
      this.init();
      this.show = true;
      this.type = 'add';
    },
    updateOriginal: function updateOriginal() {
      for (var key in this.param) {
        this.pParam[key] = this.param[key];
      }
    },
    addInvoice: function addInvoice() {
      var _this = this;

      if (!this.checkAll) {
        return;
      }

      var param = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].copy(this.param);
      if (param.haveDefault === true) {
        param.haveDefault = 2;
      } else {
        param.haveDefault = 1;
      }
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.ADDINVOICEINFO, param, function (res) {
        _this.init();
        _this.$emit('on-success');
        _this.show = false;
      });
    },
    updateInvoice: function updateInvoice() {
      var _this2 = this;

      if (!this.checkAll) {
        return;
      }
      var param = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].copy(this.param);
      if (param.haveDefault === true) {
        param.haveDefault = 2;
      } else {
        param.haveDefault = 1;
      }
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.UPDATEUSERINVOICE, param, function (res) {
        _this2.show = false;
        _this2.$emit('on-success');
        _this2.init();
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.success('更新发票成功！');
      });
    }
  },
  watch: {},
  created: function created() {}
});

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sdModal__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sdModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sdModal__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sd-confirm',
  props: [],
  components: { sdModal: __WEBPACK_IMPORTED_MODULE_2__sdModal___default.a },
  data: function data() {
    return {
      show: false,
      type: '',
      title: '',
      content: '',
      fn: undefined
    };
  },

  computed: {
    defContent: function defContent() {
      if (this.content) {
        return this.content;
      } else if (this.type == 'select') {
        return '确认操作？';
      } else if (this.type == 'error') {
        return '操作错误！';
      } else if (this.type == 'success') {
        return '操作成功！';
      }
    }
  },
  methods: {
    select: function select(title, content, fn) {
      this.type = 'select';
      this.title = title;
      this.content = content;
      this.fn = fn;
      this.show = true;
    },
    success: function success(content, fn) {
      this.type = 'success';
      this.title = '操作成功';
      this.content = content;
      this.fn = fn;
      this.show = true;
    },
    error: function error(content, fn) {
      this.type = 'error';
      this.title = '操作失败';
      this.content = content;
      this.fn = fn;
      this.show = true;
    },
    affirm: function affirm() {
      this.show = false;
      this.fn && this.fn();
      this.fn = undefined;
      this.$emit('on-affirm', this.data);
    },
    cancel: function cancel() {
      this.show = false;
      this.fn = undefined;
      this.$emit('on-cancel', this.data);
    }
  },
  created: function created() {}
});

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_util__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sd-footer',
    props: [],
    data: function data() {
        return {};
    },

    computed: {},
    methods: {},
    updated: function updated() {},
    created: function created() {}
});

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sd-footer',
    props: [],
    data: function data() {
        return {
            oldSearchStr: ''
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
        userInfo: function userInfo(state) {
            return state.common.userInfo;
        }
    })),
    methods: {
        toSearchPage: function toSearchPage() {
            window.open('/search/result?oldSearchStr=' + this.oldSearchStr);
        }
    },
    updated: function updated() {},
    mounted: function mounted() {
        $(".scrollx").hover(function () {
            $(this).find(".scrolly").stop().slideDown("slow");
        }, function () {
            $(this).find(".scrolly").stop().slideUp("slow");
        });
    },
    created: function created() {}
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_util__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sd-modal',
    props: ['left', 'top'],
    data: function data() {
        return {};
    },

    computed: {},
    methods: {},
    updated: function updated() {
        var content = this.$refs.content,
            cH = content.offsetHeight,
            cW = content.offsetWidth,
            wH = document.documentElement.clientHeight,
            wW = document.documentElement.clientWidth;
        $(content).css({
            'left': '50%',
            'top': '48%',
            'margin-left': -cW / 2 + 'px',
            'margin-top': -cH / 2 + 'px'
        });
    },
    created: function created() {}
});

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_util__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sd-pager',
    props: ['pageData'],
    data: function data() {
        return {
            showItem: 5
        };
    },

    computed: {
        pages: function pages() {
            var pag = [];
            if (this.pageData.pageNo < this.showItem) {
                var i = Math.min(this.showItem, this.pageData.totalPage);
                while (i) {
                    pag.unshift(i--);
                }
            } else {
                var middle = this.pageData.pageNo - Math.floor(this.showItem / 2),
                    i = this.showItem;
                if (middle > this.pageData.totalPage - this.showItem) {
                    middle = this.pageData.totalPage - this.showItem + 1;
                }
                while (i--) {
                    pag.push(middle++);
                }
            }
            return pag;
        }
    },
    methods: {
        prePage: function prePage() {
            this.pageData.pageNo-- && this.toPage(this.pageData.pageNo--);
        },
        nextPage: function nextPage() {
            this.pageData.pageNo++ && this.toPage(this.pageData.pageNo++);
        },
        toPage: function toPage(index) {

            if (index == this.pageData.pageNo) {
                return;
            }
            this.pageData.pageNo = index;
            this.$emit('page-change', index);
        }
    }

});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sd-select',
  props: ['options', 'open', 'value'],
  methods: {
    changeOpen: function changeOpen() {
      this.$emit('changeOpen');
    },
    changeOption: function changeOption(data) {
      this.$emit('changeOption', data);
    }
  }
});

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_commTools__ = __webpack_require__(172);






var API = __WEBPACK_IMPORTED_MODULE_1__service_util__["a" /* util */].api(['UPLOAD']);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sd-upload',
    props: [],
    data: function data() {
        return {};
    },

    computed: {},
    methods: {
        doUpload: function doUpload() {
            $('#uploadifive-upload-img').find('input:last').click();
        },
        init: function init() {
            var _this = this;
            __WEBPACK_IMPORTED_MODULE_2__service_commTools__["a" /* commTools */].initUpload($(this.$refs.upload), {
                fileType: '.jpg,.png',
                fileSizeLimit: 50000,
                'uploadScript': API.UPLOAD + ';jsessionid=' + window.USERINFO.sessionId,
                onUploadComplete: function onUploadComplete(file, _data) {
                    var data = eval('(' + _data + ')');
                    if (data.status == 4) {
                        var auth = __webpack_require__(89).auth;
                        auth.pop_login();
                    }
                    _this.$emit('on-upload', data, file);
                }
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        if (!window.USERINFO) {
            this.$store.dispatch('getUserInfo').then(function (res) {
                _this2.init();
            });
        } else {
            this.init();
        }
    },
    created: function created() {}
});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WSelect',
  props: {
    value: [String, Number],
    placeholder: String,
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      currentInput: '',
      currentPlaceholder: '',

      nativeValue: '',

      showDropdown: false,

      hoverIndex: -1
    };
  },

  computed: {
    selectedLabel: function selectedLabel() {
      var _this = this;

      var opt = this.options.find(function (d) {
        return d.value === _this.nativeValue;
      });
      return opt ? opt.label : this.nativeValue;
    },
    suggestion: function suggestion() {
      var _this2 = this;

      if (!this.currentInput) return this.options;
      return this.options.filter(function (d) {
        return d.label.includes(_this2.currentInput);
      });
    }
  },
  watch: {
    value: function value(val) {
      this.setNativeValue(val);
    }
  },
  mounted: function mounted() {
    this.setNativeValue(this.value);
  },

  methods: {
    setNativeValue: function setNativeValue(val) {
      var value = val;
      if (value === undefined && value === null) value = '';
      if (value !== this.nativeValue) {
        this.nativeValue = value;
        this.currentInput = this.selectedLabel;
      }
    },
    handleInput: function handleInput() {
      var value = this.value;
      if (value === undefined && value === null) value = '';
      if (value !== this.nativeValue) {
        this.$emit('input', this.nativeValue);
      }
    },
    onfocus: function onfocus() {},
    onChange: function onChange(item) {
      this.setNativeValue(item.value);
      this.handleInput();
      this.handleClose();
      this.$emit('change', item.value, item);
    },
    handleClose: function handleClose() {
      if (!this.showDropdown) return;
      this.showDropdown = false;
      this.currentPlaceholder = '';
      this.currentInput = this.selectedLabel;
    },
    handleOpen: function handleOpen() {
      this.showDropdown = true;
      this.currentPlaceholder = this.selectedLabel;
      this.currentInput = '';
    },
    handleClear: function handleClear() {
      this.setNativeValue('');
    },
    upEvent: function upEvent() {
      if (this.hoverIndex > 0) {
        this.hoverIndex--;
      }
    },
    downEvent: function downEvent() {
      if (this.hoverIndex + 1 < this.suggestion.length) {
        this.hoverIndex++;
      }
    },
    enterEvent: function enterEvent() {
      var opt = this.suggestion[this.hoverIndex];
      if (opt) this.onChange(opt);
      this.hoverIndex = -1;
      this.$refs['inner-input'].blur();
    }
  }
});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_addAddress__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_addAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_addAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_addInvoice__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_addInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_addInvoice__);








var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['ADDUSERADDRESS', 'GETADDRESSBYUSERID', 'GETUSERINVOICEBYUSERID', 'UPDATEUSERADDRESS', 'UPDATEUSERINVOICE', 'DELETEUSERADDRESS', 'DELETEUSERINVOICEBYID']);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'address-view',
  components: { addAddress: __WEBPACK_IMPORTED_MODULE_3__components_addAddress___default.a, addInvoice: __WEBPACK_IMPORTED_MODULE_4__components_addInvoice___default.a },
  data: function data() {
    return {
      pen: false,
      value: '',

      addressList: [],

      invoiceList: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.common.userInfo;
    },
    options: function options(state) {
      return state.common.options;
    }
  })),
  methods: {
    updateAddress: function updateAddress(item) {
      this.$refs.addressCtrl.doUpdate(item);
    },
    updateInvoice: function updateInvoice(item) {
      this.$refs.invoceCtrl.doUpdate(item);
    },
    addAddress: function addAddress() {
      this.$refs.addressCtrl.doAdd();
    },
    addInvoice: function addInvoice() {
      this.$refs.invoceCtrl.doAdd();
    },
    deleteAddress: function deleteAddress(item) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.select('确认操作', '确认删除地址？', function () {
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.DELETEUSERADDRESS, { id: item.id }, function (res) {
          _this.getAddressList();
        });
      });
    },
    deleteInvoice: function deleteInvoice(item) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.select('确认操作', '确认删除发票模版？', function () {
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.DELETEUSERINVOICEBYID, { id: item.id }, function (res) {
          _this2.getInvoiceList();
        });
      });
    },
    setDefault: function setDefault(item, type) {
      var param = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].copy(item);
      var api = type == 1 ? API.UPDATEUSERADDRESS : API.UPDATEUSERINVOICE;
      var src = type == 1 ? this.addressList : this.invoiceList;
      param.haveDefault = 2;

      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(api, param, function (res) {
        src.forEach(function (d) {
          d.haveDefault = 1;
        });
        item.haveDefault = 2;
      });
    },
    getAddressList: function getAddressList() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.GETADDRESSBYUSERID, {}, function (res) {

        _this3.addressList = res.data;
        if (!res.data.length) {
          _this3.addAddress();
        }
      });
    },
    getInvoiceList: function getInvoiceList() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.GETUSERINVOICEBYUSERID, {}, function (res) {
        _this4.invoiceList = res.data;
        if (!res.data.length) {
          _this4.addInvoice();
        }
      });
    }
  },
  created: function created() {
    this.getAddressList();
    this.getInvoiceList();
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(775)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(875),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sdHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sdHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_sdHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sdFooter__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sdFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_sdFooter__);







var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['LOGIN', 'GETINFOCOUNT']);
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'base-view',
    components: { sdHeader: __WEBPACK_IMPORTED_MODULE_3__components_sdHeader___default.a, sdFooter: __WEBPACK_IMPORTED_MODULE_4__components_sdFooter___default.a },
    data: function data() {
        return {
            res: '',
            oldSearchStr: '',
            pageGroup: [[{ name: 'HomeView', title: '我的主页' }], [{ name: '', title: '订单中心' }, { name: 'OrderView', title: '我的订单' }, { name: 'CouponView', title: '我的优惠券' }], [{ name: '', title: '财务中心' }, { name: 'RechargeView', title: '充值' }, { name: 'PayRecord', title: '支付记录' }, { name: 'MyInvoiceView', title: '我的发票' }, { name: 'AddressView', title: '发票地址管理' }], [{ name: '', title: '客户服务' }, { name: 'CollectView', title: '我的收藏' }, { name: 'MessageView', title: '我的消息', amount: true }, { name: 'EnterpriseView', title: '企业认证' }, { name: 'IdentityView', title: '身份认证' }], [{ name: '', title: '设置' }, { name: 'InfoView', title: '基本信息' }, { name: 'ResetView', title: '修改密码' }]]
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
        userInfo: function userInfo(state) {
            return state.common.userInfo;
        },
        log: function log(state) {
            return state.common.log;
        },
        amount: function amount(state) {
            return state.common.amount;
        }
    })),
    methods: {
        toSearchPage: function toSearchPage() {
            window.open('/search/result.html?oldSearchStr=' + this.oldSearchStr);
        },
        getAmount: function getAmount() {
            this.$store.dispatch('updateMessageAmount');
        }
    },
    created: function created() {
        var _this = this;
        this.$store.dispatch('getUserInfo').then(function (res) {
            _this.getAmount();
        });
    },

    watch: {
        $route: function $route(nv) {
            this.getAmount();
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdSelect__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sdSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue__);








var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['SEARCHCUSTOMERRECHARGES']);
/* harmony default export */ __webpack_exports__["default"] = ({
    components: { sdSelect: __WEBPACK_IMPORTED_MODULE_1__components_sdSelect___default.a, sdPager: __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue___default.a },
    data: function data() {
        return {
            options: [{
                label: '全部',
                param: {}
            }, {
                label: '近三个月订单',
                param: {
                    beginTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(3, 'month').format('YYYY-MM-01'),
                    endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss')
                }
            }, {
                label: '近六个月订单',
                param: {
                    beginTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(6, 'month').format('YYYY-MM-01'),
                    endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss')
                }
            }, {
                label: '一年前订单',
                param: {
                    endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'year').format('YYYY-MM-DD')
                }
            }],
            open: false,
            dateRange: { label: '全部', param: {} },
            list: [],
            page: {
                pageNo: 1,
                pageSize: 15,
                totalPage: 1
            }
        };
    },

    computed: {
        searchRecharge: function searchRecharge() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.dateRange.param);
        },
        paramPage: function paramPage() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.page);
        }
    },
    methods: {
        changeRange: function changeRange(data) {
            this.dateRange = data;
            this.page = this.$options.data().page;
            this.open = !this.open;
            this.search();
        },
        pageChange: function pageChange() {
            this.search();
        },
        search: function search() {
            var _this2 = this;

            var _this = this;
            __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.SEARCHCUSTOMERRECHARGES, { searchRecharge: _this.searchRecharge, page: _this.paramPage }, function (json) {
                _this.list = json.data.datas;
                _this2.page.pageNo = json.data.pageNo;
                _this2.page.totalPage = json.data.totalPage;
            });
        }
    },
    mounted: function mounted() {
        this.search();
    }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sdPager__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sdPager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_sdPager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plug_playerController__ = __webpack_require__(171);







var API = __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].api(['CUSTOMERFINDCOLLECTION', 'CUSTOMERCANCELCOLLECTION', 'GETCOLLECTIONBYCONDITION', 'CUSTOMERCOLLECT']);
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'collect-view',
    components: { sdPager: __WEBPACK_IMPORTED_MODULE_2__components_sdPager___default.a },
    data: function data() {
        return {
            type: 'dubber',
            waitingSelect: false,
            selectedItems: [],
            searchKey: '',
            datas: {
                dubber: [],
                voice: [],
                album: []
            },
            pages: {
                dubber: {
                    kw: '',
                    pageNo: 1,
                    pageSize: 20,
                    totalPage: 1
                },
                voice: {
                    kw: '',
                    pageNo: 1,
                    pageSize: 30,
                    totalPage: 1
                },
                album: {
                    kw: '',
                    pageNo: 1,
                    pageSize: 20,
                    totalPage: 1
                }
            },

            curPage: {
                kw: '',
                pageNo: 1,
                pageSize: 20,
                totalPage: 1
            }

        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
        userInfo: function userInfo(state) {
            return state.common.userInfo;
        },
        log: function log(state) {
            return state.common.log;
        }
    }), {
        getPage: function getPage() {
            var page = this.pages[this.type];
            return {
                pageNo: page.pageNo,
                pageSize: page.pageSize
            };
        },
        getData: function getData() {
            return this.datas[this.type];
        },
        getTypeId: function getTypeId() {
            return { 'dubber': 1, 'voice': 2, 'album': 3 }[this.type];
        },
        getTypeKey: function getTypeKey() {
            return { 'dubber': 'dubbingId', 'voice': 'voiceId', 'album': 'tranSpecialId' }[this.type];
        },
        isSelectedAll: function isSelectedAll() {
            var key = this.type;
            return this.datas[key].length == this.selectedItems.length && this.selectedItems.length;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        checkAll: function checkAll() {
            var _this2 = this;

            var key = this.type;

            if (this.isSelectedAll) {
                this.selectedItems = [];
                return;
            }

            this.selectedItems = [];
            this.datas[key].forEach(function (d) {
                _this2.selectedItems.push(d);
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */], {
        changeType: function changeType(type) {
            this.selectedItems = [];
            this.type = type;
            this.curPage = this.pages[this.type];

            if (!this.getData.length) {
                this.doSearch();
            }
        },
        getIndex: function getIndex(item) {
            return this.selectedItems.indexOf(item);
        },
        isSelected: function isSelected(item) {
            return this.getIndex(item) != -1;
        },
        typeChange: function typeChange() {
            if (this.waitingSelect) {
                this.waitingSelect = false;
                this.selectedItems = [];
            } else {
                this.waitingSelect = true;
            }
        },
        selectItem: function selectItem(item) {
            if (!this.waitingSelect) {
                return;
            }
            var i = this.selectedItems.indexOf(item);
            if (i != -1) {
                this.selectedItems.splice(i, 1);
            } else {
                this.selectedItems.push(item);
            }
        },
        doDelete: function doDelete() {
            var _this3 = this;

            var src = this.getData;
            var del = this.selectedItems;
            var ids = [];
            var _curType = this.type;
            del.forEach(function (d) {
                ids.push(d[_this3.getTypeKey]);
            });
            this.typeChange();

            if (!ids.length) {
                return;
            }

            var param = {
                collectType: this.getTypeId,
                collectionIds: ids.join(',')
            };

            __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].updateCollectCookie(this.getTypeId, ids, 'remove');
            __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.CUSTOMERCANCELCOLLECTION, param, function (json) {
                _this3.changeType(_curType);
                _this3.doSearch();
            });
        },
        pageChange: function pageChange(index) {
            var page = this.pages[this.type];

            this.doSearch();
        },
        doSearch: function doSearch(searchType) {
            var _this4 = this;

            var type = this.getTypeId,
                page = this.pages[this.type];
            var param = {
                collectType: type,
                page: this.getPage,
                caseString: this.searchKey
            };
            __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.CUSTOMERFINDCOLLECTION, param, function (json) {
                _this4.selectedItems = [];
                var _data = json.data.datas,
                    _page = {
                    pageNo: json.data.pageNo,
                    totalPage: json.data.totalPage
                };

                _data.forEach(function (d, i) {
                    if (!d || d == null) {
                        _data.splice(i, 1);
                    }
                });

                if (type == 1) {
                    var _this = _this4;
                    _this4.datas.dubber = _data;
                    var dubber = _this4.datas.dubber;
                    for (var a in dubber) {
                        _this.$set(dubber[a], 'hasCollect', true);
                    }
                    _this4.pages.dubber.totalPage = _page.totalPage;
                    _this4.pages.dubber.pageNo = _page.pageNo;
                } else if (type == 2) {
                    _this4.datas.voice = _data;
                    _this4.pages.voice.totalPage = _page.totalPage;
                    _this4.pages.voice.pageNo = _page.pageNo;
                    __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].addSoundData(_data);
                } else if (type == 3) {
                    _this4.datas.album = _data;
                    _this4.pages.album.totalPage = _page.totalPage;
                    _this4.pages.album.pageNo = _page.pageNo;
                }
            });
        },
        searchItem: function searchItem() {
            var _this5 = this;

            var type = this.getTypeId;
            var param = {
                collectType: type,
                caseString: this.searchKey,
                page: this.getPage
            };
            __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.GETCOLLECTIONBYCONDITION, param, function (json) {
                var _data = json.data.datas,
                    _page = {
                    pageNo: json.data.pageNo,
                    totalPage: json.data.totalPage
                };

                _data.forEach(function (d, i) {
                    if (!d || d == null) {
                        _data.splice(i, 1);
                    }
                });

                if (type == 1) {
                    _this5.datas.dubber = _data;
                    _this5.pages.dubber.totalPage = _page.totalPage;
                    _this5.pages.dubber.pageNo = _page.pageNo;
                    var dubber = _this5.datas.dubber;
                    for (var a in dubber) {
                        _this5.$set(dubber[a], 'hasCollect', true);
                    }
                } else if (type == 2) {
                    _this5.datas.voice = _data;
                    _this5.pages.voice.totalPage = _page.totalPage;
                    _this5.pages.voice.pageNo = _page.pageNo;
                    __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].addSoundData(_data);
                } else if (type == 3) {
                    _this5.datas.album = _data;
                    _this5.pages.album.totalPage = _page.totalPage;
                    _this5.pages.album.pageNo = _page.pageNo;
                }
            });
        },
        singleCollect: function singleCollect(item) {
            var param = {
                collectType: this.getTypeId,
                collectionIds: item.dubbingId
            };

            if (item.hasCollect) {
                __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].updateCollectCookie(this.getTypeId, item.dubbingId, 'remove');
                item.hasCollect = false;
                __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.CUSTOMERCANCELCOLLECTION, param, function (res) {
                    if (res.status == 1) {
                        item.hasCollect = false;
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].updateCollectCookie(this.getTypeId, item.dubbingId, 'add');
                __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.CUSTOMERCOLLECT, {
                    collectType: this.getTypeId,
                    collectionId: item.dubbingId
                }, function (res) {
                    if (res.status == 1) {
                        item.hasCollect = true;
                    }
                });
            }
        }
    }),
    watch: {
        searchKey: function searchKey(value) {
            if (!value) {
                this.searchItem();
            }
        }
    },
    created: function created() {
        this.changeType('dubber');
    }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdPager__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdPager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sdPager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);






var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['FINDMYDISCOUNT']);
/* harmony default export */ __webpack_exports__["default"] = ({
    components: { sdPager: __WEBPACK_IMPORTED_MODULE_1__components_sdPager___default.a },
    data: function data() {
        return {
            genre: [{ label: '可用满减券', type: 1 }, { label: '可用代金券', type: 2 }],
            time: [{
                change: {
                    label: '进行中',
                    param: {
                        endStartTime: moment().format('YYYY-MM-DD'),
                        beginEndTime: moment().format('YYYY-MM-DD'),
                        useStatus: 1
                    },
                    type: 1
                },
                data: []
            }, {
                change: {
                    label: '即将开始',
                    param: {
                        beginStartTime: moment().add(1, 'days').format('YYYY-MM-DD'),
                        endStartTime: moment().add(7, 'days').format('YYYY-MM-DD'),
                        useStatus: 1
                    },
                    type: 2
                },
                data: []
            }, {
                change: {
                    label: '即将结束',
                    param: {
                        endStartTime: moment().format('YYYY-MM-DD'),
                        beginEndTime: moment().format('YYYY-MM-DD'),
                        endEndTime: moment().add(7, 'days').format('YYYY-MM-DD'),
                        useStatus: 1
                    },
                    type: 3
                },
                data: []
            }, {
                change: {
                    label: '已经结束',
                    param: {
                        beginEndTime: moment().subtract(7, 'days').format('YYYY-MM-DD'),
                        endEndTime: moment().subtract(1, 'days').format('YYYY-MM-DD')
                    },
                    type: 4
                },
                data: []
            }, {
                change: {
                    label: '已经使用',
                    param: {
                        useStatus: 2
                    },
                    type: 5
                },
                data: []
            }],
            genreSelected: {},
            timeSelected: {
                change: {
                    label: '进行中',
                    param: {
                        beginStartTime: moment(),
                        endEndTime: moment(),
                        useStatus: 1
                    },
                    type: 1
                },
                data: []
            },
            page: {
                pageNo: 1,
                pageSize: 12,
                totalPage: 1,
                totalRecord: 1
            }
        };
    },

    computed: {
        searchTranDiscountUser: function searchTranDiscountUser() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                discountType: this.genreSelected.type
            }, this.timeSelected.change.param, {
                page: {
                    pageNo: this.page.pageNo,
                    pageSize: this.page.pageSize
                }
            });
        },
        currentType: function currentType() {
            return this.timeSelected.change.type;
        },
        usable: function usable() {
            return !(this.currentType == 4 || this.currentType == 2 || this.currentType == 5);
        }
    },
    methods: {
        genreChange: function genreChange(data) {
            this.genreSelected = data;
            this.initPage();
            this.list();
        },
        timeChange: function timeChange(data) {
            this.timeSelected.change = data;
            this.initPage();
            this.list();
        },
        list: function list() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.FINDMYDISCOUNT, this.searchTranDiscountUser, function (res) {
                _this.timeSelected.data = res.data.datas;
                _this.page.pageNo = res.data.pageNo;
                _this.page.totalPage = res.data.totalPage;
                _this.page.totalRecord = res.data.totalRecord;
            });
        },
        pageChange: function pageChange() {
            this.list();
        },
        initPage: function initPage() {
            this.page = {
                pageNo: 1,
                pageSize: 12,
                totalPage: 1,
                totalRecord: 1
            };
        },
        diff: function diff(start, end) {
            var s = moment().diff(moment(start), 'days');
            var e = moment().diff(moment(end), 'days');
            if (e > -7 && s > 0) {
                return true;
            }
        }
    },
    mounted: function mounted() {
        this.genreSelected = this.genre[0];
        this.timeSelected.change = this.time[0].change;
        this.list();
    }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdModal_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sdModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_util__ = __webpack_require__(5);






var API = __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].api(['FINDMYORDER', 'GETCONTRIBUTIONBYID', 'ADDTRANAPPRAISEINFO']);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'discuss-view',
  components: {
    sdModal: __WEBPACK_IMPORTED_MODULE_1__components_sdModal_vue___default.a
  },
  data: function data() {
    return {
      haveComments: false,
      performance: ['不可接受', '一般般', '满意', '很好', '非常好'],
      dubbingGradeHover: 0,
      dubbingGradeData: 0,
      serviceGradeHover: 0,
      serviceGradeData: 0,
      dubbingGradeHint: '',
      serviceGradeHint: '',
      orderData: '',
      textareaHint: '',
      textarea: '',

      searchOrder: {
        numberStr: 0,
        numberType: 2
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.common.userInfo;
    },
    _options: function _options(state) {
      return state.common.options;
    }
  }), {
    textareaNum: function textareaNum() {
      if (this.textarea.length <= 200) {
        this.textareaHint = '';
      }
      return this.textarea.length;
    }
  }),
  methods: {
    gradeFn: function gradeFn(identifying, num) {
      if (identifying === 1 && this.haveComments) {
        this.dubbingGradeData = num;
        this.dubbingGradeHint = '';
      } else if (identifying === 2 && this.haveComments) {
        this.serviceGradeData = num;
        this.serviceGradeHint = '';
      } else {}
    },
    gradeEnter: function gradeEnter(identifying, num) {
      if (identifying === 1 && this.haveComments) {
        this.dubbingGradeHover = num;
        this.dubbingGradeHint = '';
      } else if (identifying === 2 && this.haveComments) {
        this.serviceGradeHover = num;
        this.serviceGradeHint = '';
      } else {}
    },
    doSearch: function doSearch() {
      var _this = this;

      this.searchOrder.numberStr = this.$route.query.id;
      var param = {
        searchOrder: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.searchOrder)
      };
      __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.FINDMYORDER, param, function (res) {
        _this.orderData = res.data.datas[0];
        if (_this.orderData.payId && _this.orderData.dubbingGrade) {
          _this.haveComments = false;
          _this.dubbingGradeData = _this.orderData.dubbingGrade;
          _this.serviceGradeData = _this.orderData.waiterGrade;
          _this.textarea = _this.orderData.appraiseMessage || '';
        } else {
          _this.haveComments = true;
        }
      });
    },
    canDownContribution: function canDownContribution(item) {
      return item.contributionId;
    },
    downContribution: function downContribution(r) {
      if (!r.contributionId) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.GETCONTRIBUTIONBYID, { id: r.contributionId }, function (json) {
        r.realPath = 'https://transaction.oss-cn-shanghai.aliyuncs.com/' + json.data.contributionServerPath;
      }, function (err) {}, true);
    },
    submitFn: function submitFn() {
      var _this2 = this;

      var verify = [false, false, true];
      var params = {
        orderId: this.orderData.id,
        dubbingGrade: this.dubbingGradeData,
        waiterGrade: this.serviceGradeData,
        appraiseMessage: this.textarea
      };

      if (params.dubbingGrade) {
        verify[0] = true;
      } else {
        this.dubbingGradeHint = '<span style="color: red">\u8BF7\u6253\u5206<span/>';
        verify[0] = false;
      }
      if (params.waiterGrade) {
        verify[1] = true;
      } else {
        this.serviceGradeHint = '<span style="color: red">\u8BF7\u6253\u5206<span/>';
        verify[1] = false;
      }
      if (params.appraiseMessage.length <= 200) {
        verify[2] = true;
        this.textareaHint = '';
      } else {
        this.textareaHint = '\u4E0D\u80FD\u8D85\u8FC7200\u767E\u5B57';
        verify[2] = false;
      }
      if (verify.indexOf(false) === -1) {
        __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.ADDTRANAPPRAISEINFO, params, function (res) {
          _this2.doSearch();
        }, function (err) {
          __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].confirm.error(err);
        });
      }
    }
  },
  watch: {},
  created: function created() {
    this.doSearch();
  }
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_upload_component__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_upload_component__);



var API = util.api(['CUSTOMERAPPLYIDENTIFY', 'CUSTOMERCHECKIDENTIFY', 'UPLOAD']);
/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        FileUpload: __WEBPACK_IMPORTED_MODULE_0_vue_upload_component___default.a
    },
    data: function data() {
        return {
            files: [],
            options: {
                extensions: ['jpg', 'gif', 'png'],
                url: API.UPLOAD + ';jsessionid='
            },
            param: {
                auditName: '',
                auditImgType: '',
                auditImgCode: '',
                auditImgOne: '',
                auditType: 2,
                id: ''
            },
            upload: false,
            status: "",
            hasImg: true,
            enableSubmit: true
        };
    },

    methods: {
        inputFile: function inputFile(newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                if (newFile.xhr.status == 200) {
                    var data = JSON.parse(newFile.response);
                    this.param.auditImgOne = data.data;
                }
            }
        },
        inputFilter: function inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                if (!/\.(jpeg|jpg|gif|png)$/i.test(newFile.name)) {
                    return prevent();
                }
            }

            newFile.blob = '';
            var URL = window.URL || window.webkitURL;
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file);
                this.upload = true;
            }
        },
        validateBeforeSubmit: function validateBeforeSubmit() {
            var _this2 = this;

            var _this = this;
            this.$validator.validateAll().then(function (result) {
                if (result) {
                    if (!_this.param.auditImgOne) {
                        _this.hasImg = false;
                    } else {
                        util.kAjax(API.CUSTOMERAPPLYIDENTIFY, _this.param, function (res) {
                            if (res.status == 1) {
                                util.confirm.success('上传成功');
                                _this2.getIdentityInfo();
                            }
                        }, function (res) {
                            util.confirm.error(res.data);
                        });
                    }
                }
            });
        },
        getIdentityInfo: function getIdentityInfo() {
            var _this3 = this;

            var param = {
                searchUserIdentify: {
                    auditType: 2
                }
            };
            util.kAjax(API.CUSTOMERCHECKIDENTIFY, param, function (res) {
                if (res.data.length) {
                    _this3.param = res.data[0];
                    if (res.data[0].auditStatus == 1) {
                        _this3.status = '资料已认证通过';
                        _this3.enableSubmit = false;
                    } else if (res.data[0].auditStatus == 2) {
                        _this3.status = '认证失败，原因：' + (res.data[0].auditFailReason || '资料未通过审核');
                        _this3.enableSubmit = true;
                    } else if (res.data[0].auditStatus == 3) {
                        _this3.status = '资料认证中，请耐心等待。';
                        _this3.enableSubmit = false;
                    }
                }
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$store.dispatch('getUserInfo').then(function (res) {
            _this4.options.url = _this4.options.url + res.data.sessionId;
        });
        this.getIdentityInfo();
    }
});

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_service__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdModal_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sdModal_vue__);








var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['GETCUSTOMERINFO', 'FINDMYORDER', 'FINDMYAUDITION', 'GETCONTRIBUTIONBYID']);
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { sdModal: __WEBPACK_IMPORTED_MODULE_5__components_sdModal_vue___default.a },
  data: function data() {
    return {
      API: API,
      orderData: [],

      viewVoice: false,

      voiceLists: [],

      integralSection: ['0-100', '101-500', '501-1200', '1201-2500', '2501-5000', '5001-8000', '8001-12000', '12001-20000', '20001-30000', '30001-50000', '50001-80000', '80001-120000', '120001-200000', '200001-300000', '300001-Infinity'],
      integral: 1,
      integralGap: 0,
      integralIcon: '1心',
      ruleTable: [{
        rank: 1,
        grade: '1-100',
        actor: '1心',
        name: '配音菜鸟'
      }, {
        rank: 2,
        grade: '101-500',
        actor: '2心',
        name: '配音先驱'
      }, {
        rank: 3,
        grade: '501-1200',
        actor: '3心',
        name: '配音大虾'
      }, {
        rank: 4,
        grade: '1201-2500',
        actor: '4心',
        name: '配音老鸟'
      }, {
        rank: 5,
        grade: '2501-5000',
        actor: '5心',
        name: '配音进阶'
      }, {
        rank: 6,
        grade: '5001-8000',
        actor: '1钻',
        name: '配音中阶'
      }, {
        rank: 7,
        grade: '8001-12000',
        actor: '2心',
        name: ' 配音高阶'
      }, {
        rank: 8,
        grade: '12001-20000',
        actor: '3钻',
        name: '配音学士'
      }, {
        rank: 9,
        grade: '20001-30000',
        actor: '4钻',
        name: '配音硕士'
      }, {
        rank: 10,
        grade: '30001-50000',
        actor: '5钻',
        name: '配音博士'
      }, {
        rank: 11,
        grade: '50001-80000',
        actor: '1皇冠',
        name: '配音狂人'
      }, {
        rank: 12,
        grade: '80001-120000',
        actor: '2皇冠',
        name: ' 配音达人'
      }, {
        rank: 13,
        grade: '120001-200000',
        actor: '3皇冠',
        name: '配音至尊'
      }, {
        rank: 14,
        grade: '200001-300000',
        actor: '4皇冠',
        name: '配音之神'
      }, {
        rank: 15,
        grade: '300001-',
        actor: '5皇冠',
        name: '配音大圣'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    collectCount: function collectCount() {
      if (this.userInfo.collectMap) {
        var _this = this;
        var arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_this.userInfo.collectMap);
        var sum = 0;
        for (var i = 0; i < arr.length; i++) {
          sum += arr[i].length;
        }
        return sum;
      } else {
        return 0;
      }
    },
    discountCount: function discountCount() {
      if (this.userInfo.discountList) {
        return this.userInfo.discountList.length;
      }
      return 0;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    _options: function _options(state) {
      return state.common.options;
    },
    userInfo: function userInfo(state) {
      return state.common.userInfo;
    }
  }), {
    integralInfo: function integralInfo() {
      return this.ruleTable[this.integral - 1];
    }
  }),
  methods: {
    canDownContribution: function canDownContribution(item) {
      return item.contributionId;
    },
    downContribution: function downContribution(r) {
      if (!r.contributionId) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.GETCONTRIBUTIONBYID, { id: r.contributionId }, function (json) {
        r.realPath = 'https://transaction.oss-cn-shanghai.aliyuncs.com/' + json.data.contributionServerPath;
      }, function (err) {}, true);
    },
    canPay: function canPay(item) {
      return item.orderStatus == 3 || item.orderStatus > 3 && item.orderStatus != 10 && !item.payId;
    },
    canAudition: function canAudition(item) {
      return item.auditionIds;
    },
    singlePay: function singlePay(item) {
      var orders = [item];
      this.$store.commit('PAYORDERS', orders);
      this.$router.push({
        name: 'PayView'
      });
    },
    voiceList: function voiceList(_ids) {
      var _this2 = this;

      var ids = _ids.split(',');
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.FINDMYAUDITION, { ids: ids }, function (res) {
        _this2.viewVoice = true;
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].addSoundData(res.data);
        _this2.voiceLists = res.data;
      });
    }
  },
  watch: {
    userInfo: function userInfo() {
      var _this3 = this;

      var num = this.userInfo.integral;
      var arr = ['1-5-心', '6-10-钻', '11-15-皇冠'];
      this.integralSection.map(function (item, index) {
        var minnum = item.split('-')[0] - 0;
        var maxnum = item.split('-')[1] - 0;
        if (minnum <= num && num <= maxnum) {
          _this3.integral = index + 1;
          _this3.integralGap = maxnum + 1 - num;
        } else {}
      });

      arr.map(function (item, index) {
        var minnum = item.split('-')[0] - 0;
        var maxnum = item.split('-')[1] - 0;
        var units = item.split('-')[2];
        if (minnum <= _this3.integral && _this3.integral <= maxnum) {
          _this3.integralIcon = _this3.integral - 5 * index + units;
        } else {}
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    var _this = this;
    this.$store.dispatch('getUserInfo').then(function (res) {});

    __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.FINDMYORDER, {}, function (res) {
      res.data.datas.map(function (d) {
        d.realPath = '';
      });
      _this4.orderData = res.data.datas.slice(0, 3);
    });
  }
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_upload_component__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_upload_component__);



var API = util.api(['CUSTOMERAPPLYIDENTIFY', 'CUSTOMERCHECKIDENTIFY', 'UPLOAD']);
/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        FileUpload: __WEBPACK_IMPORTED_MODULE_0_vue_upload_component___default.a
    },
    data: function data() {
        return {
            API: API,
            files: [],
            options: {
                extensions: ['jpg', 'gif', 'png'],
                url: API.UPLOAD + ';jsessionid='
            },
            param: {
                auditName: '',
                auditImgType: 1,
                auditImgCode: '',
                auditImgOne: '',
                auditType: 1,
                id: ''
            },
            upload: false,
            status: "",
            hasImg: true,
            disable: false,
            enableSubmit: true };
    },

    methods: {
        inputFile: function inputFile(newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                if (newFile.xhr.status == 200) {
                    var data = JSON.parse(newFile.response);
                    this.param.auditImgOne = data.data;
                }
            }
        },
        inputFilter: function inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                if (!/\.(jpeg|jpg|gif|png)$/i.test(newFile.name)) {
                    return prevent();
                }
            }

            newFile.blob = '';
            var URL = window.URL || window.webkitURL;
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file);
                this.upload = true;
            }
        },
        validateBeforeSubmit: function validateBeforeSubmit() {
            var _this2 = this;

            var _this = this;
            this.$validator.validateAll().then(function (result) {
                if (result) {
                    if (!_this.param.auditImgOne) {
                        _this.hasImg = false;
                    } else {
                        util.kAjax(API.CUSTOMERAPPLYIDENTIFY, _this.param, function (res) {
                            if (res.status == 1) {
                                util.confirm.success('上传成功');
                                _this2.getIdentityInfo();
                            }
                        }, function (res) {
                            util.confirm.error(res.data);
                        });
                    }
                }
            });
        },
        getIdentityInfo: function getIdentityInfo() {
            var _this3 = this;

            var param = {
                searchUserIdentify: {
                    auditType: 1
                }
            };
            util.kAjax(API.CUSTOMERCHECKIDENTIFY, param, function (res) {
                if (res.data.length) {
                    _this3.param = res.data[0];
                    if (res.data[0].auditStatus == 1) {
                        _this3.status = '资料已认证通过。';
                        _this3.disable = 'disabled';
                        _this3.enableSubmit = false;
                    } else if (res.data[0].auditStatus == 2) {
                        _this3.status = '认证失败，原因：' + (res.data[0].auditFailReason || '资料未通过审核');
                        _this3.enableSubmit = true;
                    } else if (res.data[0].auditStatus == 3) {
                        _this3.status = '资料认证中，请耐心等待。';
                        _this3.disable = 'disabled';
                        _this3.enableSubmit = false;
                    }
                }
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$store.dispatch('getUserInfo').then(function (res) {
            _this4.options.url = _this4.options.url + res.data.sessionId;
        });
        this.getIdentityInfo();
    }
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sdUpload__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sdUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_sdUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdModal__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sdModal__);









var API = __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].api(['SEARCHCUSTOMERAMOUNT', 'UPDATEMYINFO', 'GETRETURNCASHINFO']);
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'info-view',
    components: { sdUpload: __WEBPACK_IMPORTED_MODULE_2__components_sdUpload___default.a, sdModal: __WEBPACK_IMPORTED_MODULE_5__components_sdModal___default.a },
    data: function data() {
        return {
            recommendSum: {
                sum: false,
                valueOne: 0,
                valueTwo: 0,
                valueThree: 0,
                valueFour: 0
            },
            remaindAmount: 0,
            param: {
                "ordinaryName": "",
                "ordinarySex": "",
                "ordinaryBirthday": "",
                "tag": "",
                "ordinaryAddress": "",
                "backupName": "",
                "backupPhone": "",
                "companyName": "",
                "userPetname": "",
                "userHead": "",
                "userMail": ""
            },
            userHead: ''
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
        userInfo: function userInfo(state) {
            return state.common.userInfo;
        },
        log: function log(state) {
            return state.common.log;
        }
    })),
    methods: {
        doUpload: function doUpload() {
            this.$refs.upload.doUpload();
        },
        onUpload: function onUpload(data, file) {
            this.param.userHead = data.data;

            this.userHead = __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].preImgPath(data.data);
        },
        setParam: function setParam() {
            var _this2 = this;

            this.$store.dispatch('getUserInfo').then(function (res) {
                _this2.param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.param, __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].copy(_this2.userInfo));
                _this2.userHead = __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].imgPath(_this2.param.userHead);
            });
        },
        submit: function submit() {
            var _this3 = this;

            var param = __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].copy(this.param);
            if (!param.ordinaryName || !param.ordinarySex || !param.userPetname) {
                __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].confirm.error('请完善必填信息！');
                return;
            }
            __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.UPDATEMYINFO, param, function (res) {
                __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].confirm.success('更新信息成功！');
                _this3.$store.dispatch('getUserInfo');
            });
        },
        copy: function copy() {
            __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].confirm.success('已复制到剪切板！');
        },
        recommend: function recommend() {
            var _this = this;
            __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.GETRETURNCASHINFO, {}, function (res) {
                _this.recommendSum = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.recommendSum, res.data);
                _this.recommendSum.sum = true;
            });
        }
    },
    created: function created() {
        var _this4 = this;

        this.setParam();
        __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.SEARCHCUSTOMERAMOUNT, {}, function (res) {
            _this4.remaindAmount = res.data;
        });
    },
    mounted: function mounted() {
        var a = this.$refs.copy;
        new __WEBPACK_IMPORTED_MODULE_4_clipboard___default.a(a);
    }
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_addAddress__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_addAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_addAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_addInvoice__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_addInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_addInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sdHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sdFooter__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sdFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_sdFooter__);









var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['ADDUSERADDRESS', 'GETADDRESSBYUSERID', 'GETUSERINVOICEBYUSERID', 'UPDATEUSERADDRESS', 'UPDATEUSERINVOICE', 'WAITERADDINVOICEAPPLY', 'DELETEUSERADDRESS', 'DELETEUSERINVOICEBYID']);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'address-view',
  components: { addAddress: __WEBPACK_IMPORTED_MODULE_3__components_addAddress___default.a, addInvoice: __WEBPACK_IMPORTED_MODULE_4__components_addInvoice___default.a, sdHeader: __WEBPACK_IMPORTED_MODULE_5__components_sdHeader___default.a, sdFooter: __WEBPACK_IMPORTED_MODULE_6__components_sdFooter___default.a },
  data: function data() {
    return {
      oldSearchStr: '',

      addressList: [],

      invoiceList: [],

      selectAddressId: '',

      selectInvoiceId: '',

      invoiceName: '配音费',

      invoiceRemark: '',

      otherRemark: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.common.userInfo;
    },
    options: function options(state) {
      return state.common.options;
    },

    invoicePays: function invoicePays(state) {
      return state.common.invoicePays;
    }
  }), {
    getCustomerAmount: function getCustomerAmount() {
      var money = 0;
      this.invoicePays.forEach(function (d) {
        money += d.realityPay;
      });
      return money;
    },
    getPayIds: function getPayIds() {
      var ids = [];
      this.invoicePays.forEach(function (d) {
        ids.push(d.id);
      });
      return ids;
    }
  }),
  methods: {
    updateAddress: function updateAddress(item, $e) {
      $e && ($e.cancelBubble = true);
      this.$refs.addressCtrl.doUpdate(item);
    },
    updateInvoice: function updateInvoice(item, $e) {
      $e && ($e.cancelBubble = true);
      this.$refs.invoceCtrl.doUpdate(item);
    },
    addAddress: function addAddress() {
      this.$refs.addressCtrl.doAdd();
    },
    addInvoice: function addInvoice() {
      this.$refs.invoceCtrl.doAdd();
    },
    deleteAddress: function deleteAddress(item, $e) {
      var _this = this;

      $e && ($e.cancelBubble = true);
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.select('确认操作', '确认删除地址？', function () {
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.DELETEUSERADDRESS, { id: item.id }, function (res) {
          _this.selectAddressId = '';
          _this.getAddressList();
        });
      });
    },
    deleteInvoice: function deleteInvoice(item, $e) {
      var _this2 = this;

      $e && ($e.cancelBubble = true);
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.select('确认操作', '确认删除发票模版？', function () {
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.DELETEUSERINVOICEBYID, { id: item.id }, function (res) {
          _this2.selectInvoiceId = '';
          _this2.getInvoiceList();
        });
      });
    },
    setDefault: function setDefault(item, type, $e) {
      $e && ($e.cancelBubble = true);
      var param = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].copy(item);
      var api = type == 1 ? API.UPDATEUSERADDRESS : API.UPDATEUSERINVOICE;
      var src = type == 1 ? this.addressList : this.invoiceList;
      param.haveDefault = 2;

      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(api, param, function (res) {
        src.forEach(function (d) {
          d.haveDefault = 1;
        });
        item.haveDefault = 2;
      });
    },
    getAddressList: function getAddressList() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.GETADDRESSBYUSERID, {}, function (res) {
        _this3.addressList = res.data;
        if (!res.data.length) {
          _this3.addAddress();
        } else {
          _this3.addressList.forEach(function (d) {
            if (d.haveDefault == 2) {
              _this3.selectAddressId = d.id;
            }
          });
        }
      });
    },
    getInvoiceList: function getInvoiceList() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.GETUSERINVOICEBYUSERID, {}, function (res) {
        _this4.invoiceList = res.data;
        if (!res.data.length) {
          _this4.addInvoice();
        } else {
          _this4.invoiceList.forEach(function (d) {
            if (d.haveDefault == 2) {
              _this4.selectInvoiceId = d.id;
            }
          });
        }
      });
    },
    selectAddress: function selectAddress(item) {
      this.selectAddressId = item.id;
    },
    selectInvoice: function selectInvoice(item) {
      this.selectInvoiceId = item.id;
    },
    submitInvoice: function submitInvoice(type) {
      var _this5 = this;

      var param = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].copy({
        "payIds": this.getPayIds,
        "userInvoiceId": this.selectInvoiceId,
        "addressId": this.selectAddressId,
        "customerAmount": this.getCustomerAmount,
        "invoiceRemark": this.invoiceRemark,
        "otherRemark": this.otherRemark,
        "invoiceName": this.invoiceName,
        "invoiceMedium": type
      });

      if (!param.addressId) {
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.error('请创建并选择寄送地址！');
        return;
      }
      if (!param.userInvoiceId) {
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.error('请创建并选择发票模版！');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.WAITERADDINVOICEAPPLY, param, function (res) {
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.success('申请开票成功！');
        _this5.$router.push({
          name: 'OrderView'
        });
      });
    }
  },
  created: function created() {
    if (!this.invoicePays.length) {
      this.$router.push({
        name: 'OrderView'
      });
    }
    this.getAddressList();
    this.getInvoiceList();
  },
  destroyed: function destroyed() {
    this.$store.commit('INVOICEORDERS', []);
  }
});

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdPager__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdPager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sdPager__);




var API = __WEBPACK_IMPORTED_MODULE_0__service_util__["a" /* util */].api(['GETMYINFORMATION', 'DELETEMESSAGEBYID']);
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { sdPager: __WEBPACK_IMPORTED_MODULE_1__components_sdPager___default.a },
  data: function data() {
    return {
      messages: [],
      curPage: {
        kw: '',
        pageNo: 1,
        pageSize: 15,
        totalPage: 1
      }
    };
  },

  computed: {
    getPage: function getPage() {
      var page = this.curPage;
      return {
        pageNo: page.pageNo,
        pageSize: page.pageSize
      };
    }
  },
  methods: {
    remove: function remove(id) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__service_util__["a" /* util */].kAjax(API.DELETEMESSAGEBYID, { id: id }, function (res) {
        if (res.status == 1) {
          _this.message();
        }
      });
    },
    changeType: function changeType() {
      this.messages = [];

      if (!this.messages.length) {
        this.message();
      }
    },
    pageChange: function pageChange(index) {
      var page = this.curPage;
      this.message();
    },
    message: function message() {
      var _this2 = this;

      var param = {
        page: this.getPage
      };
      __WEBPACK_IMPORTED_MODULE_0__service_util__["a" /* util */].kAjax(API.GETMYINFORMATION, param, function (res) {
        var page = _this2.curPage;
        _this2.messages = [];
        var _data = res.data.datas,
            _page = {
          pageNo: res.data.pageNo,
          totalPage: res.data.totalPage
        };
        _this2.messages = _data;

        _this2.curPage.totalPage = _page.totalPage;
        _this2.curPage.pageNo = _page.pageNo;
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.changeType();
  }
});

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdSelect__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sdSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue__);








var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['GETTRANINVOICEBYSEARCH']);
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { sdSelect: __WEBPACK_IMPORTED_MODULE_1__components_sdSelect___default.a, sdPager: __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue___default.a },
  data: function data() {
    return {
      options: [{
        label: '全部',
        param: {}
      }, {
        label: '近三个月订单',
        param: {
          beginTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(3, 'month').format('YYYY-MM-01'),
          endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss')
        }
      }, {
        label: '近六个月订单',
        param: {
          beginTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(6, 'month').format('YYYY-MM-01'),
          endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss')
        }
      }, {
        label: '一年前的订单',
        param: {
          endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'year').format('YYYY-MM-DD')
        }
      }],
      open: false,
      dateRange: { label: '全部', param: {} },
      list: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        totalPage: 1
      }
    };
  },

  computed: {
    searchTranInvoice: function searchTranInvoice() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.dateRange.param);
    },
    paramPage: function paramPage() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.page);
    }
  },
  methods: {
    changeRange: function changeRange(data) {
      this.dateRange = data;
      this.open = !this.open;
      this.page = this.$options.data().page;
      this.search();
    },
    pageChange: function pageChange() {
      this.search();
    },
    search: function search() {
      var _this2 = this;

      var _this = this;
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.GETTRANINVOICEBYSEARCH, { searchTranInvoice: _this.searchTranInvoice, page: _this.page }, function (json) {
        _this.list = json.data.datas;
        _this2.page.pageNo = json.data.pageNo;
        _this2.page.totalPage = json.data.totalPage;
      });
    }
  },
  mounted: function mounted() {
    this.search();
  }
});

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sdPager__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sdPager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_sdPager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sdConfirm__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sdConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_sdConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_service__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sdSelect_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sdSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_sdSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sdModal_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sdModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_sdModal_vue__);











var API = __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].api(['FINDMYORDER', 'SINGLECREATEORDER', 'IMPROPERCREATEORDER', 'FINDMYAUDITION', 'GETCONTRIBUTIONBYID', 'GETSTATISTICSBYCUSTOMERSEARCH', 'WAITERADDINVOICEAPPLY', 'GETSTATISTICSBYCUSTOMERSEARCH', 'DOWNLOADORDERINFO']);
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'order-view',
    components: { sdPager: __WEBPACK_IMPORTED_MODULE_2__components_sdPager___default.a, sdConfirm: __WEBPACK_IMPORTED_MODULE_3__components_sdConfirm___default.a, sdSelect: __WEBPACK_IMPORTED_MODULE_6__components_sdSelect_vue___default.a, sdModal: __WEBPACK_IMPORTED_MODULE_7__components_sdModal_vue___default.a },
    data: function data() {
        return {
            forHelp: false,
            orderViki: {
                first: false,
                second: false,
                third: false
            },
            viewVoice: false,

            voiceLists: [],

            open: false,

            orderData: [],

            searchOrder: {
                customerOrderType: '',
                numberType: 4
            },

            page: {
                pageNo: 1,
                pageSize: 1
            },

            pageInfo: {
                pageNo: 1,
                pageSize: 20,
                totalPage: 1,
                totalRecord: 1
            },
            options: {
                orderStatus: {
                    '1': '需求中',
                    '2': '试音中',
                    '3': '待支付',
                    '4': '录制中',
                    '5': '已成品',
                    '6': '已成品',
                    '8': '已成品',
                    '10': '已取消'
                },
                customerOrderType: [{ id: '', label: '全部订单' }, { id: '1', label: '需求中' }, { id: '2', label: '试音中' }, { id: '3', label: '待支付' }, { id: '4', label: '录制中' }, { id: '5', label: '已成品' }]

            },

            selected: [],
            isSelectedAll: false,


            dateValue: [],
            pickerOptions: {
                shortcuts: [{
                    text: '近三个月订单',
                    onClick: function onClick(picker) {
                        var end = moment().format('YYYY-MM-DD 23:59:59');
                        var start = moment().add(-3, 'M').format('YYYY-MM-DD 00:00:00');
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近六个月订单',
                    onClick: function onClick(picker) {
                        var end = moment().format('YYYY-MM-DD 23:59:59');
                        var start = moment().add(-6, 'M').format('YYYY-MM-DD 00:00:00');
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '一年前的订单',
                    onClick: function onClick(picker) {
                        var end = moment().add(-1, 'Y').format('YYYY-MM-DD 00:00:00');
                        var start = moment().add(-5, 'Y').format('YYYY-MM-DD 00:00:00');
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },

            summation: {
                show: false,
                num: 0
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
        userInfo: function userInfo(state) {
            return state.common.userInfo;
        },
        _options: function _options(state) {
            return state.common.options;
        }
    })),
    methods: {
        help: function help() {
            this.forHelp = true;
            this.orderViki.first = true;
        },
        voiceList: function voiceList(_ids) {
            var _this = this;

            var ids = _ids.split(',');
            __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].kAjax(API.FINDMYAUDITION, { ids: ids }, function (res) {
                _this.viewVoice = true;
                __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].addSoundData(res.data);
                _this.voiceLists = res.data;
            });
        },
        canPay: function canPay(item) {
            return item.orderStatus == 3 || item.orderStatus > 3 && item.orderStatus != 10 && !item.payId;
        },
        canAudition: function canAudition(item) {
            return item.auditionIds;
        },
        canDownContribution: function canDownContribution(item) {
            return item.contributionId;
        },
        downContribution: function downContribution(r) {
            if (!r.contributionId) {
                return;
            }
            __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].kAjax(API.GETCONTRIBUTIONBYID, { id: r.contributionId }, function (json) {
                r.realPath = 'https://transaction.oss-cn-shanghai.aliyuncs.com/' + json.data.contributionServerPath;
            }, function (err) {}, true);
        },
        statusLabel: function statusLabel(order) {
            var status = order.orderStatus,
                payId = order.payId;
            if (status >= 3 && status != 10 && !payId) {
                return '待支付';
            }
            return this._options.orderStatus[status];
        },
        changeStatus: function changeStatus(id) {
            console.log(id);
            this.searchOrder.customerOrderType = id;

            this.pageInfo.pageNo = 1;
            this.doSearch();
        },
        pageChange: function pageChange() {
            this.doSearch();
        },
        selectDateRange: function selectDateRange(date) {
            this.dateRange = date;
            this.open = !this.open;
            this.doSearch();
        },
        clear: function clear() {
            this.searchOrder.appointPriceBegin = '';
            this.searchOrder.appointPriceEnd = '';
            this.searchOrder.numberStr = '';
            this.pageInfo.pageNo = 1;
            this.dateRange = this.options.dateList[0];
            this.doSearch();
        },
        selectAll: function selectAll() {
            var _this2 = this;

            if (!this.isSelectedAll) {
                this.selected = [];
                this.orderData.forEach(function (d) {
                    _this2.selected.push(d);
                });
            } else {
                this.selected = [];
            }
        },
        unSelectAll: function unSelectAll() {
            this.selected = [];
        },
        clearPrice: function clearPrice() {
            this.searchOrder.appointPriceBegin = '';
            this.searchOrder.appointPriceEnd = '';
            this.doSearch();
        },
        prePage: function prePage() {
            this.$refs.pager.prePage();
        },
        nextPage: function nextPage() {
            this.$refs.pager.nextPage();
        },
        doSearch: function doSearch() {
            var _this3 = this;

            this.summation.show = false;
            var param = {
                searchOrder: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.searchOrder, {
                    beginDate: this.dateValue[0],
                    endDate: this.dateValue[1]
                }),
                page: {
                    pageNo: this.pageInfo.pageNo,
                    pageSize: this.pageInfo.pageSize
                }
            };
            __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].kAjax(API.FINDMYORDER, param, function (res) {
                res.data.datas.map(function (d) {
                    return d.realPath = '';
                });
                _this3.orderData = res.data.datas;
                _this3.pageInfo.pageNo = res.data.pageNo;
                _this3.pageInfo.totalPage = res.data.totalPage;
                _this3.pageInfo.totalRecord = res.data.totalRecord;
                _this3.unSelectAll();
            });
        },
        singlePay: function singlePay(item) {
            var orders = [item];
            this.$store.commit('PAYORDERS', orders);
            this.$router.push({
                name: 'PayView'
            });
        },
        batchPay: function batchPay() {
            var orders = [];

            for (var i in this.selected) {
                var d = this.selected[i];
                if (!this.canPay(d)) {
                    __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].confirm.error('请选择已定价而未支付的订单！');
                    return;
                }
                orders.push(d);
            }
            if (!this.selected.length) {
                __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].confirm.error('无可支付的订单！');
                return;
            }

            this.$store.commit('PAYORDERS', this.selected);
            this.$router.push({
                name: 'PayView'
            });
        },
        batchInvoice: function batchInvoice() {
            var orders = [],
                money = 0;
            for (var i in this.selected) {
                var d = this.selected[i];
                if (!d.payId || d.orderStatus <= 3 || d.orderStatus == 10 || !d.voiceLength && !d.productId) {
                    __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].confirm.error('请选择已支付且已录成品而未开票的订单！');
                    return;
                }
                if (d.invoiceId) {
                    __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].confirm.error('请选择未开票的订单！');
                    return;
                }
                money += d.realityPrice;
                orders.push(d);
            }
            if (!orders.length) {
                __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].confirm.error('请选择订单！');
                return;
            }

            if (money < 300) {
                __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].confirm.error('开票总价需大于300元！');
                return;
            }
            this.$store.commit('INVOICEORDERS', orders);
            this.$router.push({
                name: 'InvoiceView'
            });
        },
        getStatistics: function getStatistics() {
            var _this4 = this;

            var param = {
                searchOrder: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.searchOrder, {
                    beginDate: this.dateValue[0],
                    endDate: this.dateValue[1]
                })
            };
            __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].kAjax(API.GETSTATISTICSBYCUSTOMERSEARCH, param, function (res) {
                if (!res.data) {
                    _this4.summation.show = true;
                    _this4.summation.num = 0;
                } else {
                    _this4.summation.show = true;
                    console.log('this.searchOrder.customerOrderType', _this4.searchOrder.customerOrderType);
                    if (_this4.searchOrder.customerOrderType == 3) {
                        _this4.summation.num = res.data.appointPrice || 0;
                        return;
                    }
                    _this4.summation.num = res.data.realityPrice || 0;
                }
            });
        },
        getExcel: function getExcel() {
            var _this5 = this;

            var data = __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].copy(this.orderData),
                src = [],
                title = ['稿件名称', '紧急', '选定老师', '定价', '实际付款', '订单状态', '创建时间'];

            if (!data.length) {
                __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].confirm.error('无订单数据！');
                return;
            }

            data.forEach(function (d, i) {
                src.push([d.contributionName, _this5._options.pressingStatus[d.pressingStatus], d.dubboNum, d.appointPrice, d.realityPrice, _this5.options.orderStatus[d.orderStatus], moment(d.createTime).format('MM-DD HH:mm')]);
            });
            __WEBPACK_IMPORTED_MODULE_4__service_util__["a" /* util */].toCSV(src, title, '订单信息' + moment().format('MM-DD HH:mm') + '.csv');
        },
        getAllExcel: function getAllExcel() {
            var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.searchOrder, {
                beginDate: this.dateValue[0],
                endDate: this.dateValue[1]
            });
            var str = '';
            for (var i in param) {
                if (param[i]) {
                    str += i + '=' + param[i] + '&';
                }
            }
            str = str.substring(0, str.length - 1);
            window.open(API.DOWNLOADORDERINFO + '?' + str);
        },
        creatOrder: function creatOrder() {
            __WEBPACK_IMPORTED_MODULE_5__service_service__["a" /* service */].creatOrder(this.doSearch);
        }
    },
    watch: {
        selected: function selected(value) {
            if (!this.selected.length) {
                this.isSelectedAll = false;
                return;
            }
            this.isSelectedAll = value.length == this.orderData.length;
        }
    },
    created: function created() {
        this.doSearch();
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdSelect__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sdSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue__);








var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['SEARCHPAYRECORD']);
/* harmony default export */ __webpack_exports__["default"] = ({
  components: { sdSelect: __WEBPACK_IMPORTED_MODULE_1__components_sdSelect___default.a, sdPager: __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue___default.a },
  data: function data() {
    return {
      selected: [],
      isSelectedAll: false,
      options: [{
        label: '全部',
        param: {}
      }, {
        label: '近三个月订单',
        param: {
          beginTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(3, 'month').format('YYYY-MM-DD'),
          endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss')
        }
      }, {
        label: '近六个月订单',
        param: {
          beginTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(6, 'month').format('YYYY-MM-DD'),
          endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss')
        }
      }, {
        label: '一年前订单',
        param: {
          endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'year').format('YYYY-MM-DD')
        }
      }],
      open: false,
      dateRange: { label: '全部', param: {} },
      list: [],
      page: {
        pageNo: 1,
        pageSize: 25,
        totalPage: 1
      }
    };
  },

  computed: {
    searchPay: function searchPay() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.dateRange.param);
    },
    paramPage: function paramPage() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.page);
    },
    onlineList: function onlineList() {
      return this.list.filter(function (d) {
        return d.onlinePay == 2;
      });
    }
  },
  methods: {
    selectAll: function selectAll() {
      var _this2 = this;

      if (!this.isSelectedAll) {
        this.selected = [];
        this.onlineList.forEach(function (d) {
          _this2.selected.push(d);
        });
      } else {
        this.selected = [];
      }
    },
    batchInvoice: function batchInvoice() {
      var pays = [],
          money = 0;
      for (var i in this.selected) {
        var d = this.selected[i];
        if (d.invoiceId) {
          __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.error('请选择未申请开票的支付记录!');
          return;
        }

        if (__WEBPACK_IMPORTED_MODULE_4_moment___default()(d.payTime).isBefore(__WEBPACK_IMPORTED_MODULE_4_moment___default()().add(-60, 'd'))) {
          __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.error('60天之前的订单，无法开票！');
          return;
        }

        money += d.realityPay;
        pays.push(d);
      }
      if (!pays.length) {
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.error('请选择支付记录！');
        return;
      }

      if (money < 300) {
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.error('开票总价需大于300元！');
        return;
      }
      this.$store.commit('INVOICEPAYS', pays);
      this.$router.push({
        name: 'InvoiceView'
      });
    },
    unSelectAll: function unSelectAll() {
      this.selected = [];
    },
    orderLineFeed: function orderLineFeed(orderNums) {
      if (orderNums.substr(0, 1) == ',') {
        orderNums = orderNums.substr(1);
      }
      return orderNums.replace(/\,/g, '<br/>');
    },
    changeRange: function changeRange(data) {
      this.dateRange = data;
      this.open = !this.open;

      this.page = this.$options.data().page;
      this.search();
    },
    pageChange: function pageChange() {
      this.search();
    },
    search: function search() {
      var _this3 = this;

      var _this = this;
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.SEARCHPAYRECORD, { searchPay: _this.searchPay, page: _this.paramPage }, function (json) {
        _this.list = json.data.datas;
        _this3.page.pageNo = json.data.pageNo;
        _this3.page.totalPage = json.data.totalPage;
        _this3.unSelectAll();
      });
    }
  },
  watch: {
    selected: function selected(value) {
      if (!this.selected.length) {
        this.isSelectedAll = false;
        return;
      }
      this.isSelectedAll = value.length && value.length == this.onlineList.length;
    }
  },
  mounted: function mounted() {
    this.search();
  }
});

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);






var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['LOGIN']);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pay-success-view',
  components: {},
  data: function data() {
    return {
      res: '',
      oldSearchStr: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.common.userInfo;
    },
    log: function log(state) {
      return state.common.log;
    }
  })),
  methods: {
    toSearchPage: function toSearchPage() {
      window.open('http://www.sd235.net/search/result#oldSearchStr=' + this.oldSearchStr);
    }
  },
  created: function created() {
    alert('支付成功，即将返回订单列表！');
    this.$router.push({
      name: 'OrderView'
    });
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sdModal__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sdModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_sdModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sdHeader__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sdHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_sdHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdFooter__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sdFooter__);








var API = __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].api(['FINDCANUSERDISCOUNT', 'SEARCHCUSTOMERAMOUNT', 'CUSTOMERSUBMITPAY', 'FINDPAYRESULTBYPAYID', 'CLOSEPAYORDER', 'FINDLASTPAYCHANNELBYCUSTOMERID', 'FINDONLINEPAYCHANNEL']);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pay-view',
    components: { sdModal: __WEBPACK_IMPORTED_MODULE_2__components_sdModal___default.a, sdHeader: __WEBPACK_IMPORTED_MODULE_4__components_sdHeader___default.a, sdFooter: __WEBPACK_IMPORTED_MODULE_5__components_sdFooter___default.a },
    data: function data() {
        return {
            oldSearchStr: '',

            remainingMount: 0,

            canUseMount: 0,

            payChannel: '',

            selectedDiscount: {},

            discountType: '2',

            discountData: [],

            QRCode: '',
            payStatus: '',

            timer: '',

            closeTime: 180,

            payId: '',

            channelAlipay: '',
            channelWx: ''
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
        userInfo: function userInfo(state) {
            return state.common.userInfo;
        },
        payOrders: function payOrders(state) {
            return state.common.payOrders;
        }
    }), {
        orderIds: function orderIds() {
            var ids = [];
            this.payOrders.forEach(function (d) {
                ids.push(d.id);
            });
            return ids;
        },
        orderNums: function orderNums() {
            var nums = [];
            this.payOrders.forEach(function (d) {
                nums.push(d.orderNum);
            });
            var numsStr = '',
                length = nums.length;
            if (length <= 3) {
                numsStr = nums.join(',') + ' 共' + length + '单';
            } else {
                numsStr = nums.slice(0, 3).join(',') + '... 共' + length + '单';
            }
            console.log(numsStr);
            return numsStr;
        },
        dj: function dj() {
            return this.discountData.filter(function (d) {
                return d.discountType == 2;
            });
        },
        yh: function yh() {
            return this.discountData.filter(function (d) {
                return d.discountType == 1;
            });
        },
        totalMoney: function totalMoney() {
            var money = 0;
            this.payOrders.forEach(function (d) {
                money += d.appointPrice;
            });
            return money;
        },
        withDiscountMoney: function withDiscountMoney() {
            var money = (this.totalMoney * 1000000 - (this.selectedDiscount.discountAmount || 0) * 1000000) / 1000000;
            return money < 0 ? 0 : money;
        },
        onlinePay: function onlinePay() {
            return (this.withDiscountMoney * 1000000 - this.remainingMount * 1000000) / 1000000;
        },
        getPayParam: function getPayParam() {
            var orderIds = [],
                payChannel = this.payChannel,
                remainingMount = this.remainingMount,
                couponId = this.selectedDiscount.discountCode,
                intendMoney = this.onlinePay;
            this.payOrders.forEach(function (d) {
                orderIds.push(d.id);
            });
            return {
                orderIds: orderIds,
                payChannel: payChannel,
                remainingMount: remainingMount,
                couponId: couponId,
                intendMoney: intendMoney
            };
        },
        payWayLs: function payWayLs() {
            return [this.channelAlipay || { id: 12 }, this.channelWx || { id: 1 }];
        }
    }),
    methods: {
        toSearchPage: function toSearchPage() {
            window.open('/search/result?oldSearchStr=' + this.oldSearchStr);
        },
        jump: function jump(name) {
            this.$router.push({
                name: name
            });
        },
        changeDiscountType: function changeDiscountType(type) {
            this.selectedDiscount = {};
            this.discountType = type;
        },
        chooseDiscount: function chooseDiscount(discount) {
            if (this.selectedDiscount == discount) {
                this.selectedDiscount = {};
            } else {
                this.selectedDiscount = discount;
            }

            this.remainingMount = 0;
        },
        changeRemainingMount: function changeRemainingMount($e) {
            var money = parseInt($e.target.value);

            if (!money || money < 0.0) {
                money = 0.0;
            }

            if (money > this.canUseMount) {
                money = this.canUseMount;
            }

            if (money > this.withDiscountMoney) {
                money = this.withDiscountMoney;
            }
            $e.target.value = money;
            this.remainingMount = money;
        },
        cancelPay: function cancelPay() {
            var _this = this;

            if (this.payStatus == 'success') {
                this.closePayresult();
                this.jump('OrderView');
            } else {
                __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.CLOSEPAYORDER, { payId: this.payId }, function (res) {
                    clearInterval(_this.timer);
                    _this.closePayresult();
                });
            }
        },
        closePayresult: function closePayresult() {
            this.payStatus = '';
            this.QRCode = '';
        },
        checkPayResult: function checkPayResult() {
            var _this2 = this;

            setInterval(this.timer);
            this.closeTime = 180;
            this.timer = setInterval(function () {
                __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.FINDPAYRESULTBYPAYID, { payId: _this2.payId }, function (res) {
                    _this2.closeTime -= 2;
                    if (_this2.closeTime <= 0) {
                        clearInterval(_this2.timer);

                        _this2.payStatus = '';
                        _this2.QRCode = '';
                    }

                    if (res.data == 2) {
                        _this2.payStatus = 'success';
                        _this2.QRCode = '';
                        clearInterval(_this2.timer);
                    }
                });
            }, 2000);
        },
        submitPay: function submitPay(payChannel) {
            var _this3 = this;

            this.payChannel = payChannel;

            var param = this.getPayParam;
            __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.CUSTOMERSUBMITPAY, param, function (res) {
                if (!res.data) {
                    _this3.payStatus = 'success';
                    return;
                }

                _this3.payId = res.data.payId;

                _this3.QRCode = res.data.html;
                _this3.payStatus = 'waiting';

                _this3.checkPayResult();
            });
        },
        getChannel: function getChannel() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API["FINDLASTPAYCHANNELBYCUSTOMERID"], {}, function (_ref) {
                var _ref$data = _ref.data,
                    data = _ref$data === undefined ? [] : _ref$data;

                var channel = data[0] ? data[0] : undefined;
                if (!channel) return;
                __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API["FINDONLINEPAYCHANNEL"], {
                    tagId: +channel.tagId
                }, function (_ref2) {
                    var _ref2$data = _ref2.data,
                        data = _ref2$data === undefined ? [] : _ref2$data;

                    _this4.channelWx = data.find(function (d) {
                        return d.onLineType == 1;
                    });
                    _this4.channelAlipay = data.find(function (d) {
                        return d.onLineType == 2;
                    });
                });
            });
        }
    },
    created: function created() {
        var _this5 = this;

        if (!this.payOrders.length) {
            this.$router.push({
                name: 'OrderView'
            });
            return;
        }

        __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.FINDCANUSERDISCOUNT, { orderIds: this.orderIds }, function (json) {
            _this5.discountData = json.data;
        });

        __WEBPACK_IMPORTED_MODULE_3__service_util__["a" /* util */].kAjax(API.SEARCHCUSTOMERAMOUNT, {}, function (json) {
            _this5.canUseMount = json.data;
        });
        this.getChannel();
    },
    mounted: function mounted() {},
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.timer);
    }
});

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);






var API = util.apis();
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            vcode: '',
            wxCode: '',
            API: API
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
        userInfo: function userInfo(state) {
            return state.common.userInfo;
        }
    })),
    methods: {
        copy: function copy() {
            util.confirm.success('已复制到剪切板！');
        }
    },
    mounted: function mounted() {
        var _this = this;

        var a = this.$refs.copy;
        new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a(a);
        this.$store.dispatch('getUserInfo').then(function (res) {
            _this.vcode = res.data.recommendCode;
        });

        var param = {
            scene: 'refCode=' + (this.userInfo.recommendCode || ''),
            page: 'pages/home/home'
        };
        util.kAjax(API.GETSMALLPROCEDURE, param, function (res) {
            _this.wxCode = res.data;
        });
    }
});

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    methods: {},
    mounted: function mounted() {}
});

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sdModal__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sdModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_sdModal__);






var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['UPDATEAMOUNTBYRECHARGE', 'FINDPAYRESULTBYPAYID', 'CLOSEPAYORDER', 'FINDLASTRECHARGECHANNELBYCUSTOMERID', 'FINDONLINEPAYCHANNEL']);
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'recharge-view',
    components: { sdModal: __WEBPACK_IMPORTED_MODULE_3__components_sdModal___default.a },
    data: function data() {
        return {
            res: '',
            oldSearchStr: '',

            money: 10,

            payChannel: '',

            QRCode: '',

            payStatus: '',

            timer: '',

            closeTime: 180,

            payId: '',
            channelAlipay: '',
            channelWx: ''
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
        userInfo: function userInfo(state) {
            return state.common.userInfo;
        }
    }), {
        getPayParam: function getPayParam() {
            return {
                money: this.money,
                payChannel: this.payChannel
            };
        },
        payWayLs: function payWayLs() {
            return [this.channelAlipay || { id: 12 }, this.channelWx || { id: 1 }];
        }
    }),
    methods: {
        toSearchPage: function toSearchPage() {
            window.open('http://www.sd235.net/search/result.html#oldSearchStr=' + this.oldSearchStr);
        },
        jump: function jump(name) {
            this.$router.push({
                name: name
            });
        },
        changeMoney: function changeMoney($e) {
            var money = parseInt($e.target.value);

            if (!money || money < 1) {
                money = 1;
            }

            if (money > 50000) {
                money = 50000;
            }
            $e.target.value = money;
            this.money = money;
        },
        cancelPay: function cancelPay() {
            var _this = this;

            if (this.payStatus != 'waiting') {
                this.payStatus = '';
            } else {
                __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.CLOSEPAYORDER, { payId: this.payId }, function (res) {
                    clearInterval(_this.timer);
                    _this.payStatus = '';
                    _this.QRCode = '';
                });
            }
        },
        checkPayResult: function checkPayResult() {
            var _this2 = this;

            setInterval(this.timer);
            this.closeTime = 180;
            this.timer = setInterval(function () {
                __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.FINDPAYRESULTBYPAYID, { payId: _this2.payId }, function (res) {
                    _this2.closeTime -= 2;
                    if (_this2.closeTime <= 0) {
                        clearInterval(_this2.timer);

                        _this2.payStatus = '';
                        _this2.QRCode = '';
                    }

                    if (res.data == 2) {
                        _this2.payStatus = 'success';
                        _this2.QRCode = '';
                        clearInterval(_this2.timer);
                    }
                });
            }, 2000);
        },
        submitPay: function submitPay(payChannel) {
            var _this3 = this;

            this.payChannel = payChannel;

            var param = this.getPayParam;
            __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.UPDATEAMOUNTBYRECHARGE, param, function (res) {
                _this3.payId = res.data.payId;

                _this3.QRCode = res.data.html;
                _this3.payStatus = 'waiting';

                _this3.checkPayResult();
            }, function (err) {
                __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].confirm.error(err);
            });
        },
        getChannel: function getChannel() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API["FINDLASTRECHARGECHANNELBYCUSTOMERID"], {}, function (_ref) {
                var _ref$data = _ref.data,
                    data = _ref$data === undefined ? [] : _ref$data;

                var channel = data[0] ? data[0] : undefined;
                if (!channel) return;
                __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API["FINDONLINEPAYCHANNEL"], {
                    tagId: +channel.tagId
                }, function (_ref2) {
                    var _ref2$data = _ref2.data,
                        data = _ref2$data === undefined ? [] : _ref2$data;

                    _this4.channelWx = data.find(function (d) {
                        return d.onLineType == 1;
                    });
                    _this4.channelAlipay = data.find(function (d) {
                        return d.onLineType == 2;
                    });
                });
            });
        }
    },
    created: function created() {
        this.$store.dispatch('getUserInfo');
        this.getChannel();
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_util__ = __webpack_require__(5);




var API = __WEBPACK_IMPORTED_MODULE_1__service_util__["a" /* util */].api(['GETRETURNCASHINFO']);
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            recommendNum: {
                valueOne: 0,
                valueTwo: 0,
                valueThree: 0,
                valueFour: 0,
                valueFive: 0
            }
        };
    },

    methods: {
        recommend: function recommend() {
            var _this = this;
            __WEBPACK_IMPORTED_MODULE_1__service_util__["a" /* util */].kAjax(API.GETRETURNCASHINFO, {}, function (res) {
                _this.recommendNum = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.recommendNum, res.data);
            });
        }
    },
    mounted: function mounted() {
        this.recommend();
    }
});

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_util__ = __webpack_require__(5);




var API = __WEBPACK_IMPORTED_MODULE_1__service_util__["a" /* util */].api(['UPDATEPWD']);
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            old: {
                model: '',
                error: '',
                state: 'false'
            },
            pwd: {
                model: '',
                error: '',
                state: 'false'
            },
            certain: {
                model: '',
                error: '',
                state: 'false'
            },
            remote: '',
            state: 'false'
        };
    },

    computed: {
        param: function param() {
            return {
                oldPass: this.old.model,
                userPass: this.pwd.model,
                newPassCopy: this.certain.model
            };
        },
        access: function access() {
            if (this.old.state && this.pwd.state && this.certain.state) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        required: function required() {
            if (this.old.model == '') {
                this.old.error = '请输入旧密码';
                this.old.state = false;
            } else {
                this.old.error = '';
                this.old.state = true;
            }
        },
        password: function password() {
            var _this = this;
            if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(_this.pwd.model)) {
                this.pwd.error = '密码必须为6-16位数字和字母组成';
                this.pwd.state = false;
            } else {
                this.pwd.error = '';
                this.pwd.state = true;
            }
        },
        confirm: function confirm() {
            if (this.pwd.model != this.certain.model) {
                this.certain.error = '与新密码不一致';
                this.certain.state = false;
            } else {
                this.certain.error = '';
                this.certain.state = true;
            }
        },
        reset: function reset() {
            if (this.access) {
                var _this = this;
                __WEBPACK_IMPORTED_MODULE_1__service_util__["a" /* util */].kAjax(API.UPDATEPWD, _this.param, function (res) {
                    _this.remote = '修改密码成功';
                    setTimeout(function () {
                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.$data, _this.$options.data());
                    }, 1500);
                }, function (err) {
                    _this.remote = err;
                    setTimeout(function () {
                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.$data, _this.$options.data());
                    }, 1500);
                });
            }
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdSelect__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_sdSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_sdSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue__);








var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['SEARCHCUSTOMEREXTRACT']);
/* harmony default export */ __webpack_exports__["default"] = ({
    components: { sdSelect: __WEBPACK_IMPORTED_MODULE_1__components_sdSelect___default.a, sdPager: __WEBPACK_IMPORTED_MODULE_5__components_sdPager_vue___default.a },
    data: function data() {
        return {
            options: [{
                label: '全部',
                param: {}
            }, {
                label: '近三个月订单',
                param: {
                    beginTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(3, 'month').format('YYYY-MM-01 HH:mm:ss'),
                    endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss')
                }
            }, {
                label: '近六个月订单',
                param: {
                    beginDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(6, 'month').format('YYYY-MM-01 HH:mm:ss'),
                    endDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss')
                }
            }, {
                label: '一年前订单',
                param: {
                    endTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'year').format('YYYY-MM-DD')
                }
            }],
            open: false,
            dateRange: { label: '全部', param: {} },
            list: [],
            page: {
                pageNo: 1,
                pageSize: 15,
                totalPage: 1
            }
        };
    },

    computed: {
        param: function param() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.dateRange.param, this.page);
        }
    },
    methods: {
        changeRange: function changeRange(data) {
            this.dateRange = data;
            this.open = !this.open;
            this.page = this.$options.data().page;
            this.search();
        },
        pageChange: function pageChange() {
            this.search();
        },
        search: function search() {
            var _this2 = this;

            var _this = this;
            __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.SEARCHCUSTOMEREXTRACT, this.param, function (json) {
                _this.list = json.data.datas;
                _this2.page.pageNo = json.data.pageNo;
                _this2.page.totalPage = json.data.totalPage;
            });
        }
    },
    mounted: function mounted() {
        this.search();
    }
});

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_service__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sdPager__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sdPager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_sdPager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sdModal_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sdModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_sdModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__service_axios__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_w_select_vue__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_w_select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_w_select_vue__);














var API = __WEBPACK_IMPORTED_MODULE_6__service_util__["a" /* util */].api(['LOGINBYCUSTOMERID', 'FINDMYORDER', 'FINDMYAUDITION', 'GETCONTRIBUTIONBYID', 'GETSTATISTICSBYCUSTOMERSEARCH', 'DOWNLOADORDERINFO', 'GETALLINNERUSER']);
/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AppPageAjax: __WEBPACK_IMPORTED_MODULE_8__components_sdPager___default.a,
    sdModal: __WEBPACK_IMPORTED_MODULE_9__components_sdModal_vue___default.a,
    WSelect: __WEBPACK_IMPORTED_MODULE_11__components_w_select_vue___default.a
  },
  data: function data() {
    return {
      customerId: '',
      customerInfo: {},
      fillData: {},
      searchParam: {
        numberType: '4',
        customerOrderType: '',
        waiterId: '',
        appointPriceBegin: '',
        appointPriceEnd: '',
        numberStr: '',
        beginDate: '',
        endDate: '',
        dateType: []
      },
      selected: [],
      summation: null,
      preventErr: {
        text: '',
        toLink: '',
        toText: ''
      },

      allSelected: '',

      viewVoice: false,

      voiceLists: [],

      forHelp: false,
      orderViki: {
        first: false,
        second: false,
        third: false
      },
      waiterOptions: [],

      options: {
        orderStatus: {
          1: '需求中',
          2: '试音中',
          3: '待支付',
          4: '录制中',
          5: '已成品',
          6: '已成品',
          8: '已成品',
          10: '已取消'
        },
        customerOrderType: [{ id: '', label: '全部订单' }, { id: '1', label: '需求中' }, { id: '2', label: '试音中' }, { id: '3', label: '待支付' }, { id: '4', label: '录制中' }, { id: '5', label: '已成品' }],
        dateList: [{ id: '', label: '全部', beginDate: '', endDate: '' }, {
          id: '1',
          label: '近三个月订单',
          beginDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(-3, 'M').format('YYYY-MM-DD 00:00:00'),
          endDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD 23:59:59')
        }, {
          id: '2',
          label: '近六个月订单',
          beginDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(-6, 'M').format('YYYY-MM-DD 00:00:00'),
          endDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD 23:59:59')
        }, {
          id: '3',
          label: '近两年订单',
          beginDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(-2, 'y').format('YYYY-MM-DD 00:00:00'),
          endDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD 23:59:59')
        }, {
          id: '3',
          label: '一年前的订单',
          beginDate: '',
          endDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(-1, 'Y').format('YYYY-MM-DD 00:00:00')
        }]
      },
      pickerOptions: {
        shortcuts: [{
          text: '近三个月订单',
          onClick: function onClick(picker) {
            var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD 23:59:59');
            var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(-3, 'M').format('YYYY-MM-DD 00:00:00');
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近六个月订单',
          onClick: function onClick(picker) {
            var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD 23:59:59');
            var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(-6, 'M').format('YYYY-MM-DD 00:00:00');
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '一年前的订单',
          onClick: function onClick(picker) {
            var end = __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(-1, 'Y').format('YYYY-MM-DD 00:00:00');
            var start = __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(-5, 'Y').format('YYYY-MM-DD 00:00:00');
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    _options: function _options(state) {
      return state.common.options;
    }
  }), {
    page: function page() {
      var _fillData = this.fillData,
          _fillData$pageNo = _fillData.pageNo,
          pageNo = _fillData$pageNo === undefined ? 1 : _fillData$pageNo,
          _fillData$pageSize = _fillData.pageSize,
          pageSize = _fillData$pageSize === undefined ? 20 : _fillData$pageSize,
          _fillData$totalPage = _fillData.totalPage,
          totalPage = _fillData$totalPage === undefined ? 1 : _fillData$totalPage,
          _fillData$totalRecord = _fillData.totalRecord,
          totalRecord = _fillData$totalRecord === undefined ? 0 : _fillData$totalRecord;

      return { pageNo: pageNo, pageSize: pageSize, totalPage: totalPage, totalRecord: totalRecord };
    }
  }),
  watch: {
    selected: function selected() {
      var isAll = this.selected.length === (this.fillData.datas || []).length;
      this.allSelected = isAll ? '1' : '';
    },
    allSelected: function allSelected(val) {
      if (val) {
        this.selected = (this.fillData.datas || []).map(function (d) {
          return d.id;
        });
      } else {
        this.selected = [];
      }
    }
  },
  created: function created() {
    var _$route$query = this.$route.query,
        customerId = _$route$query.customerId,
        customerOrderType = _$route$query.customerOrderType,
        waiterId = _$route$query.waiterId;

    customerId = decodeURIComponent(customerId);
    this.customerId = customerId;
    this.searchParam.customerOrderType = customerOrderType || '';
    this.searchParam.waiterId = waiterId || '';
  },
  mounted: function mounted() {
    var _this = this;

    if (this.customerId) {
      __WEBPACK_IMPORTED_MODULE_10__service_axios__["a" /* default */].post(API['LOGINBYCUSTOMERID'], {
        customerIdData: this.customerId
      }).then(function (_ref) {
        var data = _ref.data;

        _this.customerInfo = data || {};
        _this.init();
      });
    }
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_10__service_axios__["a" /* default */].post(API['GETALLINNERUSER']).then(function (_ref2) {
                  var data = _ref2.data;

                  if (data) {
                    _this2.waiterOptions = data.map(function (d) {
                      return { value: d.baseId, label: d.userPetname + '/' + d.userName };
                    });
                  }
                });
                _this2.doSearch();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getSearchParam: function getSearchParam() {
      var param = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.searchParam);
      delete param.dateType;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(param).forEach(function (k) {
        if (typeof param[k] === 'string') param[k] = param[k].replace(/(^\s*)|(\s*$)/g, '');
        if (param[k] === undefined || param[k] === '') delete param[k];
      });
      return param;
    },
    doSearch: function doSearch(pageNo) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_10__service_axios__["a" /* default */].post(API['FINDMYORDER'], {
        searchOrder: this.getSearchParam(),
        pageNo: pageNo || this.page.pageNo,
        pageSize: 20
      }).then(function (_ref3) {
        var data = _ref3.data;

        if (data) {
          _this3.fillData = data || {};
        }
      });
    },
    getUserInfo: function getUserInfo() {
      this.$store.dispatch('auth/AUTH_GETCUSTOMERINFO');
    },
    pageChange: function pageChange(pageNo) {
      this.fillData.pageNo = pageNo;
      this.doSearch(pageNo);
    },
    handleClear: function handleClear() {
      this.searchParam = {
        numberType: '4',
        customerOrderType: '',
        waiterId: '',
        appointPriceBegin: '',
        appointPriceEnd: '',
        numberStr: '',
        beginDate: '',
        endDate: '',
        dateType: ''
      };
      this.doSearch();
    },
    createOrder: function createOrder() {
      __WEBPACK_IMPORTED_MODULE_7__service_service__["a" /* service */].creatOrder(this.doSearch);
    },
    prevPage: function prevPage() {
      this.$refs.pager.prePage();
    },
    nextPage: function nextPage() {
      this.$refs.pager.nextPage();
    },
    batchPay: function batchPay() {
      var _this4 = this;

      var orders = (this.fillData.datas || []).filter(function (d) {
        return _this4.selected.includes(d.id);
      });
      var orderError = orders.find(function (d) {
        return !_this4.canPay(d);
      });
      if (orderError) {
        __WEBPACK_IMPORTED_MODULE_6__service_util__["a" /* util */].confirm.error('请选择已定价而未支付的订单！');
        return;
      }
      if (!orders.length) {
        __WEBPACK_IMPORTED_MODULE_6__service_util__["a" /* util */].confirm.error('无可支付的订单！');
        return;
      }
      this.$store.commit('PAYORDERS', orders);
      this.$router.push({
        name: 'PayView'
      });
    },
    dateChange: function dateChange(values) {
      this.searchParam.beginDate = values[0];
      this.searchParam.endDate = values[1];
    },
    singlePay: function singlePay(item) {
      var orders = [item];
      this.$store.commit('PAYORDERS', orders);
      this.$router.push({
        name: 'PayView'
      });
    },
    productPlay: function productPlay(row) {
      var param = {
        id: 'audition_' + row.id,
        path: row.auditionServerPath,
        title: row.auditionName
      };
      this.playByPath(param);
    },
    lookVoiceList: function lookVoiceList(_ref4) {
      var _this5 = this;

      var auditionIds = _ref4.auditionIds;

      var ids = auditionIds.split(',');
      __WEBPACK_IMPORTED_MODULE_10__service_axios__["a" /* default */].post(API['FINDMYAUDITION'], { ids: ids }).then(function (_ref5) {
        var data = _ref5.data;

        if (data) {
          _this5.viewVoice = true;
          __WEBPACK_IMPORTED_MODULE_6__service_util__["a" /* util */].addSoundData(data);
          _this5.voiceLists = data;
        }
      });
    },
    downContribution: function downContribution(r) {
      var _this6 = this;

      if (!r.contributionId) {
        return;
      }
      if (r.realPath) {
        this.downFileHandle(r.realPath);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_10__service_axios__["a" /* default */].post(API['GETCONTRIBUTIONBYID'], { id: r.contributionId }).then(function (_ref6) {
        var data = _ref6.data;

        if (data) {
          r.realPath = 'https://transaction.oss-cn-shanghai.aliyuncs.com/' + data.contributionServerPath;
          _this6.downFileHandle(r.realPath);
        }
      });
    },
    downFileHandle: function downFileHandle(path) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = path;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    canPay: function canPay(item) {
      return item.orderStatus >= 3 && item.orderStatus != 10 && !item.payId;
    },
    changeStatus: function changeStatus(id) {
      this.$set(this.searchParam, 'customerOrderType', id);
      this.doSearch(1);
    },
    openHelp: function openHelp() {
      this.forHelp = true;
      this.orderViki.first = true;
    },
    getStatistics: function getStatistics() {
      var _this7 = this;

      var param = {
        searchOrder: this.getSearchParam()
      };
      __WEBPACK_IMPORTED_MODULE_10__service_axios__["a" /* default */].post(API['GETSTATISTICSBYCUSTOMERSEARCH'], param).then(function (_ref7) {
        var data = _ref7.data;

        if (!data) {
          _this7.summation = null;
        } else {
          if (param.searchOrder.customerOrderType == 3) {
            _this7.summation = data.appointPrice || 0;
            return;
          }
          _this7.summation = data.realityPrice || 0;
        }
      });
    },
    getExcel: function getExcel() {
      var _this8 = this;

      var data = __WEBPACK_IMPORTED_MODULE_6__service_util__["a" /* util */].copy(this.fillData.datas || []),
          src = [],
          title = ['稿件名称', '紧急', '选定老师', '定价', '实际付款', '订单状态', '创建时间'];

      if (!data.length) {
        __WEBPACK_IMPORTED_MODULE_6__service_util__["a" /* util */].confirm.error('无订单数据！');
        return;
      }

      data.forEach(function (d, i) {
        src.push([d.contributionName, _this8._options.pressingStatus[d.pressingStatus], d.dubboNum, d.appointPrice, d.realityPrice, _this8.options.orderStatus[d.orderStatus], __WEBPACK_IMPORTED_MODULE_5_moment___default()(d.createTime).format('MM-DD HH:mm')]);
      });
      __WEBPACK_IMPORTED_MODULE_6__service_util__["a" /* util */].toCSV(src, title, '订单信息' + __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('MM-DD HH:mm') + '.csv');
    },
    getAllExcel: function getAllExcel() {
      var param = this.getSearchParam();
      var str = '';
      for (var i in param) {
        if (param[i]) {
          str += i + '=' + param[i] + '&';
        }
      }
      str = str.substring(0, str.length - 1);
      window.open(API.DOWNLOADORDERINFO + '?' + str);
    }
  },

  asyncData: function asyncData(ctx) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var store, params, error, query, customerId, customerOrderType, waiterId;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              store = ctx.store, params = ctx.params, error = ctx.error, query = ctx.query;
              customerId = query.customerId, customerOrderType = query.customerOrderType, waiterId = query.waiterId;

              customerId = decodeURIComponent(customerId);
              _context2.prev = 3;
              return _context2.abrupt('return', {
                customerId: customerId,
                customerOrderType: customerOrderType,
                waiterId: waiterId
              });

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](3);

              error({ statusCode: 404, message: _context2.t0 });

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this9, [[3, 7]]);
    }))();
  }
});

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter_filter__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directive_directives__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_validate_js__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_upload_component__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_upload_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elementUi__ = __webpack_require__(394);











__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('file-upload', __WEBPACK_IMPORTED_MODULE_8_vue_upload_component___default.a);

window.moment = __WEBPACK_IMPORTED_MODULE_6_moment___default.a;

window.vue = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_http__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_http___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_http__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_https__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_https___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_https__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);









var config = {
  headers: {
    post: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  },

  timeout: 10000,

  withCredentials: true,

  responseType: 'json',

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  httpAgent: new __WEBPACK_IMPORTED_MODULE_3_http___default.a.Agent({
    keepAlive: true
  }),
  httpsAgent: new __WEBPACK_IMPORTED_MODULE_4_https___default.a.Agent({
    keepAlive: true
  }),
  debug: true,
  crossDomain: true
};

if (process.server || !process.client) {
  config.baseURL = 'http://' + (__webpack_require__.i({"NODE_ENV":"production"}).HOST || 'localhost') + ':' + (__webpack_require__.i({"NODE_ENV":"production"}).PORT || 3000);
}

var axiosExtra = {
  onRequest: function onRequest(fn) {
    this.interceptors.request.use(function (config) {
      return fn(config) || config;
    });
  },
  onResponse: function onResponse(fn) {
    this.interceptors.response.use(function (response) {
      return fn(response) || response;
    });
  },
  onRequestError: function onRequestError(fn) {
    this.interceptors.request.use(undefined, function (error) {
      return fn(error) || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  onResponseError: function onResponseError(fn) {
    this.interceptors.response.use(undefined, function (error) {
      return fn(error) || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  onError: function onError(fn) {
    this.onRequestError(fn);
    this.onResponseError(fn);
  }
};

var extendAxiosInstance = function extendAxiosInstance(axios) {
  for (var key in axiosExtra) {
    axios[key] = axiosExtra[key].bind(axios);
  }
};

var setupProgress = function setupProgress(axios) {
  if (!process.client) {
    return;
  }

  var noopLoading = {
    finish: function finish() {},
    start: function start() {},
    fail: function fail() {},
    set: function set() {}
  };

  var $loading = function $loading() {
    return window.$nuxt && window.$nuxt.$loading && window.$nuxt.$loading.set ? window.$nuxt.$loading : noopLoading;
  };

  var currentRequests = 0;

  axios.onRequest(function (config) {
    if (config && config.progress === false) {
      return;
    }

    currentRequests++;
  });

  axios.onResponse(function (response) {
    if (response && response.config && response.config.progress === false) {
      return;
    }

    currentRequests--;
    if (currentRequests <= 0) {
      currentRequests = 0;
      $loading().finish();
    }
  });

  axios.onError(function (error) {
    if (error && error.config && error.config.progress === false) {
      return;
    }

    currentRequests--;
    $loading().fail();
    $loading().finish();
  });

  var onProgress = function onProgress(e) {
    if (!currentRequests) {
      return;
    }
    var progress = e.loaded * 100 / (e.total * currentRequests);
    $loading().set(Math.min(100, progress));
  };

  axios.defaults.onUploadProgress = onProgress;
  axios.defaults.onDownloadProgress = onProgress;
};

var $axios = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create(config);

extendAxiosInstance($axios);

setupProgress($axios);

$axios.interceptors.request.use(function (config) {
  if (process.client && config.data && config.data.constructor.name == 'FormData') {
    return config;
  }
  if (config.method === 'post') {
    config.data = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(config.data, { arrayFormat: 'brackets' });
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

$axios.interceptors.response.use(function (res) {
  return res.data || {};
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(url) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (false) {
      console.log('[' + moment().format() + '] POST => ', url, '\n param:', data);
    }

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      $axios(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ method: 'post', url: url, data: data }, config)).then(function (res) {
        switch (res.status + '') {
          case '1':
            {
              return resolve(res);
            }
          case '4':
            {
              console.log('UnLogin: => ', res);
              if (process.client && window.__NUXT__ && !data.noModal) {
                __NUXT__['state']['auth']['customerInfo'] = null;
                __NUXT__['state']['auth']['showLoginModal'] = true;
              }
              return reject(res);
            }
          default:
            {
              console.log('Error: => ', res);
              return reject(res);
            }
        }
      }).catch(function (e) {
        console.log('Error: => URL: ', url, '\n resErr:', e.Error);
        return reject(e);
      });
    });
  },
  get: function get(url) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (false) {
      console.log('[' + moment().format() + '] GET => ', url, '\n param:', data);
    }

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      $axios(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ method: 'get', url: url, params: data }, config)).then(function (res) {
        switch (res.status + '') {
          case '1':
            {
              return resolve(res);
            }
          case '4':
            {
              console.log('Error: => ', res);
              return reject(res);
            }
          default:
            {
              console.log('Error: => URL: ', url, '\n param:', data, res);
              return reject(res);
            }
        }
      }).catch(function (e) {
        console.log('Error: => URL: ', url, '\n resErr:', e.Error);
        return reject(e);
      });
    });
  },
  request: function request(config) {
    return $axios(config);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(49)))

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAPI;
/* harmony export (immutable) */ __webpack_exports__["c"] = getIMG;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPREIMG;
/* harmony export (immutable) */ __webpack_exports__["e"] = allAPI;
/* harmony export (immutable) */ __webpack_exports__["b"] = getOSS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _api;

var prefix = 'https://www.sd235.net/platform_tran_oview/local',
    PREVIEW_IMG = 'https://tmp.sd235.net:8088/tem/',
    PUBLIC_IMG = 'https://tmp.sd235.net:8088/public/',
    SERVER_PATH = 'https://sd235.oss-cn-shanghai.aliyuncs.com/';
var api = (_api = {
  ADDPLAYCOUNT: '/convoice/addPlayCount',

  ADDDOWNLOADCOUNT: '/convoice/addDownloadCount',

  ONLINEWAITERLIST: '/user/onlineWaiterList',

  FINDMYORDER: '/customerOrder/findMyOrder',

  IMPROPERCREATEORDER: '/customerOrder/improperCreateOrder',

  SINGLECREATEORDER: '/customerOrder/singleCreateOrder',

  FINDMYAUDITION: '/customerOrder/findMyAudition',

  REGISTER: '/user/register',

  UPDATEPWD: '/user/updatePwd',

  LOGINOUT: '/user/loginOut',

  LOGIN: '/user/login',

  GETVERIFYCODE: '/user/getVerifyCode',

  FORGETPASS: '/user/forgetPass',

  GETFORGETCODE: '/user/getForgetCode',

  UPLOAD: '/datum/upload',

  FINDDICT: '/customerOrder/findDict',

  CHECKPHONE: '/user/checkPhone',

  UPDATEOLDUSERPHONE: '/user/updateOldUserPhone',

  GETCONTRIBUTIONBYID: '/customerOrder/getContributionById',

  UPDATEMYINFO: '/user/updateMyInfo',

  GETCUSTOMERINFO: '/user/getCustomerInfo',

  GETSTATISTICSBYCUSTOMERSEARCH: '/customerOrder/getStatisticsByCustomerSearch',

  GETTRANINVOICEBYSEARCH: '/customerInvoice/getTranInvoiceBySearch',

  FINDTRANINVOICEINFOBYID: '/customerInvoice/findTranInvoiceInfoById',

  ADDUSERADDRESS: '/customerInvoice/addUserAddress',

  ADDINVOICEINFO: '/customerInvoice/addInvoiceInfo',

  GETADDRESSBYUSERID: '/customerInvoice/getAddressByUserId',

  GETUSERINVOICEBYUSERID: '/customerInvoice/getUserInvoiceByUserId',

  WAITERADDINVOICEAPPLY: '/customerInvoice/waiterAddInvoiceApply',

  UPDATEUSERADDRESS: '/customerInvoice/updateUserAddress',

  UPDATEUSERINVOICE: '/customerInvoice/updateUserInvoice',

  DELETEUSERADDRESS: '/customerInvoice/deleteUserAddress',

  DELETEUSERINVOICEBYID: '/customerInvoice/deleteUserInvoiceById',

  GETINTERNALINFO: '/user/getInternalInfo',

  REGISTBYQQ: '/user/registByQQ',

  LOGINBYMAIL: '/user/loginByMail',

  FINDPASSBYMAIL: '/user/findPassByMail',

  CHECKUUID: '/user/checkUUID',

  UPDATESYSUSERPWDBYUUID: '/user/updateSysUserPwdByUUID',

  SEARCHPAYRECORD: '/customerPay/searchPayRecord',

  SEARCHCUSTOMERAMOUNT: '/customerPay/searchCustomerAmount',

  SEARCHCUSTOMERRECHARGES: '/customerPay/searchCustomerRecharges',

  SEARCHCUSTOMEREXTRACT: '/customerPay/searchCustomerExtract',

  CLOSEPAYORDER: '/customerPay/closePayOrder'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETINTERNALINFO', '/user/getInternalInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'REGISTBYQQ', '/user/registByQQ'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'LOGINBYMAIL', '/user/loginByMail'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'FINDPASSBYMAIL', '/user/findPassByMail'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'REGISTVERIFYCODE', '/user/getVerifyCode'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'BOUNDPHONE', '/user/updateOldUserPhone'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'ONLINEWAITERLIST', '/user/onlineWaiterList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'IMGVERIFYCODE', '/datum/imgVerifyCode'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'CHECKUUID', '/user/checkUUID'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'UPDATESYSUSERPWDBYUUID', '/user/updateSysUserPwdByUUID'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'SIGNIN', '/point/signIn'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'CUSTOMERCOLLECT', '/point/customerCollect'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'CUSTOMERFINDCOLLECTION', '/point/customerFindCollection'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'CUSTOMERCANCELCOLLECTION', '/point/customerCancelCollection'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETCOLLECTORS', '/point/getCollectors'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'CUSTOMERUPVOTE', '/point/customerUpvote'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETUPVOTESTATISTICS', '/point/getUpvoteStatistics'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETCOLLECTSTATISTICS', '/point/getCollectStatistics'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'CUSTOMERFINDCOLLECTIONIDS', '/point/customerFindCollectionIds'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETCOLLECTIONBYCONDITION', '/point/getCollectionByCondition'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'CUSTOMERSUBMITPAY', '/customerPay/customerSubmitPay'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'UPDATEAMOUNTBYRECHARGE', '/customerPay/updateAmountByRecharge'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'FINDPAYRESULTBYPAYID', '/customerPay/findPayResultByPayId'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'ADDTRANAPPRAISEINFO', '/appraise/addTranAppraiseInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'FINDMYDISCOUNT', '/discount/findMyDiscount'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'FINDCANUSERDISCOUNT', '/discount/findCanUserDiscount'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'FINGDISCOUNTUSERBYCODE', '/discount/fingDiscountUserByCode'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'UPDATECLAIMDISCOUNT', '/discount/updateClaimDiscount'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'FINDDISCOUNT', '/discount/findDiscount'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETCUSTOMERALLDISCOUNT', '/discount/getCustomerAllDiscount'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETMYINFORMATION', '/information/getMyInformation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETMYINFORMATIONBYID', '/information/getMyInformationById'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'DELETEMESSAGEBYID', '/information/deleteMessageById'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETINFOCOUNT', '/information/getInfoCount'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETRETURNCASHINFO', '/customerOrder/getReturnCashInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'DOWNLOADORDERINFO', '/customerOrder/downloadOrderInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'CUSTOMERAPPLYIDENTIFY', '/customerIdentify/customerApplyIdentify'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'CUSTOMERCHECKIDENTIFY', '/customerIdentify/customerCheckIdentify'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETSMALLPROCEDURE', '/customerOrder/getSmallProcedure'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'FINDONLINEPAYCHANNEL', '/link_pay/findOnLinePayChannel'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'FINDLASTRECHARGECHANNELBYCUSTOMERID', '/link_pay/findLastRechargeChannelByCustomerId'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'FINDLASTPAYCHANNELBYCUSTOMERID', '/link_pay/findLastPayChannelByCustomerId'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'LOGINBYCUSTOMERID', '/link_pay/loginByCustomerId'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'GETALLINNERUSER', '/customerOrder/getAllInnerUser'), _api);

function filterPath(path) {
  path = path.replace(/\\/g, '/');
  return path;
}
function getAPI(name) {
  return prefix + api[name];
}
function getIMG(path) {
  return filterPath(PUBLIC_IMG + path);
}
function getPREIMG(path) {
  return filterPath(PREVIEW_IMG + path);
}
function allAPI() {
  var apis = {};
  for (var i in api) {
    apis[i] = getAPI(i);
  }
  apis['OSS'] = getOSS('');
  apis['IMG'] = getIMG('');
  apis['PRE'] = getPREIMG('');
  return apis;
}
function getOSS() {
  return SERVER_PATH;
}

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _opt = {
    orderStatus: { '1': '已需求', '2': '已试音', '3': '待支付', '4': '已支付', '5': '已成品', '6': '已成品', '8': '已成品', '10': '已取消' },
    orderType: { '1': '普通', '2': '修改', '3': '补录', '4': '保密' },
    pressingStatus: { '1': '低', '2': '中', '3': '高' },
    invoiceType: [{ id: 1, label: '增值税普通发票' }, { id: 2, label: '增值税专用发票' }],
    _invoiceType: { '1': '增值税普通发票', '2': '增值税专用发票' },
    invoiceName: ['服务费', '信息咨询费', '摄影服务费'],
    invoiceStatus: { '1': '未开票', '2': '已开票' },
    auditingStatus: { '1': '未审核', '2': '已通过', '3': '未通过' }
};

/* harmony default export */ __webpack_exports__["a"] = (_opt);

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);


window.$ = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a;
window.jQuery = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a;
__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend({
	isObject: function isObject(arg) {
		return (typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(arg)) == 'object';
	},
	copy: function copy(source) {
		return __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(true, {}, source);
	},
	times: function times(count, fn) {
		if (isNaN(count)) return;
		var i = 0;
		while (i < count) {
			var r = fn(i);

			if (r === false) break;
			if (r === true) continue;
			i++;
		}
	},
	escape2Html: function escape2Html(str) {
		var arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' };
		return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
			return arrEntities[t];
		});
	},

	chunk: function chunk(arr, count) {
		var result = [];
		for (var i = 0, len = arr.length; i < len; i += count) {
			result.push(arr.slice(i, i + count));
		}
		return result;
	},
	arc4random: function arc4random(max) {
		return Math.floor(Math.random() * max);
	},
	randomArr: function randomArr(arr) {
		return arr[__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.arc4random(arr.length)];
	},

	repeat: function repeat(source, args) {
		if (!source || (typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source)) != 'object') return '';
		if (typeof args == 'function') {
			return this._repeat(source, args);
		}
		var con = '',
		    len = source.length;
		__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each(source, function (i, d) {
			if (!d) return true;
			var _con = '';
			__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each(args, function (j, e) {
				_con += typeof e == 'function' ? e(d, i, len) : e;
			});
			con += _con;
		});
		return con;
	},
	_repeat: function _repeat(source, fn) {
		var res = '';
		__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each(source, function (i, d) {
			var _res = fn(i, d, source);
			if (typeof _res === 'boolean') {
				return _res;
			}
			res += _res;
		});
		return res;
	},

	toJson: function toJson(str) {
		var res = {};
		__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each(str.split('&'), function (i, d) {
			var e = d.split('=');

			if (e.length == 1) {
				res = str;
				return false;
			}
			res[e[0]] = e[1];
		});
		return res;
	},

	removeEmpty: function removeEmpty(param, copy) {
		if (copy) {
			param = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.copy(param);
		}
		if (param) {
			for (var k in param) {
				if (param[k] === '') {
					delete param[k];
				}
				for (var j in param[k]) {
					if (param[k][j] === '') {
						delete param[k][j];
					}
				}
			};
		}
		return param;
	},

	toCN: function toCN(str) {
		return str.replace(/[^\u4e00-\u9fa5]/gi, "");
	},

	tips: function tips() {
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.ui-tips').remove();
	},
	itemTool: {
		isLeft: function isLeft(count, i) {
			return !(i % count);
		},
		isRight: function isRight(count, i) {
			return !(i % count - (count - 1));
		}
	},

	cookie: {
		set: function set(key, value, day) {
			var Days = day || 3;
			var exp = new Date();
			exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
			document.cookie = key + "=" + escape(value + '') + ";expires=" + exp.toGMTString() + ";path=/";
		},
		get: function get(key) {
			var arr,
			    reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");

			if (arr = document.cookie.match(reg)) {
				return unescape(arr[2]);
			} else {
				return null;
			}
		},
		delete: function _delete(key) {
			if (!key) {
				__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.cookie.deleteAll();
				return;
			}
			var exp = new Date();
			exp.setTime(exp.getTime() - 1);
			var cval = this.get(key);
			if (cval != null) {
				document.cookie = key + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
			}
		},
		deleteAll: function deleteAll() {
			var myDate = new Date();
			myDate.setTime(-1000);
			var data = document.cookie;
			var dataArray = data.split("; ");
			for (var i = 0; i < dataArray.length; i++) {
				var varName = dataArray[i].split("=");
				document.cookie = varName[0] + "=''; expires=" + myDate.toGMTString() + ";path=/";
			}
		}
	},
	modal: function modal(type, content, cantRemove) {
		var fn = {
			pop: function pop(content) {
				var $m = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#sd_modal");
				var $c = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(content).css({
					"display": "block",
					"position": "fixed",
					"opacity": 1,
					"z-index": 110000,
					"left": 50 + "%",
					"top": 30 + "%"
				}).addClass('sd_modal_content');
				$m.after($c);

				$c.css('margin-left', '-' + $c.outerWidth() / 2 + 'px');
				__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#sd_modal").css({ "display": "block", "opacity": 0 });
				__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#sd_modal").fadeTo(200, 0.5);
			},
			close: function close() {
				var $m = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#sd_modal"),
				    $c = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".sd_modal_content");
				$m.remove();
				$c.remove();
			}
		};

		if (!__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#sd_modal").length) {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').append('<div id=\'sd_modal\'></div>');

			if (!cantRemove) {
				__WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').on('click', '#sd_modal', function () {});
			}
		}
		fn[type](content);
	}
});

__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.fn.extend({
	replace: function replace() {
		var that = this,
		    args = arguments,
		    argCount = args.length;
		if (!argCount || argCount > 2) {
			throw new Error('jqEx -------> arguments error!!!');
		}
		if (argCount === 2) {
			return that.each(function () {
				__WEBPACK_IMPORTED_MODULE_1_jquery___default()(args[0], that).empty().append(args[1]);
			});
		} else {
			return that.each(function () {
				__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).empty().append(args[0]);
			});
		}
	},
	switchClass: function switchClass(str) {
		this.addClass(str).siblings().removeClass(str);
		return this;
	},
	switchShow: function switchShow() {
		this.show().siblings().hide();
	},

	item: function item(key) {
		if (this.attr(key)) return this;
		return this.parents('[' + key + ']:first');
	},

	itemId: function itemId(key) {
		if (this.attr(key)) return this.attr(key);
		return this.parents('[' + key + ']:first').attr(key);
	},

	tips: function tips(content, direction) {
		__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.ui-tips').remove();
		if (!content) return;

		var temp = '<div class="ui-tips ui-tips-bottom ui-tips-x-center ui-tips-price-grid" style="z-index: 999;">\n\t\t\t\t\t\t<div class="ui-tips-main">' + content + '</div>\n\t\t\t\t\t\t<span class="ui-tips-arrow" style="z-index:999"></span>\n\t\t\t\t\t</div>';
		this.each(function (i) {
			var tips = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(temp),
			    $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
			    height = $this.height(),
			    offset = $this.offset();
			tips.appendTo('body');
			if (!direction || direction == 'top') tips.css({ 'z-index': 999, top: offset.top - tips.height() - 5 + 'px', 'left': offset.left + ($this.width() - tips.width()) / 2 + 'px' });else if (direction == 'bottom') tips.addClass('rotate').css({ 'z-index': 999, top: offset.top + height + 10 + 'px', 'left': offset.left + ($this.width() - tips.width()) / 2 + 'px' });else if (direction == 'right') tips.addClass('point-right').css({ 'z-index': 999, top: offset.top + ($this.height() - tips.height()) / 2 - 5 + 'px', 'left': offset.left - tips.width() - 20 + 'px' });
		});
	},

	overflowHidden: function overflowHidden(rows, lineHeight) {
		var that = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
		var maxHeight = lineHeight * rows;
		var text = that.text();
		var len = text.length;
		var temp = "",
		    slen,
		    tempStr;
		if (that.height() < maxHeight) {
			return;
		} else {
			that.text('');
			var i = 0;
			while (that.height() < maxHeight) {
				temp += text.substring(0, i + 1);
				that.text(temp);
				i++;
			}
		}
		slen = temp.length;
		tempStr = temp.substring(0, slen);
		that.text(tempStr + "...");
		that.height = maxHeight + 'px';
	}
});

!function (window) {
	var ua = window.navigator.userAgent.toLowerCase(),
	    reg = /msie|applewebkit.+safari/;
	if (reg.test(ua)) {
		var _sort = Array.prototype.sort;
		Array.prototype.sort = function (fn) {
			if (!!fn && typeof fn === 'function') {
				if (this.length < 2) return this;
				var i = 0,
				    j = i + 1,
				    l = this.length,
				    tmp,
				    r = false,
				    t = 0;
				for (; i < l; i++) {
					for (j = i + 1; j < l; j++) {
						t = fn.call(this, this[i], this[j]);
						r = (typeof t === 'number' ? t : !!t ? 1 : 0) > 0 ? true : false;
						if (r) {
							tmp = this[i];
							this[i] = this[j];
							this[j] = tmp;
						}
					}
				}
				return this;
			} else {
				return _sort.call(this);
			}
		};
	}
}(window);

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_data_options__ = __webpack_require__(456);




var API = __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].api(['GETCUSTOMERINFO', 'FINDMYORDER', 'SINGLECREATEORDER', 'IMPROPERCREATEORDER', 'FINDMYAUDITION', 'GETCONTRIBUTIONBYID', 'GETSTATISTICSBYCUSTOMERSEARCH', 'WAITERADDINVOICEAPPLY', 'SIGNIN', 'SEARCHPAYRECORD', 'GETINFOCOUNT']);

var state = {
  log: '',
  userInfo: {},
  isSingin: false,
  amount: 0,
  options: __WEBPACK_IMPORTED_MODULE_3__service_data_options__["a" /* default */],

  soundData: {},
  playingItem: {},

  payOrders: [],

  invoiceOrders: [],

  invoicePays: []
};

var mutations = {
  GETUSERINFO: function GETUSERINFO(state, payload) {
    window.USERINFO = payload.data;
    state.userInfo = payload.data;
  },
  SIGNIN: function SIGNIN(state, payload) {
    state.isSingin = true;
  },
  LOG: function LOG(state, data) {
    state.log = data;
  },
  SOUNDDATA: function SOUNDDATA(state, payload) {
    state.soundData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.soundData, payload);
  },
  PAYORDERS: function PAYORDERS(state, data) {
    state.payOrders = data;
  },
  INVOICEORDERS: function INVOICEORDERS(state, data) {
    state.invoiceOrders = data;
  },
  INVOICEPAYS: function INVOICEPAYS(state, data) {
    state.invoicePays = data;
  },
  AMOUNT: function AMOUNT(state, data) {
    state.amount = data || 0;
  }
};

var actions = {
  log: function log(_ref, _log) {
    var commit = _ref.commit,
        state = _ref.state;

    commit('LOG', _log);
  },
  getUserInfo: function getUserInfo(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.GETCUSTOMERINFO, {}, function (json) {
        var res = {
          type: 'GETUSERINFO',
          data: json.data
        };

        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].cookie.set('userName', res.data.userPetname || '深度会员');
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].cookie.set('userHead', res.data.userHead);
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].cookie.set('baseId', res.data.baseId);
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].setCollectCookie(res.data.collectMap);
        __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].getCollectCookie();
        commit(res);
        resolve(res);
      });
    });
  },
  getOrderList: function getOrderList(_ref3, param) {
    var commit = _ref3.commit,
        state = _ref3.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.FINDMYORDER, param, function (json) {
        var res = {
          type: 'GETORDERLIST',
          data: json.data
        };
        resolve(res);
      });
    });
  },
  signin: function signin(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.SIGNIN, {}, function (json) {
        var res = {
          type: 'SIGNIN',
          data: json.data
        };
        resolve(res);
      });
    });
  },
  addSoundData: function addSoundData(_ref5, datas) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var data = {};
    datas.forEach(function (d) {
      data[d.voiceId] = { id: d.voiceId,
        audio: d.filePath,
        img: d.deployDubbing ? d.deployDubbing.dubbingHead : '',
        dubbingName: d.nameExternal,
        dubbingId: d.dubbingId,
        title: d.voiceTitle };
    });
    commit('SOUNDDATA', data);
  },
  updateMessageAmount: function updateMessageAmount(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var id = state.userInfo.baseId;
    if (id) {
      __WEBPACK_IMPORTED_MODULE_2__service_util__["a" /* util */].kAjax(API.GETINFOCOUNT, { userId: id }, function (json) {
        commit('AMOUNT', json.data || 0);
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_util__ = __webpack_require__(5);


var OSS = "https://sd235.oss-cn-shanghai.aliyuncs.com/";
var API = __WEBPACK_IMPORTED_MODULE_1__service_util__["a" /* util */].api(["ADDPLAYCOUNT"]);

var timer = undefined;
function hasClass(obj, cls) {
  return obj.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

var audioInfo = {
  state: {
    player: "",

    audio: {
      voiceId: "",
      filePath: "",
      voiceTitle: "",
      deployDubbing: {
        dubbingHead: ""
      }
    },

    audioIds: {},

    audioDatas: {},

    isPlaying: false,

    isWaiting: false,

    currentIndex: 0,

    playType: 1,

    currentTime: 0,

    musicDuration: 0,

    musicLoadStart: false,

    isUnfold: false
  },
  getters: {
    getEl: function getEl(state) {
      return state.el;
    },
    getIsPlaying: function getIsPlaying(state) {
      return state.isPlaying;
    },
    getIsWaiting: function getIsWaiting(state) {
      return state.isWaiting;
    },
    getCurrentIndex: function getCurrentIndex(state) {
      return state.currentIndex;
    },
    getPlayType: function getPlayType(state) {
      return state.playType;
    },
    getCurrentTime: function getCurrentTime(state) {
      return state.currentTime;
    },
    getMusicDuration: function getMusicDuration(state) {
      return state.duration;
    },
    getMusicLoadStart: function getMusicLoadStart(state) {
      return state.musicLoadStart;
    },
    getPlayingItem: function getPlayingItem(state) {
      var res = {
        voiceId: state.audio.voiceId,
        voiceImg: state.audio.deployDubbing.dubbingHead ? __WEBPACK_IMPORTED_MODULE_1__service_util__["a" /* util */].imgPath(state.audio.deployDubbing.dubbingHead) : "/static/global_player.png",
        isPlaying: state.isPlaying,
        isWaiting: state.isWaiting,
        voiceTitle: state.audio.voiceTitle,
        isUnfold: state.isUnfold
      };
      return res;
    }
  },
  mutations: {
    _initPlayer: function _initPlayer(state, el) {
      state.player = el;
    },
    _onPlaying: function _onPlaying(state) {
      state.isPlaying = true;
    },
    _onPause: function _onPause(state) {
      state.isPlaying = false;
    },
    _onWaiting: function _onWaiting(state) {
      state.isWaiting = true;
    },
    _onCanplay: function _onCanplay(state) {
      state.isWaiting = false;
    },
    _setUnfold: function _setUnfold(state, bool) {
      state.isUnfold = bool;
    },
    _play: function _play(state) {
      state.isPlaying = true;
      state.player.play();
    },
    _pause: function _pause(state) {
      state.isPlaying = false;
      state.player.pause();
    },
    _togglePlay: function _togglePlay(state) {
      if (state.isPlaying) {
        state.isPlaying = false;
        state.player.pause();
      } else {
        state.isPlaying = true;
        state.player.play();
      }
    },
    _addAudioDatas: function _addAudioDatas(state, datas) {
      state.audioDatas = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.audioDatas, datas);
    },
    _updatePlayerInfo: function _updatePlayerInfo(state, audioInfo) {
      state.currentTime = audioInfo.currentTime;
      state.duration = audioInfo.duration;
    },
    _addPlayCount: function _addPlayCount(state, id) {
      __WEBPACK_IMPORTED_MODULE_1__service_util__["a" /* util */].kAjax(API.ADDPLAYCOUNT, { id: id });
    },
    playEnd: function playEnd(state) {}
  },
  actions: {
    initPlayer: function initPlayer(_ref, el) {
      var commit = _ref.commit,
          state = _ref.state;

      commit("_initPlayer", el);
    },
    addAudioDatas: function addAudioDatas(_ref2, datas) {
      var commit = _ref2.commit,
          state = _ref2.state;

      !datas.length && (datas = [datas]);
      var res = {};
      datas.forEach(function (d, i) {
        res[d.voiceId] = d;
      });
      commit("_addAudioDatas", res);
    },
    playById: function playById(_ref3, id) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var interval = 3500;
      commit("_setUnfold", true);
      timer && clearTimeout(timer);
      timer = setTimeout(function () {
        commit("_setUnfold", false);
      }, interval);

      if (!id) {
        if (!state.audio.voiceId) {
          return;
        }
        commit("_togglePlay");
        return;
      }

      if (state.audio.voiceId == id) {
        commit("_togglePlay");
        return;
      }

      var data = state.audioDatas[id];
      if (data) {
        state.audio = data;
        state.player.setAttribute("src", OSS + state.audio.filePath);
        commit("_play");
        commit("_addPlayCount", id);
      } else {
        console.warn("未找到声音id:" + id);
      }
    },
    playByItem: function playByItem(state, item) {}
  }
};

/* harmony default export */ __webpack_exports__["a"] = (audioInfo);

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return util; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_api_js__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_superagent__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);









var util = {
  getAPI: function getAPI(arg) {
    return util.api(arg);
  },
  api: function api(arg) {
    if (typeof arg == 'string') return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_api_js__["a" /* getAPI */])(arg);
    if ((typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(arg)) == 'object') {
      var apis = {};
      apis['OSS'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_api_js__["b" /* getOSS */])('');
      apis['IMG'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_api_js__["c" /* getIMG */])('');
      apis['PRE'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_api_js__["d" /* getPREIMG */])('');
      for (var i in arg) {
        apis[arg[i]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_api_js__["a" /* getAPI */])(arg[i]);
      }
      return apis;
    }
  },
  apis: function apis() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_api_js__["e" /* allAPI */])();
  },
  imgPath: function imgPath(path) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_api_js__["c" /* getIMG */])(path);
  },
  preImgPath: function preImgPath(path) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_api_js__["d" /* getPREIMG */])(path);
  },
  getOSS: function getOSS() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_api_js__["b" /* getOSS */])();
  },

  back: function back() {
    if (window.$pageCount) {
      this.$router.back(-1);
    } else {
      this.$router.push({
        name: 'HomeView'
      });
    }
  },
  cookie: {
    set: function set(key, value, day) {
      var Days = day || 3;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      document.cookie = key + '=' + escape(value + '') + ';expires=' + exp.toGMTString() + ';path=/';
    },
    get: function get(key) {
      var arr,
          reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');

      if (arr = document.cookie.match(reg)) {
        return unescape(arr[2]);
      } else {
        return null;
      }
    },
    delete: function _delete(key) {
      if (!key) {
        util.cookie.deleteAll();
        return;
      }
      var exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval = this.get(key);
      if (cval != null) {
        document.cookie = key + '=' + cval + ';expires=' + exp.toGMTString() + ';path=/';
      }
    },
    deleteAll: function deleteAll() {
      var myDate = new Date();
      myDate.setTime(-1000);
      var data = document.cookie;
      var dataArray = data.split('; ');
      for (var i = 0; i < dataArray.length; i++) {
        var varName = dataArray[i].split('=');
        document.cookie = varName[0] + "='';expires=" + myDate.toGMTString() + ';path=/';
      }
    }
  },

  copy: function copy(obj) {
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj));
  },

  parseURLParam: function parseURLParam(param) {
    var _res = parse(param);
    function parse(param, prefix) {
      var res = res || '';
      prefix = prefix || '';
      for (var key in param) {
        var d = param[key];
        switch (typeof d === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(d)) {
          case 'string':
            {
              if (prefix) {
                res += prefix + '[' + key + ']' + '=' + d + '&';
              } else {
                res += key + '=' + d + '&';
              }
            }
            break;

          case 'object':
            {
              if (d.length != undefined) {
                for (var i in d) {
                  var _d = d[i];
                  if (prefix) {
                    res += prefix + '[' + key + ']' + '[]=' + _d + '&';
                  } else {
                    res += key + '[]=' + _d + '&';
                  }
                }
              } else {
                res += parse(d, key);
              }
            }
            break;
          default:
            {
              if (prefix) {
                res += prefix + '[' + key + ']' + '=' + d + '&';
              } else {
                res += key + '=' + d + '&';
              }
            }
            break;
        }
      }
      return res;
    }
    return _res ? _res.substr(0, _res.length - 1) : '';
  },

  removeEmpty: function removeEmpty(param) {
    if (param) {
      for (var k in param) {
        if (param[k] === '') {
          delete param[k];
        }
        for (var j in param[k]) {
          if (param[k][j] === '') {
            delete param[k][j];
          }
        }
      }
    }
    return param;
  },
  kAjax: function kAjax(url, _param, success, error, noAlert) {
    var param = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_param));
    param = util.removeEmpty(param);
    if (!url) {
      console.warn('kAjax : 参数 url 未定义！');
      return;
    }

    window.requestCount = window.requestCount || 1;
    __WEBPACK_IMPORTED_MODULE_5_superagent___default.a.post(url).withCredentials().type('form').send(this.parseURLParam(param)).end(function (err, res) {
      if (err) {
        console.warn('请求错误 - ', url, param);
        return;
      }
      var json = JSON.parse(res.text);

      if (json.status == 4) {
        error && error();

        __WEBPACK_IMPORTED_MODULE_4__auth_js__["auth"].pop_login();
        return;
      }
      if (json.status == 1) {
        success && success(json);
      } else {
        error && error(json.message);
        !noAlert && util.confirm.error(json.message);
        console.warn('error:', json.message);
      }
    });
  },

  getCollectCookie: function getCollectCookie() {
    window.collectMap = {
      1: getIds(util.cookie.get('COLLECT_DUBBER_IDS')),
      2: getIds(util.cookie.get('COLLECT_VOICE_IDS')),
      3: getIds(util.cookie.get('COLLECT_ALBUM_IDS'))
    };
    function getIds(src) {
      if (!src) {
        return [];
      } else {
        return src.split(',');
      }
    }
  },
  setCollectCookie: function setCollectCookie(collectMap) {
    if (!collectMap) {
      util.cookie.delete('COLLECT_DUBBER_IDS');
      util.cookie.delete('COLLECT_VOICE_IDS');
      util.cookie.delete('COLLECT_ALBUM_IDS');
      return;
    }
    util.cookie.set('COLLECT_DUBBER_IDS', collectMap['1'].join(','));
    util.cookie.set('COLLECT_VOICE_IDS', collectMap['2'].join(','));
    util.cookie.set('COLLECT_ALBUM_IDS', collectMap['3'].join(','));
  },
  updateCollectCookie: function updateCollectCookie(typeId, _id, act) {
    _id = (typeof _id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_id)) != 'object' ? [_id] : _id;
    _id.forEach(function (id) {
      if (act == 'remove') {
        var index = window.collectMap[typeId].indexOf(id + '');
        if (index > -1) {
          window.collectMap[typeId].splice(index, 1);
        }
      } else {
        window.collectMap[typeId].push(id);
      }
    });
    util.setCollectCookie(window.collectMap);
  },
  toCSV: function toCSV(jsonData, titles, name) {
    var json = (typeof jsonData === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(jsonData)) != 'object' ? JSON.parse(jsonData) : jsonData;
    var CSV = '';

    if (titles) {
      var row = '';
      for (var i in titles) {
        row += titles[i] + ',';
      }
      row = row.slice(0, -1);
      CSV += row + '\n';
    }

    for (var i in json) {
      var row = '';
      var r = json[i];
      for (var j in r) {
        row += '"' + (!isNaN(r[j]) && (r[j] + '').length > 12 ? "'" : '') + r[j] + '",';
      }
      row = row.slice(0, -1);
      CSV += row + '\n';
    }
    CSV = CSV.replace(/\undefined/g, '-');
    if (CSV == '') {
      util.confirm.error('操作错误', '导出失败,表格内容不正确！');
      return;
    }
    var fileName = '';
    fileName += name.replace(/ /g, '_');
    CSV = encodeURIComponent(CSV);
    var uri = 'data:text/csv;charset=utf-8,\uFEFF' + CSV;
    var link = document.createElement('a');
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(link).attr('href', uri).css('visibility', 'hidden').attr('download', fileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  bind_collect: function bind_collect() {
    util.getCollectCookie();
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('body').on('click', '[collect-dubber]', function (e) {
      util.doCollect(1, this);
    });
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('body').on('click', '[collect-voice]', function (e) {
      util.doCollect(2, this);
    });
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('body').on('click', '[collect-album]', function (e) {
      util.doCollect(3, this);
    });
  },
  jumpDetail: function jumpDetail(type, id) {
    if (!id) {
      return;
    }
    var name = '';
    if (type == 'dubber') {
      name = 'DetailDubberView';
    } else {
      name = 'DetailVoiceView';
    }
    this.$router.push({
      name: name,
      params: { id: id }
    });
  },
  addSoundData: function addSoundData(datas) {
    var data = {};
    datas.forEach(function (d) {
      if (!d.voiceId) {
        data[d.id] = {
          id: d.id,

          audio: 'https://transaction.oss-cn-shanghai.aliyuncs.com/' + d.auditionServerPath,
          img: '',
          dubbingName: d.auditionDubboNum,
          dubbingId: d.auditionDubboId,
          title: d.auditionName
        };
      } else {
        data[d.voiceId] = {
          id: d.voiceId,
          audio: d.filePath,
          img: d.deployDubbing ? d.deployDubbing.dubbingHead : '',
          dubbingName: d.nameExternal,
          dubbingId: d.dubbingId,
          title: d.voiceTitle
        };
      }
    });
    gPlayer.soundData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gPlayer.soundData, data);
  },

  logout: function logout() {
    util.cookie.delete('userName');

    util.setCollectCookie();
    util.kAjax(util.api('LOGINOUT'), {});
    setTimeout(function () {
      location.reload(true);
    });
  },

  popIM: function popIM() {
    var list = '<li><a data-base-id="1" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=1&userPetname=\u6DF1\u5EA67\u53F7">\u6DF1\u5EA67\u53F7</a></li>\n\t\t\t\t   <li><a data-base-id="2" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=2&userPetname=\u6DF1\u5EA68\u53F7">\u6DF1\u5EA68\u53F7</a></li>\n\t\t\t\t   <li><a data-base-id="3" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=3&userPetname=\u6DF1\u5EA62\u53F7">\u6DF1\u5EA62\u53F7</a></li>\n\t\t\t\t    <li><a data-base-id="4" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=4&userPetname=\u6DF1\u5EA65\u53F7">\u6DF1\u5EA65\u53F7</a></li>\n\t\t\t\t   <li><a data-base-id="5" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=4110&userPetname=\u6DF1\u5EA63\u53F7">\u6DF1\u5EA63\u53F7</a></li>\n\t\t\t\t   <li><a data-base-id="6" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=11612&userPetname=\u6DF1\u5EA626\u53F7">\u6DF1\u5EA626\u53F7</a></li>\n\t\t\t\t   <li><a data-base-id="7" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=6138&userPetname=\u6DF1\u5EA618\u53F7">\u6DF1\u5EA618\u53F7</a></li>\n\t\t\t\t   <li><a data-base-id="8" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=3746&userPetname=\u6DF1\u5EA610\u53F7">\u6DF1\u5EA610\u53F7</a></li>\n\t\t\t\t   <li><a data-base-id="9" target="_blank" data-im-href="http://www.sd235.net/sdchat.html?baseId=11613&userPetname=\u6DF1\u5EA627\u53F7">\u6DF1\u5EA627\u53F7</a></li>\n\t\t\t\t\n\t\t\t\t';

    var dom = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(list);
    setInterval(update, 550000);
    update();
    function update() {
      util.kAjax(util.api('ONLINEWAITERLIST'), {}, function (json) {
        var data = json.data || [];
        dom.find('[data-base-id]').removeClass('online');
        __WEBPACK_IMPORTED_MODULE_7_jquery___default.a.each(data, function (i, d) {
          var t = dom.find('[data-base-id=' + d.baseId + ']');
          t.addClass('online');
        });
      });
    }

    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('body').on('mouseenter', '.kf_btn', function () {
      var wrap = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this).find('ul');
      wrap.replace(dom);
    });

    __WEBPACK_IMPORTED_MODULE_7_jquery___default()('body').on('click', '[data-im-href]', function () {
      var $this = __WEBPACK_IMPORTED_MODULE_7_jquery___default()(this),
          href = $this.attr('data-im-href'),
          win = window.open();
      win.location.href = href;
    });
  },

  publicEvent: function publicEvent() {
    util.popIM();
  }
};

util.publicEvent();
window.util = util;


/***/ }),

/***/ 750:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 751:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 752:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 753:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 759:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 761:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 762:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 768:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 769:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 770:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 771:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 772:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 773:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 774:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 775:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 235,
	"./af.js": 235,
	"./ar": 243,
	"./ar-dz": 236,
	"./ar-dz.js": 236,
	"./ar-kw": 237,
	"./ar-kw.js": 237,
	"./ar-ly": 238,
	"./ar-ly.js": 238,
	"./ar-ma": 239,
	"./ar-ma.js": 239,
	"./ar-ps": 240,
	"./ar-ps.js": 240,
	"./ar-sa": 241,
	"./ar-sa.js": 241,
	"./ar-tn": 242,
	"./ar-tn.js": 242,
	"./ar.js": 243,
	"./az": 244,
	"./az.js": 244,
	"./be": 245,
	"./be.js": 245,
	"./bg": 246,
	"./bg.js": 246,
	"./bm": 247,
	"./bm.js": 247,
	"./bn": 249,
	"./bn-bd": 248,
	"./bn-bd.js": 248,
	"./bn.js": 249,
	"./bo": 250,
	"./bo.js": 250,
	"./br": 251,
	"./br.js": 251,
	"./bs": 252,
	"./bs.js": 252,
	"./ca": 253,
	"./ca.js": 253,
	"./cs": 254,
	"./cs.js": 254,
	"./cv": 255,
	"./cv.js": 255,
	"./cy": 256,
	"./cy.js": 256,
	"./da": 257,
	"./da.js": 257,
	"./de": 260,
	"./de-at": 258,
	"./de-at.js": 258,
	"./de-ch": 259,
	"./de-ch.js": 259,
	"./de.js": 260,
	"./dv": 261,
	"./dv.js": 261,
	"./el": 262,
	"./el.js": 262,
	"./en-au": 263,
	"./en-au.js": 263,
	"./en-ca": 264,
	"./en-ca.js": 264,
	"./en-gb": 265,
	"./en-gb.js": 265,
	"./en-ie": 266,
	"./en-ie.js": 266,
	"./en-il": 267,
	"./en-il.js": 267,
	"./en-in": 268,
	"./en-in.js": 268,
	"./en-nz": 269,
	"./en-nz.js": 269,
	"./en-sg": 270,
	"./en-sg.js": 270,
	"./eo": 271,
	"./eo.js": 271,
	"./es": 275,
	"./es-do": 272,
	"./es-do.js": 272,
	"./es-mx": 273,
	"./es-mx.js": 273,
	"./es-us": 274,
	"./es-us.js": 274,
	"./es.js": 275,
	"./et": 276,
	"./et.js": 276,
	"./eu": 277,
	"./eu.js": 277,
	"./fa": 278,
	"./fa.js": 278,
	"./fi": 279,
	"./fi.js": 279,
	"./fil": 280,
	"./fil.js": 280,
	"./fo": 281,
	"./fo.js": 281,
	"./fr": 284,
	"./fr-ca": 282,
	"./fr-ca.js": 282,
	"./fr-ch": 283,
	"./fr-ch.js": 283,
	"./fr.js": 284,
	"./fy": 285,
	"./fy.js": 285,
	"./ga": 286,
	"./ga.js": 286,
	"./gd": 287,
	"./gd.js": 287,
	"./gl": 288,
	"./gl.js": 288,
	"./gom-deva": 289,
	"./gom-deva.js": 289,
	"./gom-latn": 290,
	"./gom-latn.js": 290,
	"./gu": 291,
	"./gu.js": 291,
	"./he": 292,
	"./he.js": 292,
	"./hi": 293,
	"./hi.js": 293,
	"./hr": 294,
	"./hr.js": 294,
	"./hu": 295,
	"./hu.js": 295,
	"./hy-am": 296,
	"./hy-am.js": 296,
	"./id": 297,
	"./id.js": 297,
	"./is": 298,
	"./is.js": 298,
	"./it": 300,
	"./it-ch": 299,
	"./it-ch.js": 299,
	"./it.js": 300,
	"./ja": 301,
	"./ja.js": 301,
	"./jv": 302,
	"./jv.js": 302,
	"./ka": 303,
	"./ka.js": 303,
	"./kk": 304,
	"./kk.js": 304,
	"./km": 305,
	"./km.js": 305,
	"./kn": 306,
	"./kn.js": 306,
	"./ko": 307,
	"./ko.js": 307,
	"./ku": 309,
	"./ku-kmr": 308,
	"./ku-kmr.js": 308,
	"./ku.js": 309,
	"./ky": 310,
	"./ky.js": 310,
	"./lb": 311,
	"./lb.js": 311,
	"./lo": 312,
	"./lo.js": 312,
	"./lt": 313,
	"./lt.js": 313,
	"./lv": 314,
	"./lv.js": 314,
	"./me": 315,
	"./me.js": 315,
	"./mi": 316,
	"./mi.js": 316,
	"./mk": 317,
	"./mk.js": 317,
	"./ml": 318,
	"./ml.js": 318,
	"./mn": 319,
	"./mn.js": 319,
	"./mr": 320,
	"./mr.js": 320,
	"./ms": 322,
	"./ms-my": 321,
	"./ms-my.js": 321,
	"./ms.js": 322,
	"./mt": 323,
	"./mt.js": 323,
	"./my": 324,
	"./my.js": 324,
	"./nb": 325,
	"./nb.js": 325,
	"./ne": 326,
	"./ne.js": 326,
	"./nl": 328,
	"./nl-be": 327,
	"./nl-be.js": 327,
	"./nl.js": 328,
	"./nn": 329,
	"./nn.js": 329,
	"./oc-lnc": 330,
	"./oc-lnc.js": 330,
	"./pa-in": 331,
	"./pa-in.js": 331,
	"./pl": 332,
	"./pl.js": 332,
	"./pt": 334,
	"./pt-br": 333,
	"./pt-br.js": 333,
	"./pt.js": 334,
	"./ro": 335,
	"./ro.js": 335,
	"./ru": 336,
	"./ru.js": 336,
	"./sd": 337,
	"./sd.js": 337,
	"./se": 338,
	"./se.js": 338,
	"./si": 339,
	"./si.js": 339,
	"./sk": 340,
	"./sk.js": 340,
	"./sl": 341,
	"./sl.js": 341,
	"./sq": 342,
	"./sq.js": 342,
	"./sr": 344,
	"./sr-cyrl": 343,
	"./sr-cyrl.js": 343,
	"./sr.js": 344,
	"./ss": 345,
	"./ss.js": 345,
	"./sv": 346,
	"./sv.js": 346,
	"./sw": 347,
	"./sw.js": 347,
	"./ta": 348,
	"./ta.js": 348,
	"./te": 349,
	"./te.js": 349,
	"./tet": 350,
	"./tet.js": 350,
	"./tg": 351,
	"./tg.js": 351,
	"./th": 352,
	"./th.js": 352,
	"./tk": 353,
	"./tk.js": 353,
	"./tl-ph": 354,
	"./tl-ph.js": 354,
	"./tlh": 355,
	"./tlh.js": 355,
	"./tr": 356,
	"./tr.js": 356,
	"./tzl": 357,
	"./tzl.js": 357,
	"./tzm": 359,
	"./tzm-latn": 358,
	"./tzm-latn.js": 358,
	"./tzm.js": 359,
	"./ug-cn": 360,
	"./ug-cn.js": 360,
	"./uk": 361,
	"./uk.js": 361,
	"./ur": 362,
	"./ur.js": 362,
	"./uz": 364,
	"./uz-latn": 363,
	"./uz-latn.js": 363,
	"./uz.js": 364,
	"./vi": 365,
	"./vi.js": 365,
	"./x-pseudo": 366,
	"./x-pseudo.js": 366,
	"./yo": 367,
	"./yo.js": 367,
	"./zh-cn": 368,
	"./zh-cn.js": 368,
	"./zh-hk": 369,
	"./zh-hk.js": 369,
	"./zh-mo": 370,
	"./zh-mo.js": 370,
	"./zh-tw": 371,
	"./zh-tw.js": 371
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 786;

/***/ }),

/***/ 810:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTMyIDc5LjE1OTI4NCwgMjAxNi8wNC8xOS0xMzoxMzo0MCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjY4OEE5NkM3OUEzMTFFN0FCQjhCQzk1Nzk1MkVBMTAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjY4OEE5NkQ3OUEzMTFFN0FCQjhCQzk1Nzk1MkVBMTAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGNjg4QTk2QTc5QTMxMUU3QUJCOEJDOTU3OTUyRUExMCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGNjg4QTk2Qjc5QTMxMUU3QUJCOEJDOTU3OTUyRUExMCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pg+xf4MAAABCSURBVHjaYmBgYKhlwA18QMRyID6HRbIciG/DONOA+DSa5CMg5mFEEpwCxDJAfByIk4BYH4h/oBvbBsT3kAUAAgwAJ/MKvPT9adwAAAAASUVORK5CYII="

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(772)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(871),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(847),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(757)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(844),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(771)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(870),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(850),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(846),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(842),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(763)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(858),
  /* scopeId */
  "data-v-4246c61d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(865),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(856),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(845),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(768)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(866),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(762)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(857),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(853),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(760)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(852),
  /* scopeId */
  "data-v-29c2dd1e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(773)
__webpack_require__(774)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(874),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(758)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(849),
  /* scopeId */
  "data-v-1a419c91",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(770)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(869),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(867),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(872),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(855),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(873),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(861),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(863),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(848),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(756)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(843),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 841:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer_ai"
  }, [_c('p', [_vm._v("相关链接： "), _c('a', {
    attrs: {
      "href": "/contact_us/company_produce",
      "target": "_blank"
    }
  }, [_vm._v("关于我们")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "/contact_us/contact_us",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")]), _vm._v("\n        | "), _c('a', {
    attrs: {
      "href": "/contact_us/safety-payment",
      "target": "_blank"
    }
  }, [_vm._v("汇款账号")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "http://sc.sd235.com/",
      "target": ""
    }
  }, [_vm._v("免费素材")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "/APP",
      "target": "_blank"
    }
  }, [_vm._v("APP下载")])]), _vm._v(" "), _c('p', [_vm._v("业务部总机： 028-8664-1863 值班人员手机：136-9964-5470")]), _vm._v(" "), _c('p', [_vm._v("蜀ICP备14021078号-1 | 川公网安备51010602000255号")])])
}]}

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-view right_auth"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('ul', {
    staticClass: "genre"
  }, [_c('li', [_vm._v("\n                " + _vm._s(_vm.genreSelected.label) + "\n                "), _c('img', {
    attrs: {
      "src": __webpack_require__(810),
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "choose"
  }, _vm._l((_vm.genre), function(ge) {
    return _c('li', {
      class: {
        on: ge == _vm.genreSelected
      },
      on: {
        "click": function($event) {
          return _vm.genreChange(ge)
        }
      }
    }, [_vm._v(_vm._s(ge.label))])
  }), 0)]), _vm._v(" "), _vm._l((_vm.time), function(ti) {
    return _c('li', {
      class: {
        on: ti.change == _vm.timeSelected.change
      },
      on: {
        "click": function($event) {
          return _vm.timeChange(ti.change)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(ti.change.label))])])
  })], 2), _vm._v(" "), (_vm.timeSelected.data.length) ? _c('div', [(_vm.genreSelected.type == 1) ? _c('ul', {
    staticClass: "list coupon"
  }, _vm._l((_vm.timeSelected.data), function(da) {
    return _c('li', {
      class: {
        now: _vm.timeSelected.change.type == 1 && _vm.diff(da.discountStartTime, da.discountEndTime),
        gray: _vm.timeSelected.change.type == 4 || !_vm.usable
      }
    }, [_c('div', {
      staticClass: "top"
    }, [(_vm.timeSelected.change.type == 1 && _vm.diff(da.discountStartTime, da.discountEndTime)) ? _c('p', {
      staticClass: "type"
    }, [_vm._v("即将到期")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "money"
    }, [_c('span', [_vm._v("￥")]), _vm._v(_vm._s(da.discountAmount))]), _vm._v(" "), _c('p', {
      staticClass: "condition"
    }, [_vm._v("【满" + _vm._s(da.discountDoorsill) + "可用】")]), _vm._v(" "), _c('p', {
      staticClass: "range"
    }, [_vm._v(_vm._s(_vm._f("time")(da.discountStartTime)) + "-" + _vm._s(_vm._f("time")(da.discountEndTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "bottom"
    }, [_c('p', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (da.discountDescription || ''),
        expression: "da.discountDescription||''"
      }],
      staticClass: "limit"
    }, [_vm._v(_vm._s(da.discountDescription || ' '))]), _vm._v(" "), (_vm.usable) ? _c('button', {
      attrs: {
        "onclick": "service.creatOrder()"
      }
    }, [_vm._v("立即使用")]) : _c('button', [_vm._v("无法使用")])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.genreSelected.type == 2) ? _c('ul', {
    staticClass: "list fullcut"
  }, _vm._l((_vm.timeSelected.data), function(da) {
    return _c('li', {
      class: {
        now: _vm.timeSelected.change.type == 1 && _vm.diff(da.discountStartTime, da.discountEndTime),
        gray: _vm.timeSelected.change.type == 4
      }
    }, [_c('div', {
      staticClass: "top"
    }, [(_vm.timeSelected.change.type == 1 && _vm.diff(da.discountStartTime, da.discountEndTime)) ? _c('p', {
      staticClass: "type"
    }, [_vm._v("即将到期")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "money"
    }, [_c('span', [_vm._v("￥")]), _vm._v(_vm._s(da.discountAmount))]), _vm._v(" "), (da.discountType == 1) ? _c('p', {
      staticClass: "condition"
    }, [_vm._v("【满" + _vm._s(da.discountDoorsill) + "可用】")]) : _c('p', {
      staticClass: "condition"
    }, [_vm._v("【全平台】")]), _vm._v(" "), _c('p', {
      staticClass: "range"
    }, [_vm._v(_vm._s(_vm._f("time")(da.discountStartTime)) + "-" + _vm._s(_vm._f("time")(da.discountEndTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "bottom"
    }, [_c('p', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (da.discountDescription || ''),
        expression: "da.discountDescription||''"
      }],
      staticClass: "limit"
    }, [_vm._v(_vm._s(da.discountDescription || ' '))]), _vm._v(" "), (_vm.usable) ? _c('button', {
      attrs: {
        "onclick": "service.creatOrder()"
      }
    }, [_vm._v("立即使用")]) : _c('button', [_vm._v("无法使用")])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page_wrap"
  }, [_c('sd-pager', {
    ref: "pager",
    attrs: {
      "page-data": _vm.page
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.timeSelected.data.length) ? _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("没有相关优惠券~")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("优惠券")])])
}]}

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "withinOrdersPage"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "searchView"
  }, [_c('div', {
    staticClass: "cellLs"
  }, [_c('div', {
    staticClass: "cellWrap"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单时间：")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "270px"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions,
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.searchParam.dateType),
      callback: function($$v) {
        _vm.$set(_vm.searchParam, "dateType", $$v)
      },
      expression: "searchParam.dateType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cellWrap"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("金额范围：")]), _vm._v(" "), _c('div', {
    staticClass: "rangeWrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParam.appointPriceBegin),
      expression: "searchParam.appointPriceBegin"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchParam.appointPriceBegin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchParam, "appointPriceBegin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParam.appointPriceEnd),
      expression: "searchParam.appointPriceEnd"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchParam.appointPriceEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchParam, "appointPriceEnd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popover"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.clearPrice()
      }
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.doSearch()
      }
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cellWrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParam.numberType),
      expression: "searchParam.numberType"
    }],
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchParam, "numberType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("老师编号")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("订单编号")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchParam.numberStr),
      expression: "searchParam.numberStr"
    }],
    staticClass: "input right",
    attrs: {
      "type": "text",
      "placeholder": _vm.searchParam.numberType === '4' ? '输入老师编号' : '输入订单编号'
    },
    domProps: {
      "value": (_vm.searchParam.numberStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchParam, "numberStr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cellWrap"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("客服id：")]), _vm._v(" "), _c('w-select', {
    attrs: {
      "placeholder": "输入客服id",
      "options": _vm.waiterOptions
    },
    model: {
      value: (_vm.searchParam.waiterId),
      callback: function($$v) {
        _vm.$set(_vm.searchParam, "waiterId", $$v)
      },
      expression: "searchParam.waiterId"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "searchHandle"
  }, [_c('button', {
    staticClass: "search",
    on: {
      "click": function($event) {
        return _vm.doSearch()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('button', {
    staticClass: "resat",
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v("重置")])])]), _vm._v(" "), _c('div', {
    staticClass: "searchFilter"
  }, [_c('ul', _vm._l((_vm.options.customerOrderType), function(item, idx) {
    return _c('li', {
      key: idx,
      class: {
        on: item.id == _vm.searchParam.customerOrderType
      },
      on: {
        "click": function($event) {
          return _vm.changeStatus(item.id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tableTools"
  }, [_c('div', [_c('button', {
    staticClass: "create",
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("新建订单")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.batchPay
    }
  }, [_vm._v("批量支付")])]), _vm._v(" "), _c('div', [_c('button', {
    attrs: {
      "disabled": _vm.page.pageNo <= 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.page.pageNo >= _vm.page.totalPage
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("下一页")])])]), _vm._v(" "), (_vm.fillData.datas && _vm.fillData.datas.length) ? _c('div', {
    staticClass: "mainTable"
  }, [_c('table', [_c('thead', [_c('tr', [_c('td', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelected),
      expression: "allSelected"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, "1") > -1 : (_vm.allSelected)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.allSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelected = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "name"
  }, [_vm._v("稿件名称")]), _vm._v(" "), _c('td', {
    staticClass: "dubber"
  }, [_vm._v("选定老师")]), _vm._v(" "), _c('td', {
    staticClass: "priced"
  }, [_vm._v("定价")]), _vm._v(" "), _c('td', {
    staticClass: "realPay"
  }, [_vm._v("实际付款")]), _vm._v(" "), _c('td', {
    staticClass: "status"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('td', {
    staticClass: "waiter"
  }, [_vm._v("客服")]), _vm._v(" "), _c('td', {
    staticClass: "duration"
  }, [_vm._v("时长")]), _vm._v(" "), _c('td', {
    staticClass: "handle"
  }, [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fillData.datas || []), function(item) {
    return [_c('tr', {
      key: 'interval_' + item.id,
      staticClass: "interval"
    }), _vm._v(" "), _c('tr', {
      key: item.id,
      staticClass: "orderTd"
    }, [_c('td', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.allSelected),
        expression: "allSelected"
      }],
      attrs: {
        "type": "checkbox",
        "value": "1"
      },
      domProps: {
        "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, "1") > -1 : (_vm.allSelected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.allSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "1",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.allSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.allSelected = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_c('span', {
      class: item.contributionId ? 'down-load' : '',
      on: {
        "click": function($event) {
          return _vm.downContribution(item)
        }
      }
    }, [_vm._v(_vm._s(item.contributionName) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "dubber"
    }, [_vm._v(_vm._s(item.dubboNum))]), _vm._v(" "), _c('td', {
      staticClass: "priced"
    }, [_vm._v(_vm._s(item.appointPrice))]), _vm._v(" "), _c('td', {
      staticClass: "realPay"
    }, [_vm._v(_vm._s(item.realityPrice))]), _vm._v(" "), _c('td', {
      staticClass: "status"
    }, [_c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ('已需求'),
        expression: "'已需求'"
      }],
      staticClass: "demand on"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'),
        expression: "item.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'"
      }],
      staticClass: "demo",
      class: {
        on: item.auditionIds
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.payId ? '已经支付订单费用' : '订单尚未支付'),
        expression: "item.payId ? '已经支付订单费用' : '订单尚未支付'"
      }],
      staticClass: "pay",
      class: {
        on: item.payId
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.productId || item.voiceLength ? '已经录制成品' : '尚未录制成品'),
        expression: "item.productId || item.voiceLength ? '已经录制成品' : '尚未录制成品'"
      }],
      staticClass: "finished",
      class: {
        on: item.productId || item.voiceLength
      }
    }), _vm._v(" "), (item.orderStatus == 10) ? _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ('已取消'),
        expression: "'已取消'"
      }],
      staticClass: "canceled"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "waiter"
    }, [_vm._v(_vm._s(item.waiterName))]), _vm._v(" "), _c('td', {
      staticClass: "duration"
    }, [_vm._v(_vm._s(item.voiceLength))]), _vm._v(" "), _c('td', {
      staticClass: "handle"
    }, [_c('div', [_c('div', [(_vm.canPay(item)) ? _c('button', {
      staticClass: "payBtn",
      on: {
        "click": function($event) {
          return _vm.singlePay(item)
        }
      }
    }, [_vm._v("立即支付")]) : _vm._e()]), _vm._v(" "), _c('div', [(item.auditionIds) ? _c('button', {
      on: {
        "click": function($event) {
          return _vm.lookVoiceList(item)
        }
      }
    }, [_vm._v("查看试音")]) : _vm._e()]), _vm._v(" "), (item.payId) ? _c('router-link', {
      staticClass: "discuss",
      attrs: {
        "to": {
          name: 'Discuss',
          query: {
            id: item.orderNum
          }
        }
      }
    }, [_vm._v(_vm._s(item.dubbingGrade ? '查看评论' : '评价订单'))]) : _vm._e()], 1)])])]
  })], 2)]), _vm._v(" "), (_vm.summation || _vm.summation === 0) ? _c('div', {
    staticClass: "summation"
  }, [_c('p', [_vm._v("\n          合计实付金额： "), _c('span', [_vm._v(_vm._s(_vm.summation))]), _vm._v("元\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table_footer_tools"
  }, [_c('button', {
    staticClass: "btn_g ghost",
    on: {
      "click": function($event) {
        return _vm.getStatistics()
      }
    }
  }, [_vm._v("查看合计")]), _vm._v(" "), _c('button', {
    staticClass: "btn_g ghost",
    on: {
      "click": function($event) {
        return _vm.getExcel()
      }
    }
  }, [_vm._v("导出本页表格")]), _vm._v(" "), _c('button', {
    staticClass: "btn_g ghost",
    on: {
      "click": _vm.getAllExcel
    }
  }, [_vm._v("导出所有表格")])]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap"
  }, [_c('app-page-ajax', {
    ref: "pager",
    attrs: {
      "page-data": _vm.page
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)]) : _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("没有检测到相关的订单~")])])]), _vm._v(" "), _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewVoice),
      expression: "viewVoice"
    }]
  }, [_c('div', {
    staticClass: "demo_voice_dialog"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        您的试音\n        "), _c('i', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.viewVoice = false
      }
    }
  })]), _vm._v(" "), _c('ul', _vm._l((_vm.voiceLists), function(vo, index) {
    return _c('li', {
      key: index,
      attrs: {
        "sound-id": vo.id
      }
    }, [_c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "dubber"
    }, [_vm._v(_vm._s(vo.auditionDubboNum + '号'))]), _vm._v(" "), _c('span', {
      staticClass: "voice",
      attrs: {
        "title": vo.auditionName
      }
    }, [_vm._v(_vm._s(vo.auditionName))]), _vm._v(" "), _c('i', {
      staticClass: "play sound-play"
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "viki_modal"
  }, [_c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.forHelp),
      expression: "forHelp"
    }]
  }, [_c('div', {
    staticClass: "viki"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.orderViki.first) ? _c('div', {
    staticClass: "first"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.orderViki.first = false;
        _vm.orderViki.second = true;
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.orderViki.second) ? _c('div', {
    staticClass: "second"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.orderViki.second = false;
        _vm.orderViki.third = true;
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.orderViki.third) ? _c('div', {
    staticClass: "third"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.orderViki.third = false;
        _vm.forHelp = false;
      }
    }
  })]) : _vm._e()])], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 844:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-view right_auth"
  }, [_c('div', {
    staticClass: "block block1"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("寄送地址")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "935px"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.addressList), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.receiverName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userPhone))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(item.userAdd))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [(item.haveDefault != 2) ? _c('a', {
      staticClass: "type to_default",
      on: {
        "click": function($event) {
          return _vm.setDefault(item, 1)
        }
      }
    }, [_vm._v("设为默认")]) : _vm._e(), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.haveDefault == 2),
        expression: "item.haveDefault == 2"
      }],
      staticClass: "type default"
    }, [_vm._v("默认地址")]), _vm._v(" "), _c('span', {
      staticClass: "opra",
      on: {
        "click": function($event) {
          return _vm.updateAddress(item)
        }
      }
    }, [_vm._v("修改")]), _vm._v("  |\n                            "), _c('span', {
      staticClass: "opra",
      on: {
        "click": function($event) {
          return _vm.deleteAddress(item, $event)
        }
      }
    }, [_vm._v("删除")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addressList.length < 5),
      expression: "addressList.length < 5"
    }],
    staticClass: "add",
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("新增地址"), _c('i')])]), _vm._v(" "), _c('div', {
    staticClass: "block block2"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("发票信息管理")]), _vm._v(" "), _vm._l((_vm.invoiceList), function(item) {
    return _c('ul', {
      staticClass: "invoice"
    }, [_c('li', [_c('ul', {
      staticClass: "info_ul"
    }, [_c('li', [_c('span', [_vm._v("发票抬头：")]), _vm._v(" " + _vm._s(item.invoiceTitle))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("发票类型：")]), _vm._v(" " + _vm._s(_vm.options._invoiceType[item.invoiceType]))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("纳税人识别号：")]), _vm._v(" " + _vm._s(item.identifyNumber))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("注册电话：")]), _vm._v(" " + _vm._s(item.regPhone))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("开户银行：")]), _vm._v(" " + _vm._s(item.regBank))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("银行号码：")]), _vm._v(" " + _vm._s(item.bankNumber))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("注册地址：")]), _vm._v(" " + _vm._s(item.regAddress))])])]), _vm._v(" "), _c('li', {
      staticClass: "invoice-info"
    }, [_c('a', {
      staticClass: "btn",
      staticStyle: {
        "color": "green"
      },
      on: {
        "click": function($event) {
          return _vm.updateInvoice(item, $event)
        }
      }
    }, [_vm._v("修改")]), _vm._v(" "), _c('a', {
      staticClass: "btn",
      staticStyle: {
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteInvoice(item, $event)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.haveDefault != 2),
        expression: "item.haveDefault != 2"
      }],
      staticClass: "btn mark",
      on: {
        "click": function($event) {
          return _vm.setDefault(item, 2, $event)
        }
      }
    }, [_vm._v("设为默认")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.haveDefault == 2),
        expression: "item.haveDefault == 2"
      }],
      staticClass: "mark"
    }, [_vm._v("默认发票")])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceList.length < 5),
      expression: "invoiceList.length < 5"
    }],
    staticClass: "add",
    staticStyle: {
      "width": "105px"
    },
    on: {
      "click": _vm.addInvoice
    }
  }, [_vm._v("新增发票信息 "), _c('i')])], 2), _vm._v(" "), _c('add-address', {
    ref: "addressCtrl",
    on: {
      "on-success": _vm.getAddressList
    }
  }), _vm._v(" "), _c('add-invoice', {
    ref: "invoceCtrl",
    on: {
      "on-success": _vm.getInvoiceList
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "300px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "200px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "500px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "200px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("收件人姓名")]), _vm._v(" "), _c('td', [_vm._v("电话号码")]), _vm._v(" "), _c('td', [_vm._v("地址")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authentication"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', [_c('div', {
    staticClass: "form_group"
  }, [_c('p', {
    staticStyle: {
      "padding-left": "150px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _c('p', {
    staticClass: "warn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.param.auditName),
      expression: "param.auditName"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.param.auditName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "auditName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('p', {
    staticClass: "warn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('idcard')),
      expression: "errors.has('idcard')"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('idcard')))])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("身份证号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|idcard'),
      expression: "'required|idcard'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.param.auditImgCode),
      expression: "param.auditImgCode"
    }],
    attrs: {
      "type": "text",
      "maxlength": "18",
      "name": "idcard"
    },
    domProps: {
      "value": (_vm.param.auditImgCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "auditImgCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('p', {
    staticClass: "warn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasImg),
      expression: "!hasImg"
    }]
  }, [_vm._v("点击上传")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "choole"
    }
  }, [_vm._v("上传身份证正面图")]), _vm._v(" "), _c('file-upload', {
    ref: "upload",
    attrs: {
      "multiple": false,
      "post-action": _vm.options.url,
      "extensions": _vm.options.extensions
    },
    on: {
      "input-file": _vm.inputFile,
      "input-filter": _vm.inputFilter
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_vm._v("\n                    选择文件\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$refs.upload || !_vm.$refs.upload.active),
      expression: "!$refs.upload || !$refs.upload.active"
    }],
    staticClass: "start",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.upload.active = true
      }
    }
  }, [_vm._v("开始上传")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$refs.upload && _vm.$refs.upload.active),
      expression: "$refs.upload && $refs.upload.active"
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.upload.active = false
      }
    }
  }, [_vm._v("停止上传")]), _vm._v(" "), _c('ul', {
    staticClass: "files"
  }, _vm._l((_vm.files), function(file) {
    return _c('li', [_vm._v(_vm._s(file.name) + "\n                          "), (file.error) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n                              上传错误\n                          ")]) : _vm._e(), _vm._v(" "), (file.success) ? _c('span', {
      staticStyle: {
        "color": "#76D05E"
      }
    }, [_vm._v("\n                              上传成功\n                          ")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("单张图片大小不得超过1024k,宽高限制不超过2000px,允许上传的图片类型：jpg\\gif\\png")]), _vm._v(" "), _vm._l((_vm.files), function(file) {
    return _c('div', {
      staticClass: "thumb"
    }, [_c('img', {
      staticStyle: {
        "max-width": "700px"
      },
      attrs: {
        "src": file.blob,
        "alt": "预览图"
      }
    })])
  }), _vm._v(" "), (_vm.param.auditImgOne && !_vm.upload) ? _c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    staticStyle: {
      "max-width": "700px"
    },
    attrs: {
      "src": _vm._f("imgPath")(_vm.param.auditImgOne),
      "alt": "预览图"
    }
  })]) : _vm._e()], 2)])]), _vm._v(" "), _c('button', {
    staticClass: "submit",
    attrs: {
      "type": "button",
      "disabled": !_vm.enableSubmit
    },
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("提交认证")])])
},staticRenderFns: []}

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center_right right_auth"
  }, [_c('div', {
    staticClass: "center_tag"
  }, [_c('ul', {
    staticClass: "left"
  }, _vm._l(([{
      title: '老师',
      id: 'dubber'
    },
    {
      title: '声音',
      id: 'voice'
    },
    {
      title: '合辑',
      id: 'album'
    } ]), function(nav) {
    return _c('li', [_c('a', {
      class: _vm.type == nav.id ? 'on' : '',
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.changeType(nav.id)
        }
      }
    }, [_vm._v(_vm._s(nav.title))])])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "right"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.waitingSelect),
      expression: "waitingSelect"
    }],
    staticClass: "all",
    class: {
      on: _vm.isSelectedAll
    },
    on: {
      "click": _vm.checkAll
    }
  }, [_vm._v(_vm._s(_vm.isSelectedAll ? "取消全选" : "全选"))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.waitingSelect),
      expression: "waitingSelect"
    }],
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.doDelete()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v("删除")]), _vm._v(" "), _c('button', {
    staticClass: "batch",
    on: {
      "click": function($event) {
        return _vm.typeChange()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.waitingSelect ? "取消" : "批量管理") + "\n        ")])]), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入搜索关键字"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchItem($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "search",
    on: {
      "click": _vm.searchItem
    }
  }, [_vm._v("搜索")])])])]), _vm._v(" "), _c('div', {
    staticClass: "center_content",
    class: {
      'waiting-select': _vm.waitingSelect
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'dubber'),
      expression: "type == 'dubber'"
    }],
    staticClass: "tea-wrap"
  }, [_vm._l((_vm.datas.dubber), function(d) {
    return _c('div', {
      staticClass: "hsktea-recom-wrap lf"
    }, [_c('div', {
      staticClass: "opacity",
      on: {
        "click": function($event) {
          return _vm.selectItem(d)
        }
      }
    }, [_c('i', {
      staticClass: "select",
      class: {
        on: _vm.isSelected(d)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "hsktea-recom-itmes"
    }, [_c('div', {
      staticClass: "recom-items-top"
    }, [_c('div', {
      staticClass: "hsktea-pic"
    }, [_c('a', {
      attrs: {
        "href": '/dubbing/detail/' + d.dubbingId,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgPath(d.dubbingHead)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "hsktea-info"
    }, [_c('a', {
      staticClass: "hsktea-num lf hl",
      attrs: {
        "href": '/dubbing/detail/' + d.dubbingId,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(d.dubbingName))]), _vm._v(" "), _c('p', [_vm._v("交易量：" + _vm._s(d.tranCount))]), _vm._v(" "), _c('p', {
      staticClass: "dis_n"
    }, [_vm._v("已合作老师")])]), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'https://sd235.oss-cn-shanghai.aliyuncs.com/rar/downloads/' +
          d.userNumber +
          '.zip'
      }
    }, [_c('div', {
      staticClass: "hsktea-download",
      attrs: {
        "title": "下载样音包"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "hsktea-price"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [(d.minPrice == 1) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("专题："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("一元配音")])]) : (d.minPrice <= 0) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("专题："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("暂无报价")])]) : (d.minPrice >= 10000) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("专题："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("联系客服")])]) : [_c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("专题:")]), _vm._v(" ￥"), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v(_vm._s(d.minPrice))]), _c('span', {
      domProps: {
        "innerHTML": _vm._s(d.language != '普通话' ? '/百词' : '/分')
      }
    })]], 2), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [(d.adPrice == 1) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("广告："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("一元配音")])]) : (d.adPrice <= 0) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("广告："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("暂无报价")])]) : (d.adPrice >= 10000) ? _c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("广告："), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v("联系客服")])]) : [_c('span', {
      staticClass: "hsktea-price-title"
    }, [_vm._v("广告:")]), _vm._v(" ￥"), _c('span', {
      staticClass: "hsktea-price-num"
    }, [_vm._v(_vm._s(d.adPrice))]), _vm._v("/30秒\n              ")]], 2)]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "collect",
      class: d.hasCollect ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.singleCollect(d)
        }
      }
    }, [(d.hasCollect) ? _c('p', [_vm._v("取消收藏" + _vm._s(d.aa))]) : _c('p', [_vm._v("收藏")])])])])
  }), _vm._v(" "), (_vm.datas.dubber.length == 0) ? _c('div', {
    staticClass: "empty_cop"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("您暂无添加收藏过的老师哦~")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/dubbing"
    }
  }, [_vm._v("去看看 >>")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'voice'),
      expression: "type == 'voice'"
    }],
    staticClass: "sea-voice-wrap"
  }, [_c('ul', _vm._l((_vm.datas.voice), function(d, index) {
    return _c('li', {
      staticClass: "voice-items",
      attrs: {
        "sound-id": d.voiceId,
        "dubber-id": d.dubbingId
      }
    }, [_c('i', {
      staticClass: "select",
      class: {
        on: _vm.isSelected(d)
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(d)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "voice_num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "sea-voice-tit lf"
    }, [_c('a', {
      staticClass: "hl",
      attrs: {
        "href": '/voice/detail/' + d.voiceId,
        "target": "_blank",
        "title": ("" + (d.voiceTitle))
      }
    }, [_vm._v(_vm._s(d.voiceTitle))]), _vm._v(" "), _c('i', {
      staticClass: "pop_video",
      attrs: {
        "data-video": "undefined"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sea-voice-tea lf"
    }, [(d.dubbingType == 1) ? _c('a', {
      staticClass: "hl",
      attrs: {
        "title": d.nameExternal,
        "href": 'dubbing/dateil/' + d.dubbingId,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(d.nameExternal))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "sea-voice-down lf"
    }, [_c('a', {
      attrs: {
        "href": _vm.getOSS() + d.filePath,
        "target": "_blank",
        "download": ".mp3",
        "title": "下载样音"
      }
    }, [_vm._v("下载")]), _vm._v(" "), _c('span', {
      staticClass: "rt"
    }, [_vm._v(_vm._s(_vm._f("toBigCount")(d.downloadCount)))])]), _vm._v(" "), _c('div', {
      staticClass: "playCount lf"
    }, [_c('i'), _vm._v(" "), _c('span', {
      staticClass: "rt"
    }, [_vm._v(_vm._s(_vm._f("toBigCount")(d.playCount)))])]), _vm._v(" "), _c('div', {
      staticClass: "opacity",
      on: {
        "click": function($event) {
          return _vm.selectItem(d)
        }
      }
    })])
  }), 0), _vm._v(" "), (_vm.datas.voice.length == 0) ? _c('div', {
    staticClass: "empty_cop"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("您暂无添加收藏过的声音哦~")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/voice"
    }
  }, [_vm._v("去看看 >>")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == 'album'),
      expression: "type == 'album'"
    }],
    staticClass: "album_area"
  }, [(_vm.datas.album.length == 0) ? _c('div', {
    staticClass: "empty_cop"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("您暂无添加收藏过的合辑哦~")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("去看看 >>")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "album-warp right_content",
    staticStyle: {
      "min-height": "600px"
    }
  }, _vm._l((_vm.datas.album), function(d) {
    return _c('li', {
      staticClass: "album_li"
    }, [_c('i', {
      staticClass: "select",
      class: {
        on: _vm.isSelected(d)
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(d)
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": '/album/detail/' + d.tranSpecialId,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "right_content_color"
    }, [_c('img', {
      attrs: {
        "src": _vm.imgPath(d.specialImgPath),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right_content_text"
    }, [_c('p', {
      staticClass: "content_text_title"
    }, [_vm._v(_vm._s(d.specialName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(d.specialKey))])]), _vm._v(" "), _c('p', {
      staticStyle: {
        "padding-top": "20px",
        "color": "#9b9b9b"
      }
    }, [_vm._v("\n                共" + _vm._s(d.specialCount) + "条\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "opacity",
      on: {
        "click": function($event) {
          return _vm.selectItem(d)
        }
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap",
    staticStyle: {
      "margin": "0 0 80px 10px"
    }
  }, [_c('sd-pager', {
    attrs: {
      "page-data": _vm.curPage
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hsktea-dub kf_btn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("立即配音")]), _vm._v(" "), _c('div', {
    staticClass: "kf_list_wrap"
  }, [_c('div', {
    staticClass: "kf_list"
  }, [_c('div', {
    staticClass: "arrow_top"
  }, [_c('div', {
    staticClass: "arrow_inner"
  })]), _vm._v(" "), _c('ul')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sea-voice-play lf"
  }, [_c('span', {
    staticClass: "sound-play"
  })])
}]}

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleClose),
      expression: "handleClose"
    }],
    staticClass: "w-select"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput),
      expression: "currentInput"
    }],
    ref: "inner-input",
    staticClass: "w-select-inner-input input",
    attrs: {
      "type": "text",
      "placeholder": _vm.currentPlaceholder || _vm.placeholder
    },
    domProps: {
      "value": (_vm.currentInput)
    },
    on: {
      "focus": _vm.onfocus,
      "click": _vm.handleOpen,
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.upEvent($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.downEvent($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterEvent($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentInput = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.nativeValue) ? _c('div', {
    staticClass: "w-select-clear",
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v("x")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdown),
      expression: "showDropdown"
    }],
    staticClass: "w-select-dropdown"
  }, [_vm._l((_vm.suggestion), function(item, index) {
    return _c('div', {
      key: item.value,
      staticClass: "w-select-option",
      class: {
        isHover: _vm.hoverIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.onChange(item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")])
  }), _vm._v(" "), (!_vm.suggestion.length) ? _c('div', {
    staticClass: "w-select__empty"
  }, [_vm._v("无匹配数据")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record-view right_auth"
  }, [_c('div', {
    staticClass: "time"
  }, [_c('label', [_vm._v("订单时间： ")]), _vm._v(" "), _c('sd-select', {
    attrs: {
      "options": _vm.options,
      "open": _vm.open,
      "value": _vm.dateRange
    },
    on: {
      "changeOpen": function($event) {
        _vm.open = !_vm.open
      },
      "changeOption": _vm.changeRange
    }
  })], 1), _vm._v(" "), (_vm.list.length) ? _c('div', [_c('table', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(li) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(li.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("time2")(li.createTime)))]), _vm._v(" "), _c('td', {
      staticClass: "red"
    }, [_vm._v("￥" + _vm._s(li.extractMoney))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap"
  }, [_c('sd-pager', {
    ref: "pager",
    attrs: {
      "page-data": _vm.page
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.list.length) ? _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("没有相关提现记录~")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "col_3"
  }), _vm._v(" "), _c('col', {
    staticClass: "col_3"
  }), _vm._v(" "), _c('col', {
    staticClass: "col_3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("编号")]), _vm._v(" "), _c('td', [_vm._v("提现时间")]), _vm._v(" "), _c('td', [_vm._v("提现金额")])])])
}]}

/***/ }),

/***/ 849:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record-view right_auth"
  }, [_c('div', {
    staticClass: "time"
  }, [_c('label', [_vm._v("订单时间： ")]), _vm._v(" "), _c('sd-select', {
    attrs: {
      "options": _vm.options,
      "open": _vm.open,
      "value": _vm.dateRange
    },
    on: {
      "changeOpen": function($event) {
        _vm.open = !_vm.open
      },
      "changeOption": _vm.changeRange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "invoice-btn"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length),
      expression: "list.length"
    }],
    staticClass: "btn_g primary",
    on: {
      "click": function($event) {
        return _vm.batchInvoice()
      }
    }
  }, [_vm._v("开具发票")]), _vm._v(" "), _c('span', {
    staticClass: "invoice_tag"
  }, [_vm._v("注： ①仅在线支付的订单可开具发票； ②单次开票订单总额不小于300元。")])]), _vm._v(" "), (_vm.list.length) ? _c('div', [_c('table', [_vm._m(0), _vm._v(" "), _c('thead', [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelectedAll),
      expression: "isSelectedAll"
    }],
    attrs: {
      "disabled": !_vm.onlineList.length,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isSelectedAll) ? _vm._i(_vm.isSelectedAll, null) > -1 : (_vm.isSelectedAll)
    },
    on: {
      "click": _vm.selectAll,
      "change": function($event) {
        var $$a = _vm.isSelectedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isSelectedAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isSelectedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isSelectedAll = $$c
        }
      }
    }
  }), _vm._v("全选")]), _vm._v(" "), _c('td', [_vm._v("支付时间")]), _vm._v(" "), _c('td', [_vm._v("实付金额")]), _vm._v(" "), _c('td', [_vm._v("优惠金额")]), _vm._v(" "), _c('td', [_vm._v("支付方式")]), _vm._v(" "), _c('td', [_vm._v("订单号")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(li) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      attrs: {
        "disabled": li.onlinePay != 2,
        "type": "checkbox"
      },
      domProps: {
        "value": li,
        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, li) > -1 : (_vm.selected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = li,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("time")(li.payTime, 'YYYY-MM-DD HH:mm')))]), _vm._v(" "), _c('td', {
      staticClass: "red"
    }, [_vm._v("￥" + _vm._s(li.realityPay))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(li.couponAmount || ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("way")(li.onlinePay)))]), _vm._v(" "), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.orderLineFeed(li.orderNumbers))
      }
    }), _vm._v(" "), (li.invoiceId) ? _c('div', {
      staticClass: "invoiced"
    }) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap"
  }, [_c('sd-pager', {
    ref: "pager",
    attrs: {
      "page-data": _vm.page
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.list.length) ? _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("没有相关支付记录~")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "col_100"
  }), _vm._v(" "), _c('col', {
    staticClass: "col_270"
  }), _vm._v(" "), _c('col', {
    staticClass: "col_100"
  }), _vm._v(" "), _c('col', {
    staticClass: "col_100"
  }), _vm._v(" "), _c('col', {
    staticClass: "col_230"
  }), _vm._v(" "), _c('col', {
    staticClass: "col_370"
  })])
}]}

/***/ }),

/***/ 850:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record-view right_auth"
  }, [_c('div', {
    staticClass: "time"
  }, [_c('label', [_vm._v("订单时间： ")]), _vm._v(" "), _c('sd-select', {
    attrs: {
      "options": _vm.options,
      "open": _vm.open,
      "value": _vm.dateRange
    },
    on: {
      "changeOpen": function($event) {
        _vm.open = !_vm.open
      },
      "changeOption": _vm.changeRange
    }
  })], 1), _vm._v(" "), (_vm.list.length) ? _c('div', [_c('table', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(li) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(li.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("time2")(li.createTime)))]), _vm._v(" "), _c('td', {
      staticClass: "red"
    }, [_vm._v("￥" + _vm._s(li.rechargeAmount))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap"
  }, [_c('sd-pager', {
    ref: "pager",
    attrs: {
      "page-data": _vm.page
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.list.length) ? _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("没有相关充值记录~")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "col_3"
  }), _vm._v(" "), _c('col', {
    staticClass: "col_3"
  }), _vm._v(" "), _c('col', {
    staticClass: "col_3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("编号")]), _vm._v(" "), _c('td', [_vm._v("充值时间")]), _vm._v(" "), _c('td', [_vm._v("充值金额")])])])
}]}

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "header-top-con"
  }, [_c('div', {
    staticClass: "header-top-left left"
  }, [_c('p', {
    staticStyle: {
      "float": "left",
      "margin-right": "15px"
    }
  }, [_vm._v("您好，欢迎来到深度配音")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userInfo.baseId),
      expression: "!userInfo.baseId"
    }],
    staticClass: "left"
  }, [_vm._m(0)]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userInfo.baseId),
      expression: "userInfo.baseId"
    }],
    staticClass: "left"
  }, [_c('li', {
    staticClass: "logined"
  }, [_c('a', {
    staticClass: "user-name",
    attrs: {
      "href": "/center/#/",
      "target": "_blank"
    }
  }, [_vm._v("Hi , " + _vm._s(_vm.userInfo.userPetname || '深度用户'))])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "header-bottom"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "left back"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "{name:'OrderView'}"
    }
  }, [_vm._v("返回主页")])], 1), _vm._v(" "), _c('a', {
    staticClass: "search",
    attrs: {
      "href": '/search/result?oldSearchStr=' + _vm.oldSearchStr,
      "target": "_blank"
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldSearchStr),
      expression: "oldSearchStr"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入关键字搜索"
    },
    domProps: {
      "value": (_vm.oldSearchStr)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toSearchPage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldSearchStr = $event.target.value
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "unlogin showLoginModal on"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "logined"
  }, [_c('a', {
    attrs: {
      "href": "javascript:util.logout()"
    }
  }, [_vm._v("退出登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top-right right"
  }, [_c('a', {
    staticClass: "hb",
    attrs: {
      "href": "http://m.sd235.net",
      "target": "_blank"
    }
  }, [_vm._v("手机版")]), _vm._v(" "), _c('a', {
    staticClass: "hb",
    attrs: {
      "href": "/APP",
      "target": "_blank"
    }
  }, [_vm._v("深度APP")]), _vm._v(" "), _c('a', {
    staticClass: "hb",
    attrs: {
      "href": "/contact_us/contact_us",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('a', {
    staticClass: "hb",
    attrs: {
      "href": "/contact_us/safety-payment",
      "target": "_blank"
    }
  }, [_vm._v("付款账号")]), _vm._v(" "), _c('div', {
    staticClass: "myserve scrollx"
  }, [_c('a', {
    attrs: {
      "href": "/contact_us/company_produce"
    }
  }, [_vm._v("服务中心 "), _c('img', {
    staticClass: "arrow",
    attrs: {
      "src": __webpack_require__(387)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fuwuzhongxin scrolly"
  }, [_c('a', {
    attrs: {
      "href": "/contact_us/company_produce"
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "/contact_us/company_produce",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("关于我们")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "/contact_us/contact_us",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("联系我们")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "/contact_us/teacher-in",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("加入我们")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "/contact_us/safety-payment",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("汇款账号")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "/contact_us/common-problems",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("常见问题")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "/msgrd?V=3&uin=2851207395&Site=深度配音投诉QQ&Menu=yes",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("投诉")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "http://www.sd235.com",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("免费素材")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(388),
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myinvoice-view right_auth"
  }, [_c('div', {
    staticClass: "time"
  }, [_c('label', [_vm._v("订单时间： ")]), _vm._v(" "), _c('sd-select', {
    attrs: {
      "options": _vm.options,
      "open": _vm.open,
      "value": _vm.dateRange
    },
    on: {
      "changeOpen": function($event) {
        _vm.open = !_vm.open
      },
      "changeOption": _vm.changeRange
    }
  })], 1), _vm._v(" "), (_vm.list.length) ? _c('div', [_c('table', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(li) {
    return _c('tr', [_c('td', {
      staticClass: "red"
    }, [_vm._v("￥" + _vm._s(li.customerAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("time2")(li.createTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("invoiceType")(li.invoiceType)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(li.invoiceTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(li.invoiceName))]), _vm._v(" "), (!li.onlinePath) ? _c('td', [_vm._v(_vm._s(_vm._f("invoiceStatus")(li.invoiceStatus)))]) : _c('td', [_c('a', {
      staticClass: "down_pdf",
      attrs: {
        "href": _vm._f("OSS")(li.onlinePath),
        "target": "_blank"
      }
    }, [_vm._v("下载电子票")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap"
  }, [_c('sd-pager', {
    ref: "pager",
    attrs: {
      "page-data": _vm.page
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.list.length) ? _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("没有检测到相关的发票~")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "money_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "time_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "genre_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "head_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "item_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "state_col"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("发票金额")]), _vm._v(" "), _c('td', [_vm._v("申请时间")]), _vm._v(" "), _c('td', [_vm._v("发票类型")]), _vm._v(" "), _c('td', [_vm._v("发票抬头")]), _vm._v(" "), _c('td', [_vm._v("项目名称")]), _vm._v(" "), _c('td', [_vm._v("开票状态")])])])
}]}

/***/ }),

/***/ 853:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-view right_auth"
  }, [_c('div', {
    staticClass: "theme"
  }, [_vm._v("我的消息")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.messages.length) ? _c('div', {
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, _vm._l((_vm.messages), function(me, index) {
    return _c('div', {
      staticClass: "block"
    }, [_c('p', {
      staticClass: "seconds"
    }, [_vm._v(_vm._s(me.createTime))]), _vm._v(" "), _c('div', {
      staticClass: "message"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v("系统消息")]), _vm._v(" "), _c('p', {
      staticClass: "info"
    }, [_vm._v(_vm._s(me.informationInfo))]), _vm._v(" "), _c('i', {
      staticClass: "close",
      on: {
        "click": function($event) {
          return _vm.remove(me.id)
        }
      }
    }), _vm._v(" "), (me.readStatus == 1) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("未读")]) : _c('span', [_vm._v("已读")])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.messages.length) ? _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("没有相关消息~")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap",
    staticStyle: {
      "margin": "0 0 80px 10px"
    }
  }, [_c('sd-pager', {
    attrs: {
      "page-data": _vm.curPage
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 854:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_c('div', {
    staticClass: "aword_alert",
    class: _vm.type || 'select'
  }, [_c('i', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.show = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.defContent))]), _vm._v(" "), (_vm.type == 'select') ? _c('ul', [_c('li', {
    staticClass: "danger",
    on: {
      "click": _vm.affirm
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('li', {
    staticClass: "ghost",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]) : (_vm.type == 'error') ? _c('ul', [_c('li', {
    staticClass: "danger",
    on: {
      "click": _vm.affirm
    }
  }, [_vm._v("确认")])]) : _c('ul', [_c('li', {
    staticClass: "danger",
    on: {
      "click": _vm.affirm
    }
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 855:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),

/***/ 856:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_view right_auth"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('router-link', {
    staticClass: "userInfoLink",
    attrs: {
      "to": {
        name: 'InfoView'
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("查看")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.userInfo.userHead ? (_vm.API.IMG + _vm.userInfo.userHead) : 'http://123.57.173.46:8089/public/2017/08/05/1/upic_0.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "name ellipsis"
  }, [_vm._v(" " + _vm._s(_vm.userInfo.userPetname || '深度用户'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "balance"
  }, [_c('span', [_vm._v("我的钱包")]), _vm._v(" "), _c('router-link', {
    staticClass: "charge",
    attrs: {
      "to": {
        name: 'RechargeView'
      }
    }
  }, [_vm._v("充值")])], 1), _vm._v(" "), _c('div', {
    staticClass: "numbers"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', [_vm._v("¥" + _vm._s(_vm.userInfo.userMoney || 0))]), _vm._v(" "), _c('span', [_vm._v("余额")])]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.discountList ? _vm.userInfo.discountList.length : 0) + "张")]), _vm._v(" "), _c('span', [_vm._v("优惠券")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CouponView'
      }
    }
  }, [_vm._v("查看")])], 1), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', [_vm._v(_vm._s(_vm.collectCount ? _vm.collectCount : 0))]), _vm._v(" "), _c('span', [_vm._v("我的收藏")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CollectView'
      }
    }
  }, [_vm._v("查看")])], 1), _vm._v(" "), _c('div', {
    staticClass: "price integral"
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.integral || 0))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "price grade"
  }, [_c('div', {
    staticClass: "gradeTop"
  }, [_c('span', {
    staticClass: "gradeNum"
  }, [_vm._v(_vm._s(_vm.integralInfo.rank))]), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.integralInfo.name))])]), _vm._v(" "), _c('div', {
    staticClass: "titleWrap clearfix"
  }, [_c('small', [_vm._v("等级")]), _c('div', {
    staticClass: "aside"
  }, [_c('i', [_vm._v("?")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.ruleTable), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.rank))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.grade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))])])
  })], 2)])]), _vm._v(" "), _c('span', {
    staticClass: "bottomWrap"
  }, [_vm._v("距离下一等级还差"), _c('b', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.integralGap))]), _vm._v("积分")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "fl"
  }, [_vm._v("近期订单")]), _vm._v(" "), _c('router-link', {
    staticClass: "rt",
    attrs: {
      "to": {
        name: 'OrderView'
      }
    }
  }, [_vm._v("查看全部订单")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.orderData.length == 0) ? _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("暂无订单信息，快去挑选合适的声音吧 ~")])]) : _vm._e(), _vm._v(" "), (_vm.orderData.length) ? _c('div', [_vm._l((_vm.orderData), function(item) {
    return _c('table', {
      staticClass: "order_tb"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "tr-th"
    }, [_c('td', {
      attrs: {
        "colspan": "8"
      }
    }, [_c('span', {
      staticClass: "dealtime"
    }, [_vm._v("创建时间：" + _vm._s(item.createTime))]), _vm._v(" "), (item.invoiceId) ? _c('div', {
      staticClass: "invoiced"
    }) : _vm._e()])]), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
      staticClass: "blue",
      class: _vm.canDownContribution(item) ? 'down-load' : '',
      attrs: {
        "href": item.realPath || 'javascript:;',
        "target": "_blank",
        "disabled": !item.realPath
      },
      on: {
        "~mouseenter": function($event) {
          return _vm.downContribution(item)
        }
      }
    }, [_vm._v(_vm._s(item.contributionName) + "\n                            ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._options.pressingStatus[item.pressingStatus]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dubboNum))]), _vm._v(" "), _c('td', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.appointPrice))]), _vm._v(" "), _c('td', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.realityPrice))]), _vm._v(" "), _c('td', [_c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ('已需求'),
        expression: "'已需求'"
      }],
      staticClass: "demand on"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'),
        expression: "item.auditionIds?'已有老师试音，查看试音详情请点击右侧‘查看试音’':'尚无老师试音'"
      }],
      staticClass: "demo",
      class: {
        on: item.auditionIds
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.payId ? '已经支付订单费用' : '订单尚未支付'),
        expression: "item.payId?'已经支付订单费用':'订单尚未支付'"
      }],
      staticClass: "pay",
      class: {
        on: item.payId
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ((item.productId || item.voiceLength) ? '已经录制成品' : '尚未录制成品'),
        expression: "(item.productId || item.voiceLength)?'已经录制成品':'尚未录制成品'"
      }],
      staticClass: "finished",
      class: {
        on: item.productId || item.voiceLength
      }
    }), _vm._v(" "), (item.orderStatus == 10) ? _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ('已取消'),
        expression: "'已取消'"
      }],
      staticClass: "canceled"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "operate",
      staticStyle: {
        "border-right": "1px solid #e2e2e2"
      }
    }, [(_vm.canPay(item)) ? _c('button', {
      staticClass: "paybtn",
      on: {
        "click": function($event) {
          return _vm.singlePay(item)
        }
      }
    }, [_vm._v("立即支付")]) : _vm._e(), _vm._v(" "), (_vm.canAudition(item)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.voiceList(item.auditionIds)
        }
      }
    }, [_vm._v("查看试音")]) : _vm._e(), _vm._v(" "), (item.payId) ? _c('router-link', {
      staticClass: "discuss",
      attrs: {
        "to": {
          name: 'Discuss',
          query: {
            id: item.orderNum
          }
        }
      }
    }, [_vm._v(_vm._s(item.dubbingGrade ? '查看评论' : '评价订单'))]) : _vm._e()], 1)])])])
  }), _vm._v(" "), _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewVoice),
      expression: "viewVoice"
    }]
  }, [_c('div', {
    staticClass: "demo_voice"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("您的试音\n                            "), _c('i', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.viewVoice = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.voiceLists), function(vo, index) {
    return _c('li', {
      attrs: {
        "sound-id": vo.id
      }
    }, [_c('a', {
      staticClass: "number",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('a', {
      staticClass: "dubber",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(vo.auditionDubboNum + '号'))]), _vm._v(" "), _c('a', {
      staticClass: "voice",
      attrs: {
        "href": "javascript:;",
        "title": vo.auditionName
      }
    }, [_vm._v(_vm._s(vo.auditionName))]), _vm._v(" "), _c('i', {
      staticClass: "play sound-play"
    })])
  }), 0)])])])], 2) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "clearfix wrap"
  }, [_vm._v("积分"), _c('span', {
    staticClass: "aside"
  }, [_c('i', [_vm._v("?")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("所有注册用户参与评价、点赞、收藏等活动，可获得深度积分。深度配音将不定期推出积分优惠活动，敬请期待！")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col'), _c('col'), _c('col'), _c('col'), _c('col'), _c('col'), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "hd"
  }, [_c('td', [_vm._v("等级")]), _vm._v(" "), _c('td', [_vm._v("积分")]), _vm._v(" "), _c('td', [_vm._v("称号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "name_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "priority_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "teacher_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "pricing_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "pay_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "state_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "operate_col"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tr-br"
  }, [_c('td', [_vm._v("稿件名称")]), _vm._v(" "), _c('td', [_vm._v("紧急")]), _vm._v(" "), _c('td', [_vm._v("选定老师")]), _vm._v(" "), _c('td', [_vm._v("定价")]), _vm._v(" "), _c('td', [_vm._v("实际付款")]), _vm._v(" "), _c('td', [_vm._v("订单状态")]), _vm._v(" "), _c('td', {
    staticClass: "operate",
    staticStyle: {
      "border-right": "1px solid #e2e2e2"
    }
  }, [_vm._v("操作")])])
}]}

/***/ }),

/***/ 857:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sd-header'), _vm._v(" "), _c('div', {
    staticClass: "address-view",
    staticStyle: {
      "width": "1200px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "block block1"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("寄送地址")]), _vm._v(" "), _c('table', [_c('colgroup', {
    staticStyle: {
      "width": "300px"
    }
  }), _vm._v(" "), _c('colgroup', {
    staticStyle: {
      "width": "200px"
    }
  }), _vm._v(" "), _c('colgroup', {
    staticStyle: {
      "width": "500px"
    }
  }), _vm._v(" "), _c('colgroup', {
    staticStyle: {
      "width": "200px"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.addressList), function(item) {
    return _c('tr', {
      class: {
        'on': item.id == _vm.selectAddressId
      },
      on: {
        "click": function($event) {
          return _vm.selectAddress(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.receiverName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userPhone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userAdd))]), _vm._v(" "), _c('td', [(item.haveDefault != 2) ? _c('p', {
      staticClass: "type to_default",
      on: {
        "click": function($event) {
          return _vm.setDefault(item, 1, $event)
        }
      }
    }, [_vm._v("设为默认")]) : _vm._e(), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.haveDefault == 2),
        expression: "item.haveDefault == 2"
      }],
      staticClass: "type default"
    }, [_vm._v("默认地址")]), _vm._v(" "), _c('a', {
      staticClass: "opra",
      on: {
        "click": function($event) {
          return _vm.updateAddress(item, $event)
        }
      }
    }, [_vm._v("修改")]), _vm._v(" |\n                          "), _c('a', {
      staticClass: "opra",
      on: {
        "click": function($event) {
          return _vm.deleteAddress(item, $event)
        }
      }
    }, [_vm._v("删除")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addressList.length <= 5),
      expression: "addressList.length <= 5"
    }],
    staticClass: "add",
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("新增地址"), _c('i')])]), _vm._v(" "), _c('div', {
    staticClass: "block block2"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("发票信息管理")]), _vm._v(" "), _vm._l((_vm.invoiceList), function(item) {
    return _c('ul', {
      staticClass: "invoice",
      class: {
        'on': item.id == _vm.selectInvoiceId
      },
      on: {
        "click": function($event) {
          return _vm.selectInvoice(item, $event)
        }
      }
    }, [_c('li', [_c('ul', {
      staticClass: "info_ul"
    }, [_c('li', [_c('span', [_vm._v("发票抬头：")]), _vm._v(" " + _vm._s(item.invoiceTitle))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("发票类型：")]), _vm._v(" " + _vm._s(_vm.options._invoiceType[item.invoiceType]))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("纳税人识别号：")]), _vm._v(" " + _vm._s(item.identifyNumber))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("注册电话：")]), _vm._v(" " + _vm._s(item.regPhone))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("开户银行：")]), _vm._v(" " + _vm._s(item.regBank))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("银行号码：")]), _vm._v(" " + _vm._s(item.bankNumber))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("注册地址：")]), _vm._v(" " + _vm._s(item.regAddress))])])]), _vm._v(" "), _c('li', {
      staticClass: "invoice-info"
    }, [_c('a', {
      staticClass: "btn mark",
      staticStyle: {
        "color": "#00A0E9"
      },
      on: {
        "click": function($event) {
          return _vm.updateInvoice(item, $event)
        }
      }
    }, [_vm._v("修改")]), _vm._v(" "), _c('a', {
      staticClass: "btn mark",
      staticStyle: {
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteInvoice(item, $event)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.haveDefault != 2),
        expression: "item.haveDefault != 2"
      }],
      staticClass: "btn mark",
      on: {
        "click": function($event) {
          return _vm.setDefault(item, 2, $event)
        }
      }
    }, [_vm._v("设为默认")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.haveDefault == 2),
        expression: "item.haveDefault == 2"
      }],
      staticClass: "mark"
    }, [_vm._v("默认发票")])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceList.length <= 5),
      expression: "invoiceList.length <= 5"
    }],
    staticClass: "add",
    on: {
      "click": _vm.addInvoice
    }
  }, [_vm._v("新增发票 "), _c('i')])], 2), _vm._v(" "), _c('div', {
    staticClass: "remark"
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "margin-right": "200px"
    }
  }, [_vm._v("项目名称："), _c('span', [_vm._v(_vm._s(_vm.invoiceName))])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("发票金额："), _c('span', {
    staticStyle: {
      "color": "#FF0415"
    }
  }, [_vm._v("￥" + _vm._s(_vm.getCustomerAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "first"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("发票备注：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceRemark),
      expression: "invoiceRemark"
    }],
    domProps: {
      "value": (_vm.invoiceRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoiceRemark = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "second"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("其他备注：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherRemark),
      expression: "otherRemark"
    }],
    domProps: {
      "value": (_vm.otherRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherRemark = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "btn"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.submitInvoice(1)
      }
    }
  }, [_vm._v("开纸质发票")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.submitInvoice(2)
      }
    }
  }, [_vm._v("开电子发票")])])]), _vm._v(" "), _c('add-address', {
    ref: "addressCtrl",
    on: {
      "on-success": _vm.getAddressList
    }
  }), _vm._v(" "), _c('add-invoice', {
    ref: "invoceCtrl",
    on: {
      "on-success": _vm.getInvoiceList
    }
  })], 1), _vm._v(" "), _c('sd-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("收件人姓名")]), _vm._v(" "), _c('td', [_vm._v("电话号码")]), _vm._v(" "), _c('td', [_vm._v("地址")]), _vm._v(" "), _c('td', [_vm._v("操作")])])])
}]}

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discussView"
  }, [_c('div', {
    staticClass: "bumenName"
  }, [_vm._v("评价订单")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "order_tb"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "tr-th"
  }, [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('span', {
    staticClass: "dealtime"
  }, [_vm._v("创建时间：" + _vm._s(_vm.orderData.createTime))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    staticClass: "blue",
    class: _vm.canDownContribution(_vm.orderData) ? 'down-load' : '',
    attrs: {
      "href": _vm.orderData.realPath || 'javascript:;',
      "target": "_blank",
      "disabled": !_vm.orderData.realPath
    },
    on: {
      "~mouseenter": function($event) {
        return _vm.downContribution(_vm.orderData)
      }
    }
  }, [_vm._v(_vm._s(_vm.orderData.contributionName))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._options.pressingStatus[_vm.orderData.pressingStatus]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderData.dubboNum))]), _vm._v(" "), _c('td', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.orderData.appointPrice))]), _vm._v(" "), _c('td', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.orderData.realityPrice))]), _vm._v(" "), _c('td', [_c('i', {
    directives: [{
      name: "jq-tips",
      rawName: "v-jq-tips",
      value: ('已需求'),
      expression: "'已需求'"
    }],
    staticClass: "demand on"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "jq-tips",
      rawName: "v-jq-tips",
      value: (_vm.orderData.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'),
      expression: "orderData.auditionIds?'已有老师试音，查看试音详情请点击右侧‘查看试音’':'尚无老师试音'"
    }],
    staticClass: "demo",
    class: {
      on: _vm.orderData.auditionIds
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "jq-tips",
      rawName: "v-jq-tips",
      value: (_vm.orderData.payId ? '已经支付订单费用' : '订单尚未支付'),
      expression: "orderData.payId?'已经支付订单费用':'订单尚未支付'"
    }],
    staticClass: "pay",
    class: {
      on: _vm.orderData.payId
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "jq-tips",
      rawName: "v-jq-tips",
      value: ((_vm.orderData.productId || _vm.orderData.voiceLength) ? '已经录制成品' : '尚未录制成品'),
      expression: "(orderData.productId || orderData.voiceLength)?'已经录制成品':'尚未录制成品'"
    }],
    staticClass: "finished",
    class: {
      on: _vm.orderData.productId || _vm.orderData.voiceLength
    }
  }), _vm._v(" "), (_vm.orderData.orderStatus == 10) ? _c('i', {
    directives: [{
      name: "jq-tips",
      rawName: "v-jq-tips",
      value: ('已取消'),
      expression: "'已取消'"
    }],
    staticClass: "canceled"
  }) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dubbingGrade gradeWrap"
  }, [_c('div', {
    staticClass: "hd clearfix"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("声音水平")]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, _vm._l((5), function(item) {
    return _c('i', {
      staticClass: "iconfont",
      class: [item <= (_vm.dubbingGradeHover || _vm.dubbingGradeData) ? 'icon-shoucang' : 'icon-shoucang1', {
        'on': item == _vm.dubbingGradeData
      }],
      on: {
        "click": function($event) {
          return _vm.gradeFn(1, item)
        },
        "mouseenter": function($event) {
          return _vm.gradeEnter(1, item)
        },
        "mouseleave": function($event) {
          _vm.dubbingGradeHover = 0
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "small",
    domProps: {
      "innerHTML": _vm._s(_vm.dubbingGradeHint ? _vm.dubbingGradeHint : _vm.performance[(_vm.dubbingGradeHover || _vm.dubbingGradeData) - 1])
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_vm._v("声音成品是否满意?")])]), _vm._v(" "), _c('div', {
    staticClass: "serviceGrade gradeWrap"
  }, [_c('div', {
    staticClass: "hd clearfix"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("沟通能力")]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, _vm._l((5), function(item) {
    return _c('i', {
      staticClass: "iconfont",
      class: [item <= (_vm.serviceGradeHover || _vm.serviceGradeData) ? 'icon-shoucang' : 'icon-shoucang1', {
        'on': item == _vm.serviceGradeData
      }],
      on: {
        "click": function($event) {
          return _vm.gradeFn(2, item)
        },
        "mouseenter": function($event) {
          return _vm.gradeEnter(2, item)
        },
        "mouseleave": function($event) {
          _vm.serviceGradeHover = 0
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "small",
    domProps: {
      "innerHTML": _vm._s(_vm.serviceGradeHint ? _vm.serviceGradeHint : _vm.performance[(_vm.serviceGradeHover || _vm.serviceGradeData) - 1])
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_vm._v("服务过程双方沟通是否理解清晰?")])]), _vm._v(" "), _c('div', {
    staticClass: "textarea"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.textareaHint),
      expression: "textareaHint"
    }],
    staticClass: "textareaHint"
  }, [_vm._v(_vm._s(_vm.textareaHint))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textarea),
      expression: "textarea"
    }],
    attrs: {
      "disabled": !_vm.haveComments,
      "placeholder": "评论字数限制在5-200字符"
    },
    domProps: {
      "value": (_vm.textarea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textarea = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wordsNumber",
    class: {
      'warn': _vm.textareaNum > 200
    }
  }, [_vm._v(_vm._s(_vm.textareaNum) + "/200字数")])]), _vm._v(" "), (_vm.haveComments) ? _c('div', {
    staticClass: "submitWrap"
  }, [_c('a', {
    staticClass: "confirm",
    on: {
      "click": function($event) {
        return _vm.submitFn()
      }
    }
  }, [_vm._v("确定")]), _c('router-link', {
    staticClass: "abandon",
    attrs: {
      "to": {
        name: 'OrderView'
      }
    }
  }, [_vm._v("放弃")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "name_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "priority_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "teacher_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "pricing_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "pay_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "state_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "operate_col"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "hd"
  }, [_c('td', [_vm._v("稿件名称")]), _vm._v(" "), _c('td', [_vm._v("紧急")]), _vm._v(" "), _c('td', [_vm._v("选定老师")]), _vm._v(" "), _c('td', [_vm._v("定价")]), _vm._v(" "), _c('td', [_vm._v("实际付款")]), _vm._v(" "), _c('td', [_vm._v("订单状态")]), _vm._v(" "), _c('td')])
}]}

/***/ }),

/***/ 859:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "top": "15%",
      "left": "33%"
    }
  }, [_c('div', {
    staticClass: "form_modal"
  }, [_c('i', {
    staticClass: "close"
  }), _vm._v(" "), _c('p', {
    staticClass: "form_title"
  }, [_vm._v("发票信息")]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('p', {
    staticClass: "error"
  }), _vm._v(" "), _c('label', {
    class: {
      'req': true
    }
  }, [_vm._v("发票类型")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.invoiceType),
      expression: "param.invoiceType"
    }],
    staticClass: "short select",
    staticStyle: {
      "-webkit-appearance": "menulist"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.param, "invoiceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.dirtyAll(false)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("增值税普通发票")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("增值税专用发票")])])]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkInvoiceTitle
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写发票抬头")]), _vm._v(" "), _c('label', {
    class: {
      'req': true
    }
  }, [_vm._v("发票抬头")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.invoiceTitle),
      expression: "param.invoiceTitle"
    }],
    staticClass: "long",
    attrs: {
      "type": "text",
      "maxlength": "42"
    },
    domProps: {
      "value": (_vm.param.invoiceTitle)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.invoiceTitle = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "invoiceTitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkIdentifyNumber
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写纳税人识别号")]), _vm._v(" "), _c('label', {
    class: {
      'req': true
    }
  }, [_vm._v("纳税人识别号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.identifyNumber),
      expression: "param.identifyNumber"
    }],
    staticClass: "long",
    attrs: {
      "type": "text",
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.param.identifyNumber)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.identifyNumber = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "identifyNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkRegAddress
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写注册地址")]), _vm._v(" "), _c('label', {
    class: {
      'req': _vm.isZP
    }
  }, [_vm._v("注册地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.regAddress),
      expression: "param.regAddress"
    }],
    staticClass: "long",
    attrs: {
      "type": "text",
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.param.regAddress)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.regAddress = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "regAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkRegPhone
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写注册电话")]), _vm._v(" "), _c('label', {
    class: {
      'req': _vm.isZP
    }
  }, [_vm._v("注册电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.regPhone),
      expression: "param.regPhone"
    }],
    staticClass: "short",
    attrs: {
      "type": "text",
      "maxlength": "17"
    },
    domProps: {
      "value": (_vm.param.regPhone)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.regPhone = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "regPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkRegBank
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写开户银行名称")]), _vm._v(" "), _c('label', {
    class: {
      'req': _vm.isZP
    }
  }, [_vm._v("开户银行")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.regBank),
      expression: "param.regBank"
    }],
    staticClass: "long",
    attrs: {
      "type": "text",
      "maxlength": "42"
    },
    domProps: {
      "value": (_vm.param.regBank)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.regBank = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "regBank", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkBankNumber
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写银行账号")]), _vm._v(" "), _c('label', {
    class: {
      'req': _vm.isZP
    }
  }, [_vm._v("银行账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.bankNumber),
      expression: "param.bankNumber"
    }],
    staticClass: "long",
    attrs: {
      "type": "text",
      "maxlength": "34"
    },
    domProps: {
      "value": (_vm.param.bankNumber)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.bankNumber = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "bankNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('p', {
    staticClass: "error"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.haveDefault),
      expression: "param.haveDefault"
    }],
    staticStyle: {
      "margin-left": "166px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.param.haveDefault) ? _vm._i(_vm.param.haveDefault, null) > -1 : (_vm.param.haveDefault)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.param.haveDefault,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.param, "haveDefault", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.param, "haveDefault", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.param, "haveDefault", $$c)
        }
      }
    }
  }), _vm._v("设为默认\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "btn"
  }, [(_vm.type == 'add') ? _c('li', {
    on: {
      "click": _vm.addInvoice
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.type == 'update') ? _c('li', {
    on: {
      "click": _vm.updateInvoice
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select2_g right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.label),
      expression: "value.label"
    }],
    class: {
      on: _vm.open
    },
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.value.label)
    },
    on: {
      "click": _vm.changeOpen,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "label", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.open) ? _c('ul', _vm._l((_vm.options), function(vo) {
    return _c('li', {
      class: {
        on: vo.label == _vm.value.label
      },
      on: {
        "click": function($event) {
          return _vm.changeOption(vo)
        }
      }
    }, [_vm._v(_vm._s(vo.label))])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 861:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommend_stat"
  }, [_c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "chead"
  }, [_c('span', {
    staticClass: "left theme"
  }, [_vm._v("一级用户")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "margin": "0 40px"
    }
  }, [_vm._v(_vm._s(_vm.recommendNum.valueFour) + " ( 人 )")]), _vm._v(" "), (_vm.recommendNum.first > 0) ? _c('span', {
    staticClass: "button"
  }, [_vm._v("( 查看全部用户 )")]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "list"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "chead"
  }, [_c('span', {
    staticClass: "left theme"
  }, [_vm._v("二级用户")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "margin": "0 40px"
    }
  }, [_vm._v(_vm._s(_vm.recommendNum.valueFive) + " ( 人 )")]), _vm._v(" "), (_vm.recommendNum.valueFive > 0) ? _c('span', {
    staticClass: "button"
  }, [_vm._v("( 查看全部用户 )")]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "list"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "chead"
  }, [_c('span', {
    staticClass: "left theme"
  }, [_vm._v("返现总额")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "margin": "0 40px"
    }
  }, [_vm._v(_vm._s(_vm.recommendNum.valueOne) + " ( 元 )")])])])]), _vm._v(" "), _c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "chead"
  }, [_c('span', {
    staticClass: "left theme"
  }, [_vm._v("未提现金额")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "margin": "0 40px"
    }
  }, [_vm._v(_vm._s(_vm.recommendNum.valueTwo) + " ( 元 )")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "title"
  }, [_c('p', [_vm._v("客户编号")]), _vm._v(" "), _c('p', [_vm._v("推荐时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("131456789852")]), _vm._v(" "), _c('span', {
    staticClass: "times"
  }, [_vm._v("2018-5-12")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "title"
  }, [_c('p', [_vm._v("客户编号")]), _vm._v(" "), _c('p', [_vm._v("推荐时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("131456789852")]), _vm._v(" "), _c('span', {
    staticClass: "times"
  }, [_vm._v("2018-5-12")])])
}]}

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "sd-player"
  }), _vm._v(" "), _c('sd-confirm', {
    ref: "confirm"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 863:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-view right_auth"
  }, [_c('div', {
    staticClass: "theme"
  }, [_vm._v("\n        修改密码\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "form_modal"
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.remote))]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.old.error))]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("旧密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.old.model),
      expression: "old.model"
    }],
    staticClass: "w200",
    attrs: {
      "input": "text",
      "onfocus": "this.type='password'"
    },
    domProps: {
      "value": (_vm.old.model)
    },
    on: {
      "blur": _vm.required,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.old, "model", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.pwd.error))]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("新密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd.model),
      expression: "pwd.model"
    }],
    staticClass: "w200",
    attrs: {
      "input": "text",
      "onfocus": "this.type='password'"
    },
    domProps: {
      "value": (_vm.pwd.model)
    },
    on: {
      "blur": _vm.password,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pwd, "model", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.certain.error))]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("确认密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certain.model),
      expression: "certain.model"
    }],
    staticClass: "w200",
    attrs: {
      "input": "text",
      "onfocus": "this.type='password'"
    },
    domProps: {
      "value": (_vm.certain.model)
    },
    on: {
      "blur": _vm.confirm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.certain, "model", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "10px",
      "margin-left": "-85px"
    }
  }, [_c('li', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("提交")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 864:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-modal"
  }, [_c('div', {
    staticClass: "modal-shade"
  }), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "modal-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 865:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authentication"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', [_c('div', {
    staticClass: "form_group"
  }, [_c('p', {
    staticStyle: {
      "padding-left": "150px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _c('p', {
    staticClass: "warn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('company')),
      expression: "errors.has('company')"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('company')))])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("公司名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.param.auditName),
      expression: "param.auditName"
    }],
    attrs: {
      "type": "text",
      "name": "company"
    },
    domProps: {
      "value": (_vm.param.auditName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "auditName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("提示：提交的企业名称与个人资料里面的企业名称不一致的话，企业认证将是未绑定的状态")])]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('p', {
    staticClass: "warn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('type')),
      expression: "errors.has('type')"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('type')))])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("证件类型")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.param.auditImgType),
      expression: "param.auditImgType"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.param.auditImgType, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.param, "auditImgType", "3")
      }
    }
  }), _vm._v("组织机构代码证\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.auditImgType),
      expression: "param.auditImgType"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.param.auditImgType, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.param, "auditImgType", "2")
      }
    }
  }), _vm._v("营业执照\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('p', {
    staticClass: "warn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('number')),
      expression: "errors.has('number')"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('number')))])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "number"
    }
  }, [_vm._v("证件号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.param.auditImgCode),
      expression: "param.auditImgCode"
    }],
    attrs: {
      "type": "text",
      "name": "number"
    },
    domProps: {
      "value": (_vm.param.auditImgCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "auditImgCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_group"
  }, [_c('p', {
    staticClass: "warn"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasImg),
      expression: "!hasImg"
    }]
  }, [_vm._v("点击上传")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "choole"
    }
  }, [_vm._v("选择证件图片")]), _vm._v(" "), _c('file-upload', {
    ref: "upload",
    attrs: {
      "multiple": false,
      "extensions": _vm.options.extensions,
      "post-action": _vm.options.url
    },
    on: {
      "input-file": _vm.inputFile,
      "input-filter": _vm.inputFilter
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_vm._v("\n                    选择文件\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$refs.upload || !_vm.$refs.upload.active),
      expression: "!$refs.upload || !$refs.upload.active"
    }],
    staticClass: "start",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.upload.active = true
      }
    }
  }, [_vm._v("开始上传")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$refs.upload && _vm.$refs.upload.active),
      expression: "$refs.upload && $refs.upload.active"
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.upload.active = false
      }
    }
  }, [_vm._v("停止上传")]), _vm._v(" "), _c('ul', {
    staticClass: "files"
  }, _vm._l((_vm.files), function(file) {
    return _c('li', [_vm._v(_vm._s(file.name) + "\n                          "), (file.error) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n                              上传错误\n                          ")]) : _vm._e(), _vm._v(" "), (file.success) ? _c('span', {
      staticStyle: {
        "color": "#76D05E"
      }
    }, [_vm._v("\n                              上传成功\n                          ")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("单张图片大小不得超过1024k,宽高限制不超过2000px,允许上传的图片类型：jpg\\gif\\png")]), _vm._v(" "), _vm._l((_vm.files), function(file) {
    return _c('div', {
      staticClass: "thumb"
    }, [_c('img', {
      staticStyle: {
        "max-width": "700px"
      },
      attrs: {
        "src": file.blob,
        "alt": "缩略图"
      }
    })])
  }), _vm._v(" "), (_vm.param.auditImgOne && !_vm.upload) ? _c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    staticStyle: {
      "max-width": "700px"
    },
    attrs: {
      "src": _vm._f("imgPath")(_vm.param.auditImgOne),
      "alt": "缩略图"
    }
  })]) : _vm._e()], 2)])]), _vm._v(" "), _c('button', {
    staticClass: "submit",
    attrs: {
      "disabled": !_vm.enableSubmit,
      "type": "button"
    },
    on: {
      "click": _vm.validateBeforeSubmit
    }
  }, [_vm._v("提交认证")])])
},staticRenderFns: []}

/***/ }),

/***/ 866:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-view right_auth"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "money"
  }, [_vm._v("余额： "), _c('span', [_vm._v(_vm._s(_vm.remaindAmount))]), _vm._v("元")]), _vm._v(" "), _c('p', {
    staticClass: "remind"
  }, [_vm._v("为了保证您账户的安全，请不要轻易相信他人要您提供账号信息，如有疑问请联系客服")])]), _vm._v(" "), _c('div', {
    staticClass: "right btn"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'RechargeView'
        })
      }
    }
  }, [_vm._v("充值")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "form_modal left"
  }, [_c('i', {
    staticClass: "close"
  }), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.param.ordinaryName
    }
  }, [_c('label', {
    staticClass: "req"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.ordinaryName),
      expression: "param.ordinaryName"
    }],
    staticClass: "short",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.ordinaryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "ordinaryName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v("请填写姓名")])]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.param.userPetname
    }
  }, [_c('label', {
    staticClass: "req"
  }, [_vm._v("昵称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.userPetname),
      expression: "param.userPetname"
    }],
    staticClass: "short",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.userPetname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "userPetname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v("请填写昵称")])]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.param.ordinarySex
    }
  }, [_c('label', {
    staticClass: "req"
  }, [_vm._v("性别")]), _vm._v(" "), _vm._l(([{
    id: 1,
    label: '男'
  }, {
    id: 2,
    label: '女'
  }, {
    id: 3,
    label: '保密'
  }]), function(item) {
    return _c('label', {
      staticClass: "radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.param.ordinarySex),
        expression: "param.ordinarySex"
      }],
      attrs: {
        "type": "radio",
        "name": "sex"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.param.ordinarySex, item.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.param, "ordinarySex", item.id)
        }
      }
    }), _vm._v(" " + _vm._s(item.label) + "\n                ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v("请选择性别")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('label', {}, [_vm._v("兴趣爱好")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.tag),
      expression: "param.tag"
    }],
    staticClass: "long",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "tag", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('label', {}, [_vm._v("地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.ordinaryAddress),
      expression: "param.ordinaryAddress"
    }],
    staticClass: "long",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.ordinaryAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "ordinaryAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('label', {}, [_vm._v("备用联系人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.backupName),
      expression: "param.backupName"
    }],
    staticClass: "long",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.backupName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "backupName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('label', {}, [_vm._v("公司名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.companyName),
      expression: "param.companyName"
    }],
    staticClass: "long",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.param.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('label', {
    staticClass: "req"
  }, [_vm._v("余额短信提示")]), _vm._v(" "), _vm._l(([{
    id: 1,
    label: '开启'
  }, {
    id: 2,
    label: '关闭'
  }]), function(item) {
    return _c('label', {
      staticClass: "radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.param.isSendSMS),
        expression: "param.isSendSMS"
      }],
      attrs: {
        "type": "radio",
        "name": "message"
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.param.isSendSMS, item.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.param, "isSendSMS", item.id)
        }
      }
    }), _vm._v(_vm._s(item.label) + "\n                ")])
  }), _vm._v(" "), _c('p', {
    staticClass: "error"
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setParam()
      }
    }
  }, [_vm._v("重置")])])]), _vm._v(" "), _c('div', {
    staticClass: "avatar"
  }, [_c('p', {
    staticClass: "left",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("头像")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [(_vm.userHead) ? _c('img', {
    attrs: {
      "src": _vm.userHead,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.doUpload
    }
  }, [_vm._v("上传头像")])])]), _vm._v(" "), _c('sd-upload', {
    ref: "upload",
    on: {
      "on-upload": _vm.onUpload
    }
  }), _vm._v(" "), _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recommendSum.sum),
      expression: "recommendSum.sum"
    }]
  }, [_c('div', {
    staticClass: "sum_wrap"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("返利总额: "), _c('span', [_vm._v(_vm._s(_vm.recommendSum.valueOne))]), _vm._v(" 元")]), _vm._v(" "), _c('i', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.recommendSum.sum = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("未处理的钱："), _c('span', [_vm._v(_vm._s(_vm.recommendSum.valueTwo))]), _vm._v("元")]), _vm._v(" "), _c('li', [_vm._v("已处理的钱："), _c('span', [_vm._v(_vm._s(_vm.recommendSum.valueThree))]), _vm._v("元")]), _vm._v(" "), _c('li', [_vm._v("已推荐：" + _vm._s(_vm.recommendSum.valueFour + _vm.recommendSum.valueFive) + "人")])])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sd-header'), _vm._v(" "), _c('div', {
    staticClass: "pay_view"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "section1 block"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("订单详情")]), _vm._v(" "), _c('div', {
    staticClass: "order"
  }, [_c('ul', {
    staticClass: "order_list"
  }, _vm._l((_vm.payOrders), function(item) {
    return _c('li', [_c('ul', {
      staticClass: "order_info"
    }, [_c('li', [_vm._v("订单编号：" + _vm._s(item.orderNum))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.contributionName))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.dubboNum))]), _vm._v(" "), _c('li', {
      staticClass: "red"
    }, [_vm._v("￥" + _vm._s(item.appointPrice))])])])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "all"
  }, [_vm._v("\n            合计： "), _c('span', [_vm._v("￥" + _vm._s(_vm.totalMoney))])])])]), _vm._v(" "), _c('div', {
    staticClass: "section2 block"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("使用优惠券/代金券抵用")]), _vm._v(" "), _c('div', {
    staticClass: "discount"
  }, [_c('ul', {
    staticClass: "choose"
  }, [_c('li', {
    class: {
      on: _vm.discountType == 2
    },
    on: {
      "click": function($event) {
        return _vm.changeDiscountType(2)
      }
    }
  }, [_vm._v("\n              代金券" + _vm._s(_vm.dj.length) + "\n            ")]), _vm._v(" "), _c('li', {
    class: {
      on: _vm.discountType == 1
    },
    on: {
      "click": function($event) {
        return _vm.changeDiscountType(1)
      }
    }
  }, [_vm._v("\n              满减券" + _vm._s(_vm.yh.length) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "cop_wrap"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discountType == 2),
      expression: "discountType == 2"
    }],
    staticClass: "dj"
  }, _vm._l((_vm.dj), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.chooseDiscount(item)
        }
      }
    }, [_c('div', {
      staticClass: "wrap",
      class: {
        on: _vm.selectedDiscount == item
      }
    }, [_c('div', {
      staticClass: "coupon"
    }, [_c('div', {
      staticClass: "money"
    }, [_c('span', {
      staticClass: "big"
    }, [_vm._v(_vm._s(item.discountAmount))]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v("￥")]), _vm._v(" "), _c('p', {
      staticClass: "full"
    }, [_vm._v("无限制")])]), _vm._v(" "), _c('p', {
      staticClass: "type"
    }, [_vm._v("代金券")])])])])
  }), 0), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.discountType == 1),
      expression: "discountType == 1"
    }],
    staticClass: "yh"
  }, _vm._l((_vm.yh), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.chooseDiscount(item)
        }
      }
    }, [_c('div', {
      staticClass: "wrap",
      class: {
        on: _vm.selectedDiscount == item
      }
    }, [_c('div', {
      staticClass: "coupon"
    }, [_c('div', {
      staticClass: "money"
    }, [_c('span', {
      staticClass: "big"
    }, [_vm._v(_vm._s(item.discountAmount))]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v("￥")]), _vm._v(" "), _c('p', {
      staticClass: "full"
    }, [_vm._v("满" + _vm._s(item.discountDoorsill) + "元使用")])]), _vm._v(" "), _c('p', {
      staticClass: "type"
    }, [_vm._v("优惠券")])])])])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "all"
  }, [_vm._v("\n            实付款："), _c('span', [_vm._v("￥" + _vm._s(this.withDiscountMoney))])]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [_c('p', [_vm._v("\n              金额抵用\n              "), _c('span', [_vm._v("￥" + _vm._s(_vm.selectedDiscount.discountAmount || 0))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section4 block"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          当前余额："), _c('span', [_vm._v("￥" + _vm._s(_vm.canUseMount || 0))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canUseMount),
      expression: "canUseMount"
    }]
  }, [_c('p', {
    staticClass: "title left",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_vm._v("使用余额：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remainingMount),
      expression: "remainingMount"
    }],
    ref: "remainingMount",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.remainingMount)
    },
    on: {
      "change": _vm.changeRemainingMount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remainingMount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#9b9b9b",
      "margin-left": "20px"
    }
  }, [_vm._v("请输入您要使用的金额余额，比如：100")])])]), _vm._v(" "), _c('div', {
    staticClass: "section3 block"
  }, [(_vm.onlinePay > 0) ? _c('div', [_c('p', {
    staticClass: "choose"
  }, [_vm._v("请选择以下支付方式")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', [_c('li', {
    directives: [{
      name: "interval",
      rawName: "v-interval"
    }],
    on: {
      "click": function($event) {
        return _vm.submitPay(_vm.payWayLs[1].id)
      }
    }
  }, [_vm._v("微信支付")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "interval",
      rawName: "v-interval"
    }],
    on: {
      "click": function($event) {
        return _vm.submitPay(_vm.payWayLs[0].id)
      }
    }
  }, [_vm._v("支付宝支付")])])]) : _c('button', {
    on: {
      "click": function($event) {
        return _vm.submitPay(13)
      }
    }
  }, [_vm._v("立即支付")]), _vm._v(" "), _c('p', {
    staticClass: "all"
  }, [_vm._v("\n          付款金额： "), _c('span', [_vm._v("￥" + _vm._s(_vm.onlinePay))])])]), _vm._v(" "), _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payStatus),
      expression: "payStatus"
    }],
    attrs: {
      "left": "28%",
      "top": "15%"
    }
  }, [_c('div', {
    staticClass: "pay_way",
    class: {
      pay_zfb: _vm.payChannel == _vm.payWayLs[0].id,
      pay_wx: _vm.payChannel == _vm.payWayLs[1].id,
    }
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.payChannel == _vm.payWayLs[1].id) ? _c('p', {
    staticClass: "way"
  }, [_vm._v("微信支付")]) : _vm._e(), _vm._v(" "), (_vm.payChannel == _vm.payWayLs[0].id) ? _c('p', {
    staticClass: "way"
  }, [_vm._v("支付宝支付")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("订单编号：" + _vm._s(_vm.orderNums))]), _vm._v(" "), _c('i', {
    staticClass: "close",
    on: {
      "click": _vm.cancelPay
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payStatus == 'waiting'),
      expression: "payStatus == 'waiting'"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', {
    staticClass: "money"
  }, [_vm._v("\n                在线付款金额："), _c('span', [_vm._v("￥" + _vm._s(_vm.onlinePay))])]), _vm._v(" "), _c('div', {
    staticClass: "erwm"
  }, [_c('img', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "src": _vm._f("preImgPath")(_vm.QRCode),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.payChannel == _vm.payWayLs[1].id) ? _c('p', {
    staticClass: "erwm_txt"
  }, [_vm._v("\n                  使用微信扫描二维码支付\n                ")]) : _vm._e(), _vm._v(" "), (_vm.payChannel == _vm.payWayLs[0].id) ? _c('p', {
    staticClass: "erwm_txt"
  }, [_vm._v("\n                  使用支付宝扫描二维码支付\n                ")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "remind"
  }, [_vm._v("\n                付款成功请不要关闭此页面，付款后页面没有跳转，请根据您的情况联系客服\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_vm._v("\n                支付遇到问题？ 请联系客服\n                "), _c('div', {
    staticClass: "btn kf_btn"
  }, [_c('div', {
    staticClass: "kf_list_wrap"
  }, [_c('div', {
    staticClass: "kf_list"
  }, [_c('div', {
    staticClass: "arrow_top"
  }, [_c('div', {
    staticClass: "arrow_inner"
  })]), _vm._v(" "), _c('ul')])])]), _vm._v("\n                或拨打电话：136-9946-5470\n              ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payStatus == 'success'),
      expression: "payStatus == 'success'"
    }],
    staticClass: "pay_way"
  }, [_c('div', {
    staticClass: "content_succ"
  }, [_c('div', {
    staticClass: "inner_succ"
  }, [_c('i'), _vm._v(" "), _c('p', {
    staticClass: "wish"
  }, [_vm._v("付款成功！祝您生活愉快！")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', [_vm._v("使用余额："), _c('span', {
    staticStyle: {
      "color": "#fb3509"
    }
  }, [_vm._v("￥" + _vm._s(_vm.remainingMount))])])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', [_vm._v("在线付款："), _c('span', {
    staticStyle: {
      "color": "#fb3509"
    }
  }, [_vm._v("￥" + _vm._s(_vm.onlinePay))])])]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.jump('OrderView')
      }
    }
  }, [_vm._v("返回订单")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/",
      "target": "_blank"
    }
  }, [_vm._v("返回首页")])])]), _vm._v(" "), _c('p', {
    staticClass: "deadline"
  })])])])])])], 1)]), _vm._v(" "), _c('sd-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "deadline"
  }, [_vm._v("\n            选择支付方式后，您有"), _c('span', {
    staticClass: "minute"
  }, [_vm._v("180秒")]), _vm._v("的时间完成付款, 逾期订单自动取消\n          ")])
}]}

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "top": "20%",
      "left": "33%"
    }
  }, [_c('div', {
    staticClass: "form_modal"
  }, [_c('i', {
    staticClass: "close"
  }), _vm._v(" "), _c('p', {
    staticClass: "form_title"
  }, [_vm._v("寄送地址")]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkReceiverName && _vm.dirty.receiverName
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请输入收件人")]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("收件人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.receiverName),
      expression: "param.receiverName"
    }],
    staticClass: "short",
    attrs: {
      "type": "text",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.param.receiverName)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.receiverName = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "receiverName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkUserAdd && _vm.dirty.userAdd
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请输入收件人详细地址")]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.userAdd),
      expression: "param.userAdd"
    }],
    attrs: {
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.param.userAdd)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.userAdd = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "userAdd", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkUserPhone && _vm.dirty.userPhone
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请输入正确的电话号码")]), _vm._v(" "), _c('label', {
    staticClass: "req"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.userPhone),
      expression: "param.userPhone"
    }],
    staticClass: "short",
    staticStyle: {
      "width": "166px"
    },
    attrs: {
      "type": "number",
      "maxlength": "13"
    },
    domProps: {
      "value": (_vm.param.userPhone)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.userPhone = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "userPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('p', {
    staticClass: "error"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.haveDefault),
      expression: "param.haveDefault"
    }],
    staticStyle: {
      "margin-left": "166px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.param.haveDefault) ? _vm._i(_vm.param.haveDefault, null) > -1 : (_vm.param.haveDefault)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.param.haveDefault,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.param, "haveDefault", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.param, "haveDefault", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.param, "haveDefault", $$c)
        }
      }
    }
  }), _vm._v("设为默认\n       ")]), _vm._v(" "), _c('ul', {
    staticClass: "btn"
  }, [(_vm.type == 'add') ? _c('li', {
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.type == 'update') ? _c('li', {
    on: {
      "click": _vm.updateAddress
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "header-top-con"
  }, [_c('div', {
    staticClass: "header-top-left left"
  }, [_c('p', {
    staticStyle: {
      "float": "left",
      "margin": "0 15px"
    }
  }, [_vm._v("您好，欢迎来到深度配音")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userInfo.baseId),
      expression: "!userInfo.baseId"
    }],
    staticClass: "left"
  }, [_vm._m(0)]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userInfo.baseId),
      expression: "userInfo.baseId"
    }],
    staticClass: "left"
  }, [_c('li', {
    staticClass: "logined"
  }, [_c('a', {
    staticClass: "user-name",
    attrs: {
      "href": "http://i.sd235.net",
      "target": "_blank"
    }
  }, [_vm._v("Hi , " + _vm._s(_vm.userInfo.userPetname || '深度用户'))])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "header-bottom"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._m(3), _vm._v(" "), _c('router-link', {
    staticClass: "title",
    attrs: {
      "to": "{name:'OrderView'}"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('a', {
    staticClass: "search",
    attrs: {
      "href": '/search/result?oldSearchStr=' + _vm.oldSearchStr,
      "target": "_blank"
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldSearchStr),
      expression: "oldSearchStr"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入关键字搜索"
    },
    domProps: {
      "value": (_vm.oldSearchStr)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toSearchPage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldSearchStr = $event.target.value
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "unlogin showLoginModal on"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "logined"
  }, [_c('a', {
    attrs: {
      "href": "javascript:util.logout()"
    }
  }, [_vm._v("退出登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top-right right"
  }, [_c('a', {
    staticClass: "hb",
    attrs: {
      "href": "http://old.sd235.net",
      "target": "_blank"
    }
  }, [_vm._v("返回旧版")]), _vm._v(" "), _c('a', {
    staticClass: "hb",
    attrs: {
      "href": "http://m.sd235.net",
      "target": "_blank"
    }
  }, [_vm._v("手机版")]), _vm._v(" "), _c('a', {
    staticClass: "hb",
    attrs: {
      "href": "/APP",
      "target": "_blank"
    }
  }, [_vm._v("深度APP")]), _vm._v(" "), _c('a', {
    staticClass: "hb",
    attrs: {
      "href": "/contact_us/contact_us",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('a', {
    staticClass: "hb",
    attrs: {
      "href": "/contact_us/safety-payment",
      "target": "_blank"
    }
  }, [_vm._v("付款账号")]), _vm._v(" "), _c('div', {
    staticClass: "myserve scrollx"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sd235.net/contact_us/company_produce"
    }
  }, [_vm._v("服务中心 "), _c('img', {
    staticClass: "arrow",
    attrs: {
      "src": __webpack_require__(387)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fuwuzhongxin scrolly"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sd235.net/contact_us/company_produce"
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "http://www.sd235.net/contact_us/company_produce",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("关于我们")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "http://www.sd235.net/contact_us/contact_us",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("联系我们")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "http://www.sd235.net/contact_us/teacher-in",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("加入我们")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "http://www.sd235.net/contact_us/safety-payment",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("汇款账号")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "http://www.sd235.net/contact_us/common-problems",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("常见问题")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "http://wpa.qq.com/msgrd?V=3&uin=2851207395&Site=深度配音投诉QQ&Menu=yes",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("投诉")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "padding": "0",
      "border": "none"
    },
    attrs: {
      "href": "http://www.sd235.com",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("免费素材")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(388),
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 870:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sd-header'), _vm._v(" "), _c('div', {
    staticClass: "center_wrap"
  }, [_c('div', {
    staticClass: "side_menu"
  }, _vm._l((_vm.pageGroup), function(group) {
    return _c('ul', {
      staticClass: "side_ul"
    }, _vm._l((group), function(page) {
      return _c('li', [(page.name) ? _c('router-link', {
        class: {
          on: _vm.$route.name == page.name
        },
        attrs: {
          "to": {
            name: page.name
          }
        }
      }, [_vm._v(_vm._s(page.title) + "\n            "), (page.amount && _vm.amount != 0) ? _c('span', [_vm._v("( " + _vm._s(_vm.amount) + " )")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!page.name) ? _c('a', {
        staticClass: "title"
      }, [_vm._v(_vm._s(page.title))]) : _vm._e()], 1)
    }), 0)
  }), 0)]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('sd-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('input', {
    ref: "upload",
    attrs: {
      "id": "upload-img"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 872:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rebate_intro right_auth"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "left chain"
  }, [_vm._v("推荐注册链接："), _c('span', {
    attrs: {
      "id": "clip"
    }
  }, [_vm._v("http://www.sd235.net/reset/register.html?vcode=" + _vm._s(_vm.vcode))])]), _vm._v(" "), _c('button', {
    ref: "copy",
    attrs: {
      "data-clipboard-target": "#clip"
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制链接")]), _vm._v(" "), (_vm.wxCode) ? _c('img', {
    attrs: {
      "src": _vm.API.PRE + _vm.wxCode,
      "alt": "二维码"
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("推荐返利活动")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("推荐返利规则")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "flag"
  }, [_vm._v("注明：本规则会定期更新，本规则解释权归深度配音所有")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "content"
  }, [_c('li', [_vm._v("1.深度配音为促进老客户带动新客户的业务增长，即日起开展暂推荐返利活动！")]), _vm._v(" "), _c('li', [_vm._v("2.只要老客户使用平台专用的推荐注册链接，引导新客户注册，并产生业务，即可获取返利！")]), _vm._v(" "), _c('li', [_vm._v("3.多推荐多得，一级推荐和二级推荐都有返利，即A推荐B,B再推荐C,A也可从C的业务获取返利！")]), _vm._v(" "), _c('li', [_vm._v("4.具体规则细则见下。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "content"
  }, [_c('li', [_vm._v("1. 必须访问推荐人的推荐链接或二维码，并注册成功，才能参与返利。")]), _vm._v(" "), _c('li', [_vm._v("2. 推荐人是老用户推荐其他人成功交易，并且单笔订单利润大于零，即可获得被推荐人一定比例返利。")]), _vm._v(" "), _c('li', [_vm._v("3. 返利大于100元时可提现，提现请联系客服。")])])
}]}

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "recharge-view right_auth"
  }, [_c('div', {
    staticClass: "theme"
  }, [_vm._v("在线充值")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticClass: "account"
  }, [_vm._v("\n        充值账户：" + _vm._s(_vm.userInfo.userPhone || _vm.userInfo.userPetname || _vm.userInfo.userNumber) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "money"
  }, [_vm._v("\n        充值金额："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.money),
      expression: "money"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.money)
    },
    on: {
      "change": _vm.changeMoney,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.money = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("请输入您要充值的金额，比如500")])])]), _vm._v(" "), _c('div', {
    staticClass: "way"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("请选择支付方式")]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.submitPay(_vm.payWayLs[1].id)
      }
    }
  }, [_vm._v("微信支付")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.submitPay(_vm.payWayLs[0].id)
      }
    }
  }, [_vm._v("支付宝支付")])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payStatus),
      expression: "payStatus"
    }]
  }, [_c('div', {
    staticClass: "pay_way",
    class: {
      pay_wx: _vm.payChannel == _vm.payWayLs[1].id,
      pay_zfb: _vm.payChannel == _vm.payWayLs[0].id,
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "close",
    on: {
      "click": _vm.cancelPay
    }
  }), _vm._v(" "), (_vm.payChannel == _vm.payWayLs[1].id) ? _c('p', {
    staticClass: "way"
  }, [_vm._v("微信支付")]) : _c('p', {
    staticClass: "way"
  }, [_vm._v("支付宝支付")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payStatus == 'waiting'),
      expression: "payStatus == 'waiting'"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', {
    staticClass: "money"
  }, [_vm._v("\n            付款金额："), _c('span', [_vm._v("￥" + _vm._s(_vm.money))])]), _vm._v(" "), _c('div', {
    staticClass: "erwm"
  }, [_c('img', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "src": _vm._f("preImgPath")(_vm.QRCode),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.payChannel == _vm.payWayLs[1].id) ? _c('p', {
    staticClass: "erwm_txt"
  }, [_vm._v("\n              使用微信扫描二维码支付\n            ")]) : _c('p', {
    staticClass: "erwm_txt"
  }, [_vm._v("使用支付宝扫描二维码支付")])]), _vm._v(" "), _c('p', {
    staticClass: "remind"
  }, [_vm._v("\n            付款成功请不要关闭此页面，付款后页面没有跳转，请根据您的情况联系客服\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_vm._v("\n            支付遇到问题？ 请联系客服\n            "), _c('div', {
    staticClass: "btn kf_btn"
  }, [_c('div', {
    staticClass: "kf_list_wrap"
  }, [_c('div', {
    staticClass: "kf_list"
  }, [_c('div', {
    staticClass: "arrow_top"
  }, [_c('div', {
    staticClass: "arrow_inner"
  })]), _vm._v(" "), _c('ul')])])]), _vm._v("\n            或拨打电话：136-9946-5470\n          ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payStatus == 'success'),
      expression: "payStatus == 'success'"
    }],
    staticClass: "pay_way"
  }, [_c('div', {
    staticClass: "content_succ"
  }, [_c('div', {
    staticClass: "inner_succ"
  }, [_c('i'), _vm._v(" "), _c('p', {
    staticClass: "wish"
  }, [_vm._v("付款成功！祝您生活愉快！")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', [_vm._v("在线付款："), _c('span', {
    staticStyle: {
      "color": "#fb3509"
    }
  }, [_vm._v("￥" + _vm._s(_vm.money))])])]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.jump('OrderView')
      }
    }
  }, [_vm._v("返回订单")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.jump('OrderView')
      }
    }
  }, [_vm._v("返回首页")])]), _vm._v(" "), _c('p', {
    staticClass: "deadline"
  })])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remind clearfix"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n          1、充值成功后，余额可能存在延迟现象，\n          一般1到5分钟内到账，如有问题，请咨询客服; "), _c('i')]), _vm._v(" "), _c('li', [_vm._v("2、充值金额输入值必须是不小于1且不大于50000的正整数;")]), _vm._v(" "), _c('li', [_vm._v("\n          3、您支付宝和微信进行充值，如果遇到任何支付问题可以查看在线客服帮助;\n        ")]), _vm._v(" "), _c('li', [_vm._v("4、充值完成后，您可以进入账户记录页面进行查看余额充值状态。")]), _vm._v(" "), _c('li', [_vm._v("5.充值金额不可退还。")]), _vm._v(" "), _c('li', [_vm._v("本方案解释权归深度配音所有。")])])])
}]}

/***/ }),

/***/ 874:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-view right_auth"
  }, [_c('div', {
    staticClass: "top_dd"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "cell cell3 left"
  }, [_c('span', [_vm._v("订单时间：")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "270px"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateValue),
      callback: function($$v) {
        _vm.dateValue = $$v
      },
      expression: "dateValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cell cell2 left"
  }, [_c('span', [_vm._v("金额范围：")]), _vm._v(" "), _c('div', {
    staticClass: "range right"
  }, [_c('div', {
    staticClass: "empty"
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.clearPrice()
      }
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.doSearch()
      }
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOrder.appointPriceBegin),
      expression: "searchOrder.appointPriceBegin"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchOrder.appointPriceBegin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchOrder, "appointPriceBegin", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOrder.appointPriceEnd),
      expression: "searchOrder.appointPriceEnd"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchOrder.appointPriceEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchOrder, "appointPriceEnd", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cell cell1 right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOrder.numberType),
      expression: "searchOrder.numberType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchOrder, "numberType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("老师编号")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("订单编号")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOrder.numberStr),
      expression: "searchOrder.numberStr"
    }],
    staticClass: "right",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchOrder.numberStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchOrder, "numberStr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('ul', [_c('li', [_c('button', {
    staticClass: "btn_g alert",
    on: {
      "click": function($event) {
        return _vm.doSearch()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn_g primary",
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v("重置")])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "order_classify"
  }, [_vm._l((_vm.options.customerOrderType), function(item, idx) {
    return _c('li', {
      key: idx,
      class: item.id == _vm.searchOrder.customerOrderType ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.changeStatus(item.id)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")])
  }), _vm._v(" "), _c('li', {
    staticClass: "help",
    on: {
      "click": _vm.help
    }
  }, [_vm._v("下单帮助")])], 2), _vm._v(" "), _c('div', {
    staticClass: "bottom_dd"
  }, [_c('div', {
    staticClass: "function"
  }, [_c('ul', {
    staticClass: "left"
  }, [_c('li', [_c('button', {
    staticClass: "btn_g active",
    on: {
      "click": function($event) {
        return _vm.creatOrder()
      }
    }
  }, [_vm._v("新建订单")])]), _vm._v(" "), (_vm.orderData.length) ? _c('li', [_c('button', {
    staticClass: "btn_g primary",
    on: {
      "click": function($event) {
        return _vm.batchPay()
      }
    }
  }, [_vm._v("批量支付")])]) : _vm._e()]), _vm._v(" "), (_vm.orderData.length) ? _c('ul', {
    staticClass: "right"
  }, [_c('li', [_c('button', {
    staticClass: "btn_g primary",
    attrs: {
      "disabled": this.pageInfo.pageNo <= 1
    },
    on: {
      "click": function($event) {
        return _vm.prePage()
      }
    }
  }, [_vm._v("上一页")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('button', {
    staticClass: "btn_g primary",
    attrs: {
      "disabled": this.pageInfo.pageNo >= this.pageInfo.totalPage
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_vm._v("\n            下一页\n          ")])])]) : _vm._e()]), _vm._v(" "), (_vm.orderData.length) ? _c('div', [_c('div', {
    staticClass: "title_dd"
  }, [_c('ul', [_c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelectedAll),
      expression: "isSelectedAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isSelectedAll) ? _vm._i(_vm.isSelectedAll, null) > -1 : (_vm.isSelectedAll)
    },
    on: {
      "click": _vm.selectAll,
      "change": function($event) {
        var $$a = _vm.isSelectedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isSelectedAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isSelectedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isSelectedAll = $$c
        }
      }
    }
  }), _vm._v("稿件名称")]), _vm._v(" "), _c('li', [_vm._v("选定老师")]), _vm._v(" "), _c('li', [_vm._v("定价")]), _vm._v(" "), _c('li', [_vm._v("实际付款")]), _vm._v(" "), _c('li', [_vm._v("订单状态")]), _vm._v(" "), _c('li', [_vm._v("操作")])])]), _vm._v(" "), _vm._l((_vm.orderData), function(item, idx) {
    return _c('table', {
      key: idx,
      staticClass: "order_tb"
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "tr-th"
    }, [_c('td', {
      attrs: {
        "colspan": "8"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, item) > -1 : (_vm.selected)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dealtime"
    }, [_vm._v(_vm._s(item.createTime))]), _vm._v(" "), (item.invoiceId) ? _c('div', {
      staticClass: "invoiced"
    }) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
      staticClass: "blue",
      class: _vm.canDownContribution(item) ? 'down-load' : '',
      attrs: {
        "href": item.realPath || 'javascript:;',
        "target": "_blank",
        "disabled": !item.realPath
      },
      on: {
        "~mouseenter": function($event) {
          return _vm.downContribution(item)
        }
      }
    }, [_vm._v(_vm._s(item.contributionName) + "\n              ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dubboNum))]), _vm._v(" "), _c('td', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.appointPrice))]), _vm._v(" "), _c('td', {
      staticClass: "red"
    }, [_vm._v(_vm._s(item.realityPrice))]), _vm._v(" "), _c('td', [_c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ('已需求'),
        expression: "'已需求'"
      }],
      staticClass: "demand on"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'),
        expression: "item.auditionIds ? '已有老师试音，查看试音详情请点击右侧‘查看试音’' : '尚无老师试音'"
      }],
      staticClass: "demo",
      class: {
        on: item.auditionIds
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.payId ? '已经支付订单费用' : '订单尚未支付'),
        expression: "item.payId ? '已经支付订单费用' : '订单尚未支付'"
      }],
      staticClass: "pay",
      class: {
        on: item.payId
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: (item.productId || item.voiceLength ? '已经录制成品' : '尚未录制成品'),
        expression: "item.productId || item.voiceLength ? '已经录制成品' : '尚未录制成品'"
      }],
      staticClass: "finished",
      class: {
        on: item.productId || item.voiceLength
      }
    }), _vm._v(" "), (item.orderStatus == 10) ? _c('i', {
      directives: [{
        name: "jq-tips",
        rawName: "v-jq-tips",
        value: ('已取消'),
        expression: "'已取消'"
      }],
      staticClass: "canceled"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "operate",
      staticStyle: {
        "border-right": "1px solid #e2e2e2"
      }
    }, [(_vm.canPay(item)) ? _c('button', {
      staticClass: "paybtn",
      on: {
        "click": function($event) {
          return _vm.singlePay(item)
        }
      }
    }, [_vm._v("立即支付")]) : _vm._e(), _vm._v(" "), (_vm.canAudition(item)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.voiceList(item.auditionIds)
        }
      }
    }, [_vm._v("查看试音")]) : _vm._e(), _vm._v(" "), (item.payId) ? _c('router-link', {
      staticClass: "discuss",
      attrs: {
        "to": {
          name: 'Discuss',
          query: {
            id: item.orderNum
          }
        }
      }
    }, [_vm._v(_vm._s(item.dubbingGrade ? '查看评论' : '评价订单'))]) : _vm._e()], 1)])])])
  }), _vm._v(" "), (_vm.summation.show) ? _c('div', {
    staticClass: "summation"
  }, [_c('p', [_vm._v("\n          合计实付金额： "), _c('span', [_vm._v(_vm._s(_vm.summation.num))]), _vm._v("元\n        ")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "btn_ul"
  }, [_c('li', [_c('button', {
    staticClass: "btn_g ghost",
    on: {
      "click": function($event) {
        return _vm.getStatistics()
      }
    }
  }, [_vm._v("查看合计")])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn_g ghost",
    on: {
      "click": function($event) {
        return _vm.getExcel()
      }
    }
  }, [_vm._v("导出本页表格")])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn_g ghost",
    on: {
      "click": _vm.getAllExcel
    }
  }, [_vm._v("导出所有表格")])])]), _vm._v(" "), _c('div', {
    staticClass: "page_wrap"
  }, [_c('sd-pager', {
    ref: "pager",
    attrs: {
      "page-data": _vm.pageInfo
    },
    on: {
      "page-change": _vm.pageChange
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.orderData.length) ? _c('div', {
    staticClass: "g_empty"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("没有检测到相关的订单~")])]) : _vm._e()]), _vm._v(" "), _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewVoice),
      expression: "viewVoice"
    }]
  }, [_c('div', {
    staticClass: "demo_voice"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        您的试音\n        "), _c('i', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.viewVoice = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.voiceLists), function(vo, index) {
    return _c('li', {
      key: index,
      attrs: {
        "sound-id": vo.id
      }
    }, [_c('a', {
      staticClass: "number",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('a', {
      staticClass: "dubber",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(vo.auditionDubboNum + '号'))]), _vm._v(" "), _c('a', {
      staticClass: "voice",
      attrs: {
        "href": "javascript:;",
        "title": vo.auditionName
      }
    }, [_vm._v(_vm._s(vo.auditionName))]), _vm._v(" "), _c('i', {
      staticClass: "play sound-play"
    })])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "viki_modal"
  }, [_c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.forHelp),
      expression: "forHelp"
    }]
  }, [_c('div', {
    staticClass: "viki"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.orderViki.first) ? _c('div', {
    staticClass: "first"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.orderViki.first = false;
        _vm.orderViki.second = true;
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.orderViki.second) ? _c('div', {
    staticClass: "second"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.orderViki.second = false;
        _vm.orderViki.third = true;
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.orderViki.third) ? _c('div', {
    staticClass: "third"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.orderViki.third = false;
        _vm.forHelp = false;
      }
    }
  })]) : _vm._e()])], 1)])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "name_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "teacher_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "pricing_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "pay_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "state_col"
  }), _vm._v(" "), _c('col', {
    staticClass: "operate_col"
  })])
}]}

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    attrs: {
      "disabled": _vm.pageData.pageNo == 1
    },
    on: {
      "click": function($event) {
        return _vm.prePage()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("上一页")])]), _vm._v(" "), _vm._l((_vm.pages), function(index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.pageData.pageNo == index
      },
      on: {
        "click": function($event) {
          return _vm.toPage(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(index))])])
  }), _vm._v(" "), _c('li', {
    attrs: {
      "disabled": _vm.pageData.totalPage == _vm.pageData.pageNo || (_vm.pageData.totalPage <= 1)
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("下一页")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("共" + _vm._s(_vm.pageData.totalPage) + "页")])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(860),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 880:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auth", function() { return fn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);




var $showLoginModal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.showLoginModal');
var $close;

var $userTitle;

var $userQQ;
var $yzmImg;
var $yzmString;
var $submitBtn;
var random = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.arc4random(10000);
var yzmUrl = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].api('IMGVERIFYCODE');
var REGISTER = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].api('REGISTBYQQ');
var checkqq = "a";
var checkyzm = "a";

var $loginQQ;
var $loginPwd;
var $loginBtn;
var random = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.arc4random(10000);
var yzmUrl = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].api('IMGVERIFYCODE');
var LOGIN = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].api('LOGIN');
var checkloginpwd = "a";
var checkloginqq = "a";

var $forgetPwd;
var FINDPASSBYMAIL = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].api('FINDPASSBYMAIL');

var $boundPhone;
var checkphone = "a";
var $yzmBtn;
var REGISTVERIFYCODE = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].api('REGISTVERIFYCODE');
var BOUNDPHONE = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].api('BOUNDPHONE');
var fn = {
    variables: {
        registQQ: checkqq,
        yzm: checkyzm,
        loginQQ: checkloginqq,
        pwd: checkloginpwd
    },
    showModal: function showModal() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('close');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('pop', ' <div class="user_modal">\n                <div class="user_title">\n                  <span class="user_title_login on">\u767B\u5F55</span>\n                  <span class="user_title_regist">\u6CE8\u518C</span>\n                  <i></i>\n                </div>\n                <div class="user_content">\n                  <div class="login tag on">\n                    <p class="error_login_qq warn"></p>\n                    <input class="long_input mb28 loginQQ" type="text" name="username" placeholder="\u8BF7\u8F93\u5165\u60A8\u7684QQ\u53F7">\n                    <p class="error_login_pwd warn top100"></p>\n                    <input class="long_input mb20 loginPwd" type="password" name="password" placeholder="\u8BF7\u8F93\u5165\u5BC6\u7801">\n                    <div class="checkbox mb20">\n                      <input class="remember" type="checkbox"> <span>\u8BB0\u4F4F\u8D26\u53F7</span>\n                    </div>\n                    <button class="loginBtn">\u767B\u5F55</button>\n                    <ul>\n                      <li>\n                        <a href="javascript:;" class="forgetPwd">\n                          <div class="dot"></div> \u8001\u5BA2\u6237\u7D22\u5BC6\n                          <div class="tips">\n                               \u8001\u5BA2\u6237\u662F\u5728\u6DF1\u5EA6\u4EA4\u6613\u8FC7\u7684\u8001\u5BA2\u6237\uFF0C\u8001\u5BA2\u6237\u65E0\u9700\u6CE8\u518C\uFF0C\u7D22\u5BC6\u540E\u767B\u5F55\n                               <div class="arrow">\n                                    <div class="arrow_in"></div>\n                               </div>\n                          </div>\n                        </a>\n                        <span>|</span>\n                      </li>\n                      <li class="forget_title">\n                        <a href="javascript:;">\u5FD8\u8BB0\u5BC6\u7801\uFF1F</a>\n                      </li>\n                    </ul>\n                  </div>\n                  <div class="regist tag">\n                    <p class="warn error_user_qq"></p>\n                    <input class="long_input mb28 userQQ" type="text" name="username" placeholder="\u8BF7\u8F93\u5165\u60A8\u7684QQ\u53F7">\n                     <p class="warn error_yzm top100"></p>\n                    <input class="short_input yzmString" type="text" name="username" placeholder="\u8F93\u5165\u53F3\u8FB9\u9A8C\u8BC1\u7801">\n                    <div class="yzm yzmImg">\n                      <img src="" alt="">\n                    </div>\n                    <button class="registButton submitBtn">\u4E00\u952E\u6CE8\u518C</button>\n                    <p class="toLogin">\u8001\u5BA2\u6237\u767B\u5F55</p>\n                  </div>\n            </div>\n            </div>');

        fn.tab();
        $close = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_title').find('i');
        $close.click(function () {
            fn.closeModal();
        });

        fn.checkQQ();
        fn.checkYzm();

        $submitBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.submitBtn');
        $submitBtn.on('click', function () {
            if (checkqq == true && checkyzm == true) {
                fn.postRegister();
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_user_qq').html('<i></i>\u8BF7\u8F93\u5165\u76F8\u5173\u5185\u5BB9');
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.toLogin').click(function () {
            fn.initYzmImg();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_title_regist').removeClass('on');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_title_login').addClass('on');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_content .regist').removeClass('on');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_content .login').addClass('on');
        });

        fn.checkLoginQQ();
        fn.checkPwd();

        $loginBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.loginBtn');
        $loginBtn.on('click', function () {
            if (checkloginqq && checkloginpwd) {
                fn.postLogin();
            }
            if (checkloginqq == "a" && checkloginpwd == "a") {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_login_qq').html('<i></i>\u8BF7\u8F93\u5165\u76F8\u5173\u5185\u5BB9');
            }
        });

        $forgetPwd = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.forgetPwd');
        $forgetPwd.on('click', function () {
            fn.findPwd();
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.forget_title').click(function () {
            fn.findPwd('忘记密码');
        });

        $yzmImg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.yzmImg');
        $yzmImg.click(function () {
            fn.freshYzm();
        });
    },
    closeModal: function closeModal() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('close');
    },
    tab: function tab() {
        $userTitle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_title');
        $userTitle.find('span').click(function () {
            fn.freshYzm();
            $userTitle.find('span').removeClass('on');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('on');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_content>div').removeClass('on');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_content>div').eq(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('on').index()).addClass('on');
        });
    },

    initYzmImg: function initYzmImg() {
        var src = yzmUrl + '?' + random;
        $yzmImg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.yzmImg img');
        $yzmImg.attr('src', src);
    },
    freshYzm: function freshYzm() {
        random = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.arc4random(10000);
        fn.initYzmImg();
    },
    checkQQ: function checkQQ() {
        $userQQ = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.userQQ');
        $userQQ.on('blur', function () {
            var qq = $userQQ.val();
            if (qq == "") {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_user_qq').html('<i></i>\u8BF7\u8F93\u5165QQ\u53F7\u7801');
                $userQQ.addClass('shadow');
                checkqq = false;
                return;
            } else if (!/^[1-9]([0-9]{5,11})$/.test(qq)) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_user_qq').html('<i></i>\u8BF7\u8F93\u5165\u6B63\u786E\u7684QQ\u53F7\u7801');
                $userQQ.addClass('shadow');
                checkqq = false;
                return;
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_user_qq').html('');
                $userQQ.removeClass('shadow');
                checkqq = true;
            }
            fn.variables.registQQ = checkqq;
        });
    },
    checkYzm: function checkYzm() {
        $yzmString = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.yzmString');
        $yzmString.on('blur', function () {
            var yzmString = $yzmString.val();
            if (yzmString == "") {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_yzm').html("<i></i>请输入验证码");
                $yzmString.addClass('shadow');
                checkyzm = false;
                return;
            } else if (!/^[0-9A-Za-z]{4}$/.test(yzmString)) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_yzm').html("<i></i>请输入正确的验证码");
                $yzmString.addClass('shadow');
                checkyzm = false;
                return;
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_yzm').html('');
                $yzmString.removeClass('shadow');
                checkyzm = true;
            }
            fn.variables.yzm = checkyzm;
        });
    },
    checkLoginQQ: function checkLoginQQ() {
        $loginQQ = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.loginQQ');
        $loginQQ.on('blur', function () {
            var qq = $loginQQ.val();
            if (qq == "") {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_login_qq').html('<i></i>\u8BF7\u8F93\u5165QQ\u53F7\u7801');
                $loginQQ.addClass('shadow');
                return;
            } else if (!/^[1-9]([0-9]{5,11})$/.test(qq)) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_login_qq').html('<i></i>\u8BF7\u8F93\u5165\u6B63\u786E\u7684QQ\u53F7\u7801');
                $loginQQ.addClass('shadow');
                return;
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_login_qq').html('');
                $loginQQ.removeClass('shadow');
                checkloginqq = true;
            }
            fn.variables.loginQQ = checkloginqq;
        });
    },
    checkPwd: function checkPwd() {
        $loginPwd = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.loginPwd');
        $loginPwd.on('blur', function () {
            var pwd = $loginPwd.val();
            if (pwd == "") {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_login_pwd').html('<i></i>\u5BC6\u7801\u4E0D\u80FD\u4E3A\u7A7A');
                $loginPwd.addClass('shadow');
                checkloginpwd = false;
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_login_pwd').html('');
                $loginPwd.removeClass('shadow');
                checkloginpwd = true;
            }
            fn.variables.pwd = checkloginpwd;
        });
    },
    checkPhone: function checkPhone() {
        $boundPhone = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.boundPhone');
        $boundPhone.on('blur', function () {
            var phone = $boundPhone.val();
            if (phone == "") {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_phone').html('<i></i>\u624B\u673A\u53F7\u7801\u4E0D\u80FD\u4E3A\u7A7A');
                $boundPhone.addClass('shadow');
                checkphone = false;
            } else if (!/^1(3|5|4|7|8)\d{9}$/.test(phone)) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_phone').html('<i></i>\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7\u7801');
                $boundPhone.addClass('shadow');
                checkphone = false;
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_phone').html('');
                $boundPhone.removeClass('shadow');
                checkphone = true;
            }
        });
    },
    checkCode: function checkCode() {
        $yzmString = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.yzmString');
        $yzmString.on('blur', function () {
            var yzmString = $yzmString.val();
            if (yzmString == "") {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_yzm').html("<i></i>请输入验证码");
                $yzmString.addClass('shadow');
                checkyzm = false;
                return;
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_yzm').html('');
                $yzmString.removeClass('shadow');
                checkyzm = true;
            }
            fn.variables.yzm = checkyzm;
        });
    },
    findPwd: function findPwd(a) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('close');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('pop', '<div class="user_modal">\n                <div class="user_title">\n                    <p>\u8001\u5BA2\u6237\u7D22\u5BC6</p>\n                    <i></i>\n                  </div>\n                  <div class="user_content suomi">\n                    <p class="warn error_user_qq"></p>\n                    <input class="long_input mb28 userQQ" type="text" name="username" placeholder="\u8BF7\u8F93\u5165\u60A8\u7684QQ\u53F7">\n                    <p class="warn error_yzm top100"></p>\n                    <input class="short_input yzmString" type="text" placeholder="\u8F93\u5165\u53F3\u8FB9\u9A8C\u8BC1\u7801">\n                    <div class="yzm yzmImg">\n                      <img src="" alt="">\n                    </div>\n                    <button class="submitBtn">\u63D0\u4EA4</button>\n                    <div class="alert">\n                      \u5BC6\u7801\u5DF2\u53D1\u9001\u5230\u4F60\u7684QQ\u90AE\u7BB1\uFF0C\u8BF7\u6CE8\u610F\u67E5\u6536\u3002\u767B\u5F55\u540E\u53EF\u8FDB\u884C\u4FEE\u6539\u3002\n                    </div>\n                    <p class="back">\u8FD4\u56DE\u767B\u5F55</p>\n                 </div>   \n            </div>');

        if (a) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_title p').html('忘记密码');
        }
        fn.freshYzm();

        $close = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_title i');
        $close.click(function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('close');
        });

        $yzmImg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.yzmImg');
        $yzmImg.click(function () {
            fn.freshYzm();
        });

        fn.checkQQ();
        fn.checkYzm();

        $submitBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.submitBtn');
        $submitBtn.click(function () {
            if (checkqq && checkyzm) {
                fn.postFindPwd();
            }
            if (checkqq == "a" && checkyzm == "a") {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_user_qq').html('<i></i>\u8BF7\u8F93\u5165\u76F8\u5173\u5185\u5BB9');
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back').click(function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('close');
            fn.showModal();
        });
    },
    boundPhone: function boundPhone() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('pop', '<div class="user_modal" style="height: 485px;">\n              <div class="user_title">\n                <p>\u7ED1\u5B9A\u624B\u673A</p>\n                <i></i>\n              </div>\n              <div class="user_content bound">\n                <p class="remind">\u6839\u636E\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u8981\u6C42\uFF0C\u4F7F\u7528\u4FE1\u606F\u53D1\u5E03\u3001\u5373\u65F6\u901A\u8BAF\u7B49\u4E92\u8054\u7F51\u670D\u52A1\u9700\u8981\u8FDB\u884C\u8EAB\u4EFD\u4FE1\u606F\u9A8C\u8BC1\u3002\u4E3A\u4FDD\u969C\u60A8\u7684\u4F7F\u7528\u4F53\u9A8C\n                   \u5EFA\u8BAE\u60A8\u5C3D\u5FEB\u5B8C\u6210\u624B\u673A\u53F7\u7ED1\u5B9A\u9A8C\u8BC1\uFF0C\u611F\u8C22\u60A8\u7684\u652F\u6301\u548C\u7406\u89E3\u3002\n                </p>\n                <p class="warn error_phone"></p>\n                <input class="long_input mb28 boundPhone" type="text" name="username" placeholder="\u8BF7\u8F93\u5165\u60A8\u7684\u624B\u673A\u53F7\u7801">\n                <p class="warn error_yzm top100"></p>\n                <input class="short_input mb28 yzmString" type="text" name="username" placeholder="\u8F93\u5165\u9A8C\u8BC1\u7801">\n                <div class="yzmBtn">\n                  \u53D1\u9001\u9A8C\u8BC1\u7801\n                </div>\n                <button class="boundPhoneBtn">\u786E\u8BA4</button>\n                <div class="alert">\n                  \u5BC6\u7801\u5DF2\u53D1\u9001\u5230\u4F60\u7684QQ\u90AE\u7BB1\uFF0C\u8BF7\u6CE8\u610F\u67E5\u6536\u3002\u767B\u5F55\u540E\u53EF\u8FDB\u884C\u4FEE\u6539\u3002\n                </div>\n              </div>\n            </div>');
        fn.checkPhone();
        fn.checkCode();

        $yzmBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.yzmBtn');
        $yzmBtn.click(function () {
            if (checkphone == true) {
                fn.postCode();
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_phone').html('<i></i>请输入正确的手机号码');
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.boundPhoneBtn').click(function () {
            if (checkphone && checkyzm) {
                fn.postBoundPhone();
            }
            if (checkphone == "a" && checkyzm == "a") {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_phone').html('<i></i>\u8BF7\u8F93\u5165\u76F8\u5173\u5185\u5BB9');
            }
        });

        $close = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_title i');
        $close.click(function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('close');
            location.reload();
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sd_modal').click(function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('close');
            location.reload();
        });
    },
    countDown: function countDown() {
        var countdown = 60;
        function settime() {
            if (countdown == 0) {
                $yzmBtn.attr("disabled", true);
                $yzmBtn.html("获取验证码");
                countdown = 60;
            } else {
                $yzmBtn.attr("disabled", 'disabled');
                $yzmBtn.html(countdown + 's\u91CD\u65B0\u53D1\u9001');
                countdown--;
            }
        }
        setTimeout(function () {
            settime();
        }, 1000);
    },
    getRequestParam: function getRequestParam() {
        var theRequest = {};
        var str = document.location.search.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
        return theRequest;
    },

    postRegister: function postRegister() {
        var vcode = fn.getRequestParam();
        var params = {
            userQq: $userQQ.val(),
            verifyCode: $yzmString.val()
        };
        if (vcode.vcode) {
            if (vcode.vcode.length == 32) {
                vcode.vcode && (params.recommendCode = vcode.vcode);
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_user_qq').html('<i></i>\u9080\u8BF7\u94FE\u63A5\u6709\u8BEF');
                return;
            }
        }
        __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].kAjax(REGISTER, params, function (res) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_user_qq').html('<i></i>\u8BF7\u70B9\u51FB<a href="http://www.mail.qq.com"\n                                        style="color:red;text-decoration: underline;" target="_blank">\u524D\u5F80\u90AE\u7BB1</a>\u5B8C\u6210\u6CE8\u518C');
            fn.freshYzm();
            $yzmString.val(' ');
        }, function (res) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_user_qq').html('<i></i>' + res);
            fn.freshYzm();
            $yzmString.val(' ');
        });
    },
    postLogin: function postLogin() {
        var params = {
            userName: $loginQQ.val(),
            userPass: $loginPwd.val(),
            loginType: 1
        };

        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.remember')[0].checked) {
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].cookie.set('loginName', params.userName);
        } else {
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].cookie.delete('loginName');
        }

        __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].kAjax(LOGIN, params, function (res) {

            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].cookie.set('NSESSIONID', res.data.sessionId);

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_login_qq').html('<i class="ok"></i>\u767B\u5F55\u6210\u529F');
            if (res.data.userPhone) {

                setTimeout(function () {
                    location.reload();
                }, 500);
            } else {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal('close');
                fn.boundPhone();
            }

            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].cookie.set('userName', res.data.userPetname || '深度会员');
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].cookie.set('userHead', res.data.userHead);
            __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].setCollectCookie(res.data.collectMap);
        }, function (res) {
            console.log(res);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_login_qq').html('<i></i>' + res);
        }, true);
    },
    postFindPwd: function postFindPwd(fun) {
        var params = {
            userQq: $userQQ.val(),
            verifyCode: $yzmString.val()
        };
        __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].kAjax(FINDPASSBYMAIL, params, function (res) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.alert').addClass('on');
            fun && fun(true);
            fn.freshYzm();
        }, function (res) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_user_qq').html('<i></i>' + res);
            fn.freshYzm();
        });
    },
    postCode: function postCode() {
        var param = {
            phone: $boundPhone.val()
        };
        __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].kAjax(REGISTVERIFYCODE, param, function (res) {}, function (res) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_phone').html('<i></i>' + res);
        });
    },
    postBoundPhone: function postBoundPhone() {
        var params = {
            phone: $boundPhone.val(),
            verifyCode: $yzmString.val()
        };
        __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].kAjax(BOUNDPHONE, params, function (res) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_phone').html('<i class="ok"></i>\u7ED1\u5B9A\u6210\u529F');
            setTimeout(function () {
                location.reload();
            }, 500);
        }, function (res) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.error_phone').html('<i></i>' + res);
        });
    },
    register: {
        bind: function bind() {
            fn.initYzmImg();
            fn.checkQQ();
            fn.freshYzm();
            fn.checkYzm();
            fn.checkPwd();
            fn.checkLoginQQ();
            fn.tab();

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', '.showLoginModal', function () {
                fn.pop_login();
            });

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.showRegModal').on('click', function () {
                fn.pop_reg();
            });
        }
    },
    pop_login: function pop_login() {
        fn.showModal();
        fn.check();
    },
    pop_reg: function pop_reg() {
        fn.pop_login();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.user_title_regist').trigger('click');
    },
    check: function check() {
        var loginName = __WEBPACK_IMPORTED_MODULE_1__util__["a" /* util */].cookie.get('loginName');
        if (loginName) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.loginQQ').val(loginName);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.checkbox.mb20 input')[0].checked = true;
        }
    }
};



/***/ })

},[453]);


// WEBPACK FOOTER //
// static/js/app.e70759df7f94ae1ece97.js